export const WORLD_MAP_COUNTRIES = {
  title: 'World, Robinson projection, medium resolution',
  version: '2.0.1',
  type: 'FeatureCollection',
  copyright: 'Copyright (c) 2022 Highsoft AS, Based on data from Natural Earth',
  copyrightShort: 'Natural Earth',
  copyrightUrl: 'http://www.naturalearthdata.com',
  crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:EPSG:54030' } },
  features: [
    {
      type: 'Feature',
      id: 'FO',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.48,
        'hc-middle-y': 0.51,
        'hc-key': 'fo',
        'hc-a2': 'FO',
        name: 'Faroe Islands',
        labelrank: '6',
        'country-abbrev': 'Faeroe Is.',
        subregion: 'Northern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'FRO',
        'iso-a2': 'FO',
        'woe-id': '23424816',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3829, 9225],
            [3836, 9225],
            [3831, 9218],
            [3819, 9226],
            [3829, 9225],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'US',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.66,
        'hc-middle-y': 0.69,
        'hc-key': 'us',
        'hc-a2': 'US',
        name: 'United States of America',
        labelrank: '2',
        'country-abbrev': 'U.S.A.',
        subregion: 'Northern America',
        'region-wb': 'North America',
        'iso-a3': 'USA',
        'iso-a2': 'US',
        'woe-id': '23424977',
        continent: 'North America',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [374, 9014],
              [357, 9011],
              [377, 9027],
              [388, 9026],
              [391, 9012],
              [382, 8983],
              [370, 8968],
              [363, 8978],
              [348, 8970],
              [350, 8999],
              [363, 9000],
              [374, 9014],
            ],
          ],
          [
            [
              [398, 8990],
              [394, 8992],
              [430, 9012],
              [428, 9002],
              [399, 8976],
              [398, 8990],
            ],
          ],
          [
            [
              [-342, 9166],
              [-344, 9152],
              [-367, 9147],
              [-386, 9153],
              [-342, 9166],
            ],
          ],
          [
            [
              [352, 9057],
              [368, 9068],
              [373, 9058],
              [362, 9040],
              [342, 9022],
              [352, 9057],
            ],
          ],
          [
            [
              [-303, 9266],
              [-286, 9264],
              [-326, 9252],
              [-325, 9263],
              [-356, 9271],
              [-309, 9277],
              [-303, 9266],
            ],
          ],
          [
            [
              [-98, 9086],
              [-59, 9100],
              [-60, 9089],
              [-92, 9081],
              [-74, 9081],
              [-92, 9064],
              [-165, 9045],
              [-162, 9060],
              [-139, 9072],
              [-98, 9086],
            ],
          ],
          [
            [
              [348, 9078],
              [356, 9087],
              [380, 9093],
              [395, 9085],
              [380, 9066],
              [364, 9075],
              [353, 9062],
              [348, 9078],
            ],
          ],
          [
            [
              [842, 7936],
              [844, 7950],
              [837, 7954],
              [840, 7974],
              [822, 7999],
              [817, 8031],
              [809, 8043],
              [806, 8046],
              [802, 8050],
              [800, 8055],
              [773, 8060],
              [759, 8054],
              [737, 8026],
              [712, 8039],
              [700, 8052],
              [699, 8084],
              [661, 8129],
              [608, 8129],
              [603, 8113],
              [513, 8113],
              [410, 8156],
              [416, 8164],
              [338, 8157],
              [340, 8179],
              [324, 8203],
              [318, 8201],
              [304, 8168],
              [299, 8176],
              [317, 8206],
              [295, 8218],
              [275, 8215],
              [279, 8227],
              [257, 8234],
              [266, 8255],
              [254, 8275],
              [247, 8310],
              [257, 8318],
              [245, 8330],
              [251, 8355],
              [258, 8343],
              [257, 8368],
              [251, 8356],
              [234, 8398],
              [247, 8432],
              [242, 8452],
              [272, 8488],
              [286, 8538],
              [311, 8564],
              [363, 8637],
              [391, 8683],
              [388, 8688],
              [399, 8735],
              [409, 8742],
              [419, 8735],
              [456, 8732],
              [450, 8710],
              [468, 8728],
              [467, 8740],
              [453, 8747],
              [476, 8765],
              [1269, 8765],
              [1284, 8776],
              [1279, 8758],
              [1333, 8748],
              [1336, 8737],
              [1347, 8741],
              [1360, 8730],
              [1413, 8728],
              [1363, 8710],
              [1320, 8685],
              [1322, 8681],
              [1366, 8689],
              [1364, 8677],
              [1399, 8687],
              [1441, 8708],
              [1455, 8706],
              [1434, 8690],
              [1450, 8686],
              [1453, 8674],
              [1475, 8673],
              [1491, 8681],
              [1528, 8684],
              [1521, 8675],
              [1536, 8672],
              [1548, 8675],
              [1546, 8668],
              [1539, 8663],
              [1556, 8653],
              [1525, 8658],
              [1520, 8650],
              [1500, 8659],
              [1494, 8631],
              [1524, 8649],
              [1548, 8632],
              [1545, 8606],
              [1538, 8592],
              [1518, 8580],
              [1518, 8566],
              [1536, 8580],
              [1552, 8578],
              [1547, 8545],
              [1539, 8532],
              [1534, 8528],
              [1530, 8532],
              [1518, 8520],
              [1517, 8519],
              [1517, 8519],
              [1498, 8498],
              [1522, 8486],
              [1549, 8491],
              [1638, 8529],
              [1650, 8542],
              [1648, 8545],
              [1648, 8548],
              [1649, 8551],
              [1651, 8554],
              [1680, 8559],
              [1696, 8554],
              [1721, 8557],
              [1740, 8565],
              [1749, 8589],
              [1760, 8594],
              [1764, 8598],
              [1784, 8611],
              [1802, 8616],
              [1802, 8616],
              [1818, 8619],
              [1897, 8620],
              [1944, 8652],
              [1962, 8681],
              [1994, 8709],
              [2001, 8699],
              [2019, 8705],
              [2031, 8695],
              [2015, 8647],
              [2018, 8642],
              [2024, 8641],
              [2019, 8629],
              [2027, 8626],
              [2028, 8610],
              [1998, 8600],
              [1971, 8584],
              [1965, 8592],
              [1947, 8579],
              [1904, 8555],
              [1892, 8541],
              [1895, 8531],
              [1878, 8520],
              [1887, 8502],
              [1903, 8497],
              [1874, 8488],
              [1856, 8489],
              [1836, 8481],
              [1809, 8481],
              [1788, 8470],
              [1828, 8472],
              [1804, 8463],
              [1759, 8454],
              [1766, 8450],
              [1746, 8418],
              [1726, 8401],
              [1709, 8419],
              [1715, 8393],
              [1712, 8379],
              [1697, 8359],
              [1675, 8339],
              [1689, 8362],
              [1675, 8381],
              [1684, 8385],
              [1680, 8410],
              [1667, 8377],
              [1670, 8360],
              [1652, 8322],
              [1667, 8323],
              [1662, 8274],
              [1643, 8263],
              [1646, 8252],
              [1628, 8235],
              [1611, 8237],
              [1584, 8220],
              [1576, 8206],
              [1558, 8207],
              [1532, 8182],
              [1468, 8140],
              [1444, 8106],
              [1438, 8091],
              [1437, 8055],
              [1448, 8011],
              [1444, 8000],
              [1454, 7945],
              [1445, 7911],
              [1434, 7886],
              [1410, 7882],
              [1408, 7904],
              [1393, 7918],
              [1373, 7971],
              [1386, 7982],
              [1373, 7985],
              [1386, 8022],
              [1362, 8061],
              [1352, 8067],
              [1318, 8049],
              [1287, 8082],
              [1239, 8073],
              [1203, 8079],
              [1167, 8050],
              [1182, 8040],
              [1181, 8026],
              [1158, 8043],
              [1147, 8030],
              [1132, 8029],
              [1109, 8054],
              [1085, 8046],
              [1060, 8055],
              [1030, 8051],
              [974, 8018],
              [917, 7992],
              [924, 7990],
              [905, 7960],
              [903, 7913],
              [869, 7917],
              [842, 7936],
            ],
          ],
          [
            [
              [468, 8765],
              [466, 8764],
              [466, 8765],
              [468, 8765],
            ],
          ],
          [
            [
              [411, 9034],
              [379, 9030],
              [383, 9038],
              [360, 9017],
              [359, 9027],
              [379, 9047],
              [392, 9052],
              [412, 9047],
              [413, 9044],
              [420, 9086],
              [412, 9091],
              [417, 9086],
              [398, 9060],
              [371, 9049],
              [385, 9060],
              [406, 9097],
              [411, 9092],
              [424, 9129],
              [398, 9092],
              [367, 9098],
              [355, 9092],
              [342, 9105],
              [341, 9121],
              [315, 9137],
              [333, 9149],
              [301, 9142],
              [258, 9156],
              [224, 9152],
              [208, 9163],
              [184, 9169],
              [198, 9181],
              [172, 9186],
              [143, 9180],
              [125, 9152],
              [113, 9145],
              [80, 9152],
              [35, 9133],
              [-0, 9127],
              [-13, 9129],
              [19, 9139],
              [7, 9145],
              [35, 9160],
              [54, 9176],
              [94, 9188],
              [120, 9182],
              [100, 9197],
              [63, 9187],
              [4, 9160],
              [-11, 9149],
              [-47, 9140],
              [-82, 9119],
              [-63, 9116],
              [-90, 9105],
              [-122, 9087],
              [-143, 9085],
              [-180, 9068],
              [-186, 9069],
              [-223, 9048],
              [-280, 9034],
              [-282, 9025],
              [-342, 9009],
              [-354, 9009],
              [-408, 8983],
              [-396, 8997],
              [-439, 8984],
              [-486, 8973],
              [-486, 8962],
              [-491, 8971],
              [-545, 8958],
              [-519, 8975],
              [-486, 8981],
              [-486, 8975],
              [-477, 8983],
              [-406, 9010],
              [-365, 9009],
              [-352, 9024],
              [-292, 9044],
              [-233, 9069],
              [-198, 9096],
              [-165, 9114],
              [-204, 9105],
              [-207, 9111],
              [-235, 9098],
              [-230, 9115],
              [-244, 9110],
              [-244, 9121],
              [-278, 9103],
              [-302, 9103],
              [-282, 9126],
              [-263, 9135],
              [-255, 9156],
              [-301, 9146],
              [-318, 9171],
              [-287, 9181],
              [-274, 9172],
              [-257, 9178],
              [-283, 9182],
              [-296, 9204],
              [-268, 9216],
              [-260, 9224],
              [-216, 9241],
              [-188, 9258],
              [-171, 9262],
              [-153, 9256],
              [-114, 9270],
              [-86, 9270],
              [-66, 9278],
              [-49, 9295],
              [-54, 9301],
              [-29, 9308],
              [-27, 9318],
              [-97, 9300],
              [-101, 9305],
              [-143, 9302],
              [-166, 9306],
              [-161, 9325],
              [-134, 9329],
              [-161, 9333],
              [-167, 9342],
              [-86, 9362],
              [-44, 9370],
              [-17, 9372],
              [-39, 9355],
              [1, 9352],
              [34, 9360],
              [31, 9367],
              [31, 9367],
              [31, 9367],
              [45, 9364],
              [66, 9370],
              [56, 9374],
              [35, 9370],
              [49, 9386],
              [5, 9388],
              [17, 9404],
              [-11, 9428],
              [23, 9444],
              [71, 9446],
              [119, 9460],
              [144, 9474],
              [194, 9490],
              [203, 9488],
              [251, 9498],
              [267, 9504],
              [312, 9506],
              [356, 9520],
              [388, 9515],
              [387, 9505],
              [423, 9508],
              [441, 9506],
              [432, 9493],
              [506, 9495],
              [534, 9485],
              [564, 9485],
              [586, 9479],
              [622, 9483],
              [658, 9469],
              [574, 9400],
              [486, 9324],
              [395, 9242],
              [312, 9163],
              [333, 9159],
              [363, 9164],
              [351, 9155],
              [364, 9126],
              [358, 9115],
              [388, 9124],
              [409, 9139],
              [439, 9145],
              [436, 9128],
              [448, 9098],
              [440, 9035],
              [465, 9018],
              [461, 9011],
              [443, 8989],
              [436, 8985],
              [421, 8976],
              [419, 8975],
              [403, 8972],
              [411, 8986],
              [431, 9004],
              [431, 9013],
              [414, 9010],
              [396, 8997],
              [404, 9013],
              [392, 9026],
              [410, 9026],
              [411, 9034],
            ],
          ],
          [
            [
              [29, 9370],
              [31, 9367],
              [31, 9367],
              [31, 9367],
              [28, 9367],
              [29, 9370],
              [29, 9370],
            ],
          ],
          [
            [
              [29, 9370],
              [22, 9381],
              [33, 9383],
              [29, 9370],
              [29, 9370],
            ],
          ],
          [
            [
              [-656, 8924],
              [-649, 8925],
              [-649, 8924],
              [-651, 8923],
              [-656, 8924],
              [-656, 8924],
            ],
          ],
          [
            [
              [-656, 8924],
              [-667, 8922],
              [-717, 8904],
              [-678, 8925],
              [-656, 8924],
              [-656, 8924],
            ],
          ],
          [
            [
              [-888, 8882],
              [-862, 8877],
              [-838, 8885],
              [-858, 8876],
              [-951, 8873],
              [-953, 8867],
              [-984, 8859],
              [-999, 8864],
              [-983, 8870],
              [-975, 8865],
              [-945, 8877],
              [-918, 8874],
              [-888, 8882],
            ],
          ],
          [
            [
              [-649, 8925],
              [-630, 8939],
              [-591, 8948],
              [-626, 8928],
              [-649, 8925],
              [-649, 8925],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'JP',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.69,
        'hc-middle-y': 0.63,
        'hc-key': 'jp',
        'hc-a2': 'JP',
        name: 'Japan',
        labelrank: '2',
        'country-abbrev': 'Japan',
        subregion: 'Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'JPN',
        'iso-a2': 'JP',
        'woe-id': '23424856',
        continent: 'Asia',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [8193, 8223],
              [8195, 8184],
              [8176, 8195],
              [8164, 8188],
              [8164, 8170],
              [8152, 8165],
              [8144, 8183],
              [8133, 8192],
              [8142, 8217],
              [8151, 8210],
              [8179, 8233],
              [8177, 8224],
              [8193, 8223],
            ],
          ],
          [
            [
              [8131, 8088],
              [8117, 8101],
              [8117, 8113],
              [8100, 8110],
              [8098, 8124],
              [8083, 8131],
              [8094, 8156],
              [8080, 8145],
              [8076, 8167],
              [8054, 8182],
              [8046, 8181],
              [8039, 8162],
              [8030, 8161],
              [8048, 8189],
              [8046, 8203],
              [8025, 8216],
              [8048, 8206],
              [8048, 8189],
              [8058, 8187],
              [8070, 8207],
              [8082, 8208],
              [8093, 8198],
              [8109, 8200],
              [8132, 8173],
              [8128, 8157],
              [8134, 8114],
              [8125, 8105],
              [8136, 8077],
              [8121, 8072],
              [8131, 8088],
            ],
          ],
          [
            [
              [8265, 8478],
              [8278, 8460],
              [8310, 8436],
              [8326, 8405],
              [8320, 8401],
              [8323, 8379],
              [8317, 8370],
              [8334, 8340],
              [8341, 8298],
              [8361, 8277],
              [8351, 8271],
              [8355, 8257],
              [8346, 8246],
              [8335, 8262],
              [8316, 8259],
              [8314, 8236],
              [8307, 8254],
              [8292, 8237],
              [8253, 8240],
              [8246, 8235],
              [8261, 8223],
              [8245, 8215],
              [8244, 8197],
              [8229, 8195],
              [8212, 8208],
              [8206, 8224],
              [8209, 8238],
              [8174, 8238],
              [8163, 8229],
              [8118, 8221],
              [8122, 8206],
              [8106, 8214],
              [8090, 8210],
              [8076, 8227],
              [8089, 8228],
              [8110, 8266],
              [8122, 8272],
              [8134, 8267],
              [8165, 8275],
              [8205, 8268],
              [8212, 8279],
              [8204, 8287],
              [8213, 8313],
              [8203, 8339],
              [8217, 8346],
              [8219, 8321],
              [8252, 8332],
              [8258, 8356],
              [8246, 8360],
              [8235, 8370],
              [8263, 8362],
              [8270, 8369],
              [8261, 8420],
              [8241, 8437],
              [8232, 8457],
              [8239, 8465],
              [8231, 8482],
              [8252, 8467],
              [8263, 8467],
              [8257, 8482],
              [8249, 8477],
              [8242, 8492],
              [8265, 8478],
            ],
          ],
          [
            [
              [8303, 8506],
              [8241, 8531],
              [8226, 8521],
              [8213, 8529],
              [8207, 8518],
              [8245, 8501],
              [8214, 8492],
              [8209, 8508],
              [8192, 8517],
              [8185, 8532],
              [8196, 8544],
              [8186, 8558],
              [8212, 8549],
              [8215, 8557],
              [8191, 8608],
              [8173, 8627],
              [8167, 8626],
              [8176, 8638],
              [8212, 8613],
              [8250, 8592],
              [8299, 8577],
              [8310, 8588],
              [8313, 8572],
              [8335, 8551],
              [8324, 8542],
              [8306, 8544],
              [8297, 8530],
              [8303, 8506],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'IN',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.37,
        'hc-middle-y': 0.44,
        'hc-key': 'in',
        'hc-a2': 'IN',
        name: 'India',
        labelrank: '2',
        'country-abbrev': 'India',
        subregion: 'Southern Asia',
        'region-wb': 'South Asia',
        'iso-a3': 'IND',
        'iso-a2': 'IN',
        'woe-id': '23424848',
        continent: 'Asia',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [7032, 7352],
              [7031, 7387],
              [7035, 7443],
              [7042, 7445],
              [7040, 7401],
              [7032, 7352],
            ],
          ],
          [
            [
              [6949, 7801],
              [6930, 7826],
              [6935, 7844],
              [6957, 7855],
              [6965, 7875],
              [6949, 7884],
              [6896, 7883],
              [6877, 7891],
              [6874, 7912],
              [6864, 7913],
              [6827, 7932],
              [6818, 7911],
              [6850, 7884],
              [6834, 7884],
              [6824, 7864],
              [6849, 7851],
              [6847, 7827],
              [6860, 7802],
              [6867, 7782],
              [6873, 7764],
              [6873, 7763],
              [6873, 7763],
              [6875, 7751],
              [6849, 7749],
              [6842, 7764],
              [6815, 7749],
              [6806, 7731],
              [6813, 7716],
              [6796, 7691],
              [6772, 7681],
              [6766, 7687],
              [6729, 7627],
              [6715, 7618],
              [6705, 7602],
              [6682, 7587],
              [6679, 7564],
              [6661, 7554],
              [6646, 7554],
              [6634, 7532],
              [6617, 7531],
              [6612, 7505],
              [6627, 7443],
              [6624, 7413],
              [6615, 7394],
              [6619, 7330],
              [6604, 7331],
              [6592, 7306],
              [6593, 7292],
              [6569, 7280],
              [6564, 7258],
              [6547, 7247],
              [6529, 7258],
              [6513, 7278],
              [6504, 7314],
              [6474, 7382],
              [6462, 7394],
              [6448, 7424],
              [6438, 7462],
              [6427, 7489],
              [6393, 7545],
              [6385, 7579],
              [6367, 7630],
              [6361, 7663],
              [6353, 7686],
              [6358, 7711],
              [6344, 7743],
              [6360, 7756],
              [6341, 7754],
              [6333, 7778],
              [6330, 7736],
              [6295, 7718],
              [6264, 7734],
              [6224, 7777],
              [6262, 7787],
              [6267, 7801],
              [6246, 7793],
              [6211, 7809],
              [6193, 7834],
              [6209, 7839],
              [6212, 7849],
              [6248, 7846],
              [6266, 7856],
              [6273, 7849],
              [6281, 7866],
              [6263, 7902],
              [6242, 7914],
              [6242, 7934],
              [6219, 7945],
              [6220, 7959],
              [6243, 7991],
              [6257, 7978],
              [6288, 7988],
              [6298, 8018],
              [6314, 8027],
              [6322, 8061],
              [6339, 8071],
              [6334, 8077],
              [6350, 8105],
              [6344, 8127],
              [6365, 8143],
              [6345, 8155],
              [6340, 8169],
              [6330, 8166],
              [6316, 8181],
              [6307, 8213],
              [6298, 8226],
              [6313, 8241],
              [6359, 8231],
              [6384, 8240],
              [6393, 8254],
              [6413, 8268],
              [6437, 8236],
              [6458, 8226],
              [6455, 8215],
              [6463, 8193],
              [6484, 8181],
              [6492, 8165],
              [6477, 8151],
              [6459, 8157],
              [6475, 8136],
              [6480, 8113],
              [6495, 8113],
              [6510, 8098],
              [6533, 8090],
              [6532, 8084],
              [6561, 8071],
              [6545, 8055],
              [6541, 8020],
              [6559, 8014],
              [6607, 7984],
              [6637, 7970],
              [6674, 7965],
              [6679, 7971],
              [6697, 7964],
              [6701, 7953],
              [6723, 7942],
              [6733, 7946],
              [6742, 7936],
              [6771, 7930],
              [6780, 7936],
              [6791, 7928],
              [6815, 7942],
              [6806, 7956],
              [6805, 7984],
              [6826, 7989],
              [6834, 7964],
              [6830, 7958],
              [6844, 7945],
              [6868, 7941],
              [6927, 7945],
              [6939, 7950],
              [6931, 7970],
              [6918, 7980],
              [6948, 7986],
              [6948, 7994],
              [6968, 8014],
              [6993, 8027],
              [7000, 8038],
              [7023, 8028],
              [7047, 8040],
              [7082, 8001],
              [7095, 7997],
              [7098, 7985],
              [7085, 7974],
              [7096, 7959],
              [7082, 7965],
              [7065, 7961],
              [7036, 7932],
              [7041, 7905],
              [7030, 7892],
              [7036, 7878],
              [7024, 7834],
              [6998, 7840],
              [7005, 7808],
              [6998, 7803],
              [7002, 7780],
              [6995, 7764],
              [6986, 7765],
              [6971, 7813],
              [6962, 7830],
              [6949, 7801],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'FR',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.28,
        'hc-middle-y': 0.04,
        'hc-key': 'fr',
        'hc-a2': 'FR',
        name: 'France',
        labelrank: '2',
        'country-abbrev': 'Fr.',
        subregion: 'Western Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'FRA',
        'iso-a2': 'FR',
        'woe-id': '-90',
        continent: 'Europe',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [4288, 8532],
              [4291, 8513],
              [4282, 8485],
              [4269, 8492],
              [4261, 8517],
              [4268, 8530],
              [4288, 8532],
            ],
          ],
          [
            [
              [9327, 6151],
              [9309, 6173],
              [9308, 6199],
              [9344, 6154],
              [9379, 6124],
              [9376, 6113],
              [9355, 6122],
              [9327, 6151],
            ],
          ],
          [
            [
              [1959, 7619],
              [1962, 7621],
              [1962, 7618],
              [1959, 7619],
            ],
          ],
          [
            [
              [4228, 8573],
              [4227, 8572],
              [4226, 8571],
              [4225, 8572],
              [4224, 8570],
              [4187, 8547],
              [4122, 8564],
              [4096, 8542],
              [4100, 8524],
              [4080, 8520],
              [4064, 8524],
              [4064, 8524],
              [4063, 8525],
              [4056, 8526],
              [4056, 8530],
              [4048, 8530],
              [4024, 8539],
              [4004, 8533],
              [3965, 8548],
              [3951, 8558],
              [3961, 8565],
              [3970, 8604],
              [3974, 8657],
              [3952, 8674],
              [3947, 8693],
              [3923, 8710],
              [3890, 8725],
              [3878, 8721],
              [3869, 8731],
              [3881, 8736],
              [3869, 8749],
              [3914, 8760],
              [3928, 8747],
              [3960, 8756],
              [3950, 8791],
              [3969, 8790],
              [3971, 8780],
              [3999, 8775],
              [4010, 8790],
              [4040, 8800],
              [4049, 8809],
              [4050, 8832],
              [4076, 8840],
              [4109, 8813],
              [4125, 8810],
              [4123, 8800],
              [4142, 8800],
              [4161, 8783],
              [4171, 8784],
              [4176, 8781],
              [4187, 8781],
              [4201, 8772],
              [4241, 8763],
              [4224, 8733],
              [4225, 8713],
              [4210, 8704],
              [4184, 8677],
              [4187, 8666],
              [4189, 8669],
              [4191, 8669],
              [4203, 8671],
              [4203, 8661],
              [4211, 8653],
              [4205, 8645],
              [4215, 8634],
              [4199, 8623],
              [4212, 8610],
              [4211, 8589],
              [4232, 8587],
              [4228, 8573],
            ],
          ],
          [
            [
              [2226, 7146],
              [2234, 7160],
              [2265, 7149],
              [2306, 7110],
              [2306, 7097],
              [2284, 7064],
              [2276, 7040],
              [2263, 7027],
              [2251, 7034],
              [2225, 7025],
              [2209, 7033],
              [2224, 7053],
              [2230, 7075],
              [2219, 7097],
              [2215, 7129],
              [2226, 7146],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'CN',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.45,
        'hc-middle-y': 0.5,
        'hc-key': 'cn',
        'hc-a2': 'CN',
        name: 'China',
        labelrank: '2',
        'country-abbrev': 'China',
        subregion: 'Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'CHN',
        'iso-a2': 'CN',
        'woe-id': '23424781',
        continent: 'Asia',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [7582, 7654],
              [7580, 7643],
              [7556, 7623],
              [7525, 7637],
              [7519, 7664],
              [7550, 7692],
              [7589, 7691],
              [7593, 7680],
              [7582, 7654],
            ],
          ],
          [
            [
              [7412, 8728],
              [7411, 8727],
              [7410, 8720],
              [7389, 8724],
              [7364, 8718],
              [7345, 8733],
              [7340, 8795],
              [7378, 8783],
              [7394, 8800],
              [7408, 8802],
              [7399, 8814],
              [7393, 8861],
              [7400, 8877],
              [7387, 8892],
              [7362, 8900],
              [7371, 8918],
              [7430, 8929],
              [7463, 8922],
              [7488, 8912],
              [7516, 8908],
              [7561, 8878],
              [7562, 8873],
              [7596, 8848],
              [7601, 8839],
              [7642, 8809],
              [7651, 8793],
              [7673, 8785],
              [7713, 8780],
              [7752, 8760],
              [7783, 8739],
              [7785, 8731],
              [7805, 8717],
              [7847, 8718],
              [7853, 8732],
              [7884, 8742],
              [7897, 8738],
              [7911, 8719],
              [7905, 8701],
              [7922, 8665],
              [7919, 8661],
              [7926, 8624],
              [7919, 8622],
              [7906, 8631],
              [7891, 8628],
              [7869, 8610],
              [7896, 8582],
              [7910, 8561],
              [7915, 8539],
              [7900, 8535],
              [7909, 8527],
              [7879, 8543],
              [7886, 8524],
              [7875, 8524],
              [7871, 8509],
              [7845, 8508],
              [7862, 8486],
              [7833, 8490],
              [7816, 8501],
              [7810, 8496],
              [7807, 8468],
              [7782, 8453],
              [7773, 8439],
              [7771, 8432],
              [7736, 8424],
              [7733, 8411],
              [7701, 8391],
              [7696, 8399],
              [7710, 8404],
              [7708, 8415],
              [7693, 8416],
              [7703, 8454],
              [7683, 8466],
              [7661, 8469],
              [7652, 8442],
              [7631, 8434],
              [7628, 8408],
              [7591, 8405],
              [7593, 8387],
              [7617, 8369],
              [7640, 8369],
              [7659, 8336],
              [7676, 8330],
              [7704, 8357],
              [7737, 8342],
              [7751, 8347],
              [7771, 8341],
              [7769, 8319],
              [7758, 8325],
              [7727, 8305],
              [7730, 8293],
              [7706, 8272],
              [7705, 8239],
              [7744, 8224],
              [7761, 8199],
              [7783, 8175],
              [7787, 8163],
              [7827, 8136],
              [7834, 8117],
              [7802, 8131],
              [7833, 8111],
              [7845, 8097],
              [7819, 8084],
              [7815, 8072],
              [7834, 8076],
              [7852, 8062],
              [7856, 8074],
              [7866, 8066],
              [7859, 8050],
              [7867, 8029],
              [7853, 8037],
              [7866, 8002],
              [7850, 8003],
              [7840, 7973],
              [7842, 7959],
              [7826, 7939],
              [7830, 7926],
              [7820, 7915],
              [7837, 7898],
              [7826, 7886],
              [7808, 7887],
              [7814, 7876],
              [7788, 7855],
              [7792, 7850],
              [7759, 7823],
              [7749, 7801],
              [7729, 7793],
              [7695, 7796],
              [7682, 7773],
              [7669, 7781],
              [7656, 7804],
              [7659, 7770],
              [7638, 7754],
              [7613, 7758],
              [7602, 7748],
              [7573, 7741],
              [7562, 7727],
              [7570, 7702],
              [7555, 7700],
              [7542, 7726],
              [7542, 7746],
              [7523, 7743],
              [7521, 7751],
              [7497, 7761],
              [7485, 7746],
              [7464, 7751],
              [7441, 7766],
              [7428, 7800],
              [7407, 7799],
              [7387, 7816],
              [7349, 7784],
              [7326, 7795],
              [7319, 7782],
              [7299, 7794],
              [7290, 7780],
              [7272, 7775],
              [7282, 7759],
              [7284, 7733],
              [7270, 7735],
              [7264, 7749],
              [7262, 7757],
              [7234, 7744],
              [7222, 7767],
              [7196, 7771],
              [7202, 7805],
              [7181, 7810],
              [7166, 7843],
              [7153, 7844],
              [7137, 7835],
              [7128, 7868],
              [7132, 7880],
              [7157, 7911],
              [7151, 7919],
              [7154, 7938],
              [7144, 7973],
              [7131, 7972],
              [7121, 7994],
              [7099, 8009],
              [7095, 7997],
              [7082, 8001],
              [7047, 8040],
              [7023, 8028],
              [7000, 8038],
              [6993, 8027],
              [6968, 8014],
              [6948, 7994],
              [6948, 7986],
              [6918, 7980],
              [6868, 8003],
              [6849, 7995],
              [6834, 7964],
              [6826, 7989],
              [6805, 7984],
              [6775, 7983],
              [6754, 7993],
              [6737, 7985],
              [6725, 8002],
              [6706, 8000],
              [6706, 8011],
              [6690, 8012],
              [6666, 8036],
              [6649, 8033],
              [6635, 8049],
              [6599, 8066],
              [6594, 8076],
              [6572, 8077],
              [6561, 8071],
              [6532, 8084],
              [6533, 8090],
              [6510, 8098],
              [6495, 8113],
              [6480, 8113],
              [6475, 8136],
              [6459, 8157],
              [6477, 8151],
              [6492, 8165],
              [6484, 8181],
              [6463, 8193],
              [6455, 8215],
              [6458, 8226],
              [6437, 8236],
              [6413, 8268],
              [6400, 8268],
              [6379, 8274],
              [6359, 8280],
              [6347, 8305],
              [6315, 8325],
              [6297, 8326],
              [6291, 8330],
              [6305, 8334],
              [6288, 8383],
              [6258, 8386],
              [6243, 8418],
              [6251, 8423],
              [6247, 8437],
              [6247, 8437],
              [6247, 8437],
              [6252, 8439],
              [6268, 8454],
              [6287, 8459],
              [6296, 8446],
              [6320, 8458],
              [6321, 8470],
              [6359, 8473],
              [6363, 8486],
              [6386, 8501],
              [6410, 8509],
              [6408, 8515],
              [6400, 8532],
              [6413, 8550],
              [6389, 8582],
              [6379, 8604],
              [6360, 8613],
              [6365, 8620],
              [6407, 8632],
              [6435, 8624],
              [6423, 8639],
              [6419, 8700],
              [6476, 8685],
              [6494, 8694],
              [6494, 8706],
              [6481, 8726],
              [6481, 8743],
              [6501, 8748],
              [6500, 8769],
              [6514, 8768],
              [6518, 8769],
              [6526, 8771],
              [6542, 8749],
              [6582, 8728],
              [6596, 8729],
              [6625, 8716],
              [6664, 8676],
              [6671, 8656],
              [6669, 8637],
              [6681, 8626],
              [6702, 8622],
              [6751, 8620],
              [6779, 8605],
              [6819, 8590],
              [6829, 8591],
              [6861, 8553],
              [6884, 8534],
              [6907, 8537],
              [6979, 8529],
              [6994, 8533],
              [7045, 8527],
              [7062, 8515],
              [7097, 8509],
              [7120, 8500],
              [7142, 8504],
              [7145, 8496],
              [7165, 8499],
              [7202, 8519],
              [7242, 8525],
              [7281, 8525],
              [7302, 8536],
              [7308, 8555],
              [7330, 8569],
              [7301, 8596],
              [7300, 8620],
              [7318, 8622],
              [7327, 8613],
              [7359, 8607],
              [7369, 8615],
              [7374, 8633],
              [7405, 8636],
              [7415, 8645],
              [7415, 8667],
              [7436, 8669],
              [7455, 8682],
              [7499, 8677],
              [7499, 8688],
              [7484, 8700],
              [7436, 8727],
              [7412, 8728],
            ],
          ],
          [
            [
              [7774, 8438],
              [7775, 8438],
              [7775, 8437],
              [7775, 8436],
              [7774, 8438],
            ],
          ],
          [
            [
              [6247, 8438],
              [6247, 8437],
              [6247, 8437],
              [6247, 8437],
              [6247, 8438],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'PT',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.45,
        'hc-middle-y': 0.51,
        'hc-key': 'pt',
        'hc-a2': 'PT',
        name: 'Portugal',
        labelrank: '2',
        'country-abbrev': 'Port.',
        subregion: 'Southern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'PRT',
        'iso-a2': 'PT',
        'woe-id': '23424925',
        continent: 'Europe',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [3777, 8333],
              [3760, 8324],
              [3741, 8330],
              [3728, 8326],
              [3734, 8341],
              [3737, 8370],
              [3715, 8390],
              [3720, 8415],
              [3727, 8420],
              [3743, 8465],
              [3738, 8503],
              [3742, 8507],
              [3758, 8514],
              [3759, 8502],
              [3808, 8506],
              [3818, 8493],
              [3796, 8473],
              [3796, 8437],
              [3796, 8437],
              [3796, 8437],
              [3792, 8427],
              [3775, 8426],
              [3792, 8402],
              [3780, 8380],
              [3790, 8364],
              [3774, 8347],
              [3777, 8333],
            ],
          ],
          [
            [
              [3796, 8437],
              [3796, 8437],
              [3796, 8436],
              [3796, 8437],
            ],
          ],
          [
            [
              [3796, 8437],
              [3796, 8437],
              [3796, 8437],
              [3796, 8437],
              [3796, 8437],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SW',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.83,
        'hc-middle-y': 0.54,
        'hc-key': 'sw',
        'hc-a2': 'SW',
        name: 'Serranilla Bank',
        labelrank: '5',
        'country-abbrev': 'S.B.',
        subregion: 'Caribbean',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': '-99',
        'iso-a2': 'SW',
        'woe-id': '-99',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1447, 7537],
            [1447, 7537],
            [1447, 7537],
            [1447, 7537],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SH',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.52,
        'hc-middle-y': 0.5,
        'hc-key': 'sh',
        'hc-a2': 'SH',
        name: 'Scarborough Reef',
        labelrank: '6',
        'country-abbrev': 'S.R.',
        subregion: 'South-Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': '-99',
        'iso-a2': 'SH',
        'woe-id': '-99',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [7839, 7511],
            [7839, 7511],
            [7839, 7511],
            [7839, 7511],
            [7839, 7511],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'EC',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.71,
        'hc-middle-y': 0.44,
        'hc-key': 'ec',
        'hc-a2': 'EC',
        name: 'Ecuador',
        labelrank: '3',
        'country-abbrev': 'Ecu.',
        subregion: 'South America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'ECU',
        'iso-a2': 'EC',
        'woe-id': '23424801',
        continent: 'South America',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [1036, 6928],
              [1068, 6918],
              [1060, 6911],
              [1038, 6921],
              [1030, 6918],
              [1019, 6941],
              [1036, 6928],
            ],
          ],
          [
            [
              [998, 6930],
              [1000, 6952],
              [1018, 6919],
              [999, 6908],
              [1008, 6925],
              [998, 6930],
            ],
          ],
          [
            [
              [1412, 7000],
              [1421, 6991],
              [1457, 6971],
              [1459, 6961],
              [1491, 6956],
              [1495, 6964],
              [1528, 6942],
              [1517, 6942],
              [1529, 6926],
              [1519, 6889],
              [1503, 6867],
              [1483, 6851],
              [1445, 6835],
              [1429, 6819],
              [1420, 6777],
              [1408, 6760],
              [1393, 6778],
              [1372, 6787],
              [1364, 6780],
              [1359, 6794],
              [1370, 6802],
              [1364, 6820],
              [1376, 6827],
              [1382, 6847],
              [1366, 6834],
              [1366, 6845],
              [1344, 6860],
              [1350, 6875],
              [1343, 6907],
              [1355, 6913],
              [1357, 6932],
              [1371, 6948],
              [1370, 6974],
              [1401, 6987],
              [1412, 7000],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'AU',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.58,
        'hc-middle-y': 0.41,
        'hc-key': 'au',
        'hc-a2': 'AU',
        name: 'Australia',
        labelrank: '2',
        'country-abbrev': 'Auz.',
        subregion: 'Australia and New Zealand',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'AUS',
        'iso-a2': 'AU',
        'woe-id': '-90',
        continent: 'Oceania',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [8262, 5621],
              [8273, 5614],
              [8248, 5602],
              [8226, 5603],
              [8227, 5614],
              [8262, 5621],
            ],
          ],
          [
            [
              [8275, 6507],
              [8256, 6507],
              [8270, 6531],
              [8280, 6522],
              [8297, 6529],
              [8304, 6514],
              [8285, 6502],
              [8275, 6507],
            ],
          ],
          [
            [
              [8348, 5363],
              [8359, 5369],
              [8361, 5406],
              [8381, 5439],
              [8382, 5431],
              [8421, 5415],
              [8469, 5426],
              [8482, 5437],
              [8497, 5465],
              [8496, 5442],
              [8488, 5439],
              [8457, 5392],
              [8422, 5357],
              [8413, 5340],
              [8408, 5354],
              [8369, 5325],
              [8349, 5337],
              [8348, 5363],
            ],
          ],
          [
            [
              [8731, 6338],
              [8746, 6290],
              [8736, 6267],
              [8746, 6261],
              [8744, 6236],
              [8773, 6223],
              [8776, 6212],
              [8818, 6191],
              [8803, 6181],
              [8817, 6161],
              [8820, 6118],
              [8830, 6103],
              [8829, 6121],
              [8855, 6101],
              [8849, 6084],
              [8864, 6053],
              [8873, 6052],
              [8889, 6006],
              [8914, 6015],
              [8895, 5986],
              [8884, 5938],
              [8891, 5925],
              [8879, 5901],
              [8872, 5871],
              [8825, 5802],
              [8811, 5774],
              [8786, 5749],
              [8782, 5739],
              [8751, 5722],
              [8709, 5676],
              [8699, 5669],
              [8677, 5636],
              [8669, 5635],
              [8644, 5609],
              [8616, 5570],
              [8607, 5548],
              [8585, 5538],
              [8548, 5536],
              [8521, 5526],
              [8488, 5505],
              [8473, 5500],
              [8462, 5486],
              [8453, 5505],
              [8431, 5510],
              [8445, 5533],
              [8381, 5497],
              [8356, 5516],
              [8333, 5514],
              [8310, 5527],
              [8298, 5560],
              [8312, 5581],
              [8314, 5609],
              [8305, 5622],
              [8277, 5620],
              [8292, 5630],
              [8305, 5653],
              [8302, 5676],
              [8271, 5636],
              [8244, 5632],
              [8256, 5647],
              [8268, 5646],
              [8272, 5661],
              [8317, 5713],
              [8298, 5713],
              [8283, 5694],
              [8260, 5684],
              [8212, 5645],
              [8216, 5685],
              [8209, 5694],
              [8212, 5711],
              [8199, 5712],
              [8206, 5738],
              [8196, 5748],
              [8178, 5748],
              [8171, 5757],
              [8152, 5754],
              [8126, 5775],
              [8055, 5767],
              [7994, 5745],
              [7960, 5746],
              [7881, 5712],
              [7870, 5697],
              [7852, 5683],
              [7806, 5687],
              [7742, 5683],
              [7719, 5665],
              [7698, 5664],
              [7678, 5647],
              [7654, 5641],
              [7616, 5643],
              [7583, 5677],
              [7592, 5698],
              [7599, 5694],
              [7616, 5707],
              [7638, 5768],
              [7632, 5799],
              [7633, 5821],
              [7642, 5849],
              [7638, 5884],
              [7631, 5900],
              [7634, 5929],
              [7614, 5987],
              [7634, 5996],
              [7645, 5961],
              [7652, 5986],
              [7639, 6033],
              [7642, 6051],
              [7656, 6070],
              [7660, 6106],
              [7677, 6132],
              [7678, 6108],
              [7697, 6133],
              [7739, 6156],
              [7754, 6170],
              [7786, 6179],
              [7805, 6177],
              [7820, 6188],
              [7842, 6191],
              [7856, 6203],
              [7868, 6199],
              [7915, 6215],
              [7929, 6226],
              [7954, 6259],
              [7969, 6270],
              [7970, 6304],
              [8003, 6337],
              [8000, 6329],
              [8013, 6294],
              [8026, 6338],
              [8048, 6338],
              [8055, 6379],
              [8071, 6375],
              [8082, 6390],
              [8081, 6402],
              [8112, 6406],
              [8120, 6424],
              [8132, 6416],
              [8146, 6435],
              [8160, 6427],
              [8181, 6399],
              [8173, 6377],
              [8192, 6397],
              [8227, 6385],
              [8232, 6393],
              [8221, 6410],
              [8235, 6424],
              [8243, 6446],
              [8256, 6450],
              [8254, 6465],
              [8287, 6494],
              [8319, 6488],
              [8341, 6494],
              [8337, 6519],
              [8317, 6527],
              [8342, 6535],
              [8343, 6518],
              [8352, 6524],
              [8358, 6511],
              [8379, 6510],
              [8398, 6497],
              [8410, 6501],
              [8418, 6490],
              [8464, 6515],
              [8471, 6489],
              [8478, 6485],
              [8461, 6471],
              [8447, 6447],
              [8437, 6440],
              [8457, 6431],
              [8471, 6432],
              [8452, 6418],
              [8454, 6432],
              [8437, 6427],
              [8420, 6401],
              [8419, 6387],
              [8446, 6364],
              [8465, 6364],
              [8462, 6353],
              [8483, 6341],
              [8497, 6323],
              [8519, 6317],
              [8528, 6324],
              [8536, 6310],
              [8530, 6299],
              [8546, 6287],
              [8575, 6297],
              [8604, 6348],
              [8618, 6387],
              [8619, 6427],
              [8629, 6453],
              [8627, 6463],
              [8641, 6478],
              [8630, 6479],
              [8644, 6498],
              [8653, 6524],
              [8658, 6567],
              [8661, 6547],
              [8672, 6546],
              [8677, 6523],
              [8675, 6506],
              [8685, 6500],
              [8679, 6487],
              [8690, 6477],
              [8687, 6434],
              [8696, 6406],
              [8715, 6419],
              [8719, 6404],
              [8739, 6390],
              [8732, 6372],
              [8731, 6338],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'PH',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.38,
        'hc-middle-y': 0.07,
        'hc-key': 'ph',
        'hc-a2': 'PH',
        name: 'Philippines',
        labelrank: '2',
        'country-abbrev': 'Phil.',
        subregion: 'South-Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'PHL',
        'iso-a2': 'PH',
        'woe-id': '23424934',
        continent: 'Asia',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [8056, 7292],
              [8036, 7283],
              [8013, 7313],
              [8028, 7323],
              [8024, 7338],
              [8036, 7356],
              [8048, 7350],
              [8038, 7314],
              [8045, 7294],
              [8056, 7292],
            ],
          ],
          [
            [
              [8059, 7310],
              [8070, 7324],
              [8084, 7320],
              [8076, 7304],
              [8044, 7300],
              [8059, 7355],
              [8064, 7333],
              [8053, 7321],
              [8059, 7310],
            ],
          ],
          [
            [
              [8075, 7374],
              [8095, 7365],
              [8096, 7347],
              [8105, 7323],
              [8090, 7324],
              [8087, 7350],
              [8072, 7341],
              [8075, 7374],
            ],
          ],
          [
            [
              [7990, 7399],
              [7991, 7391],
              [8015, 7376],
              [8033, 7373],
              [8032, 7362],
              [8016, 7345],
              [7996, 7335],
              [7997, 7381],
              [7988, 7385],
              [7990, 7399],
            ],
          ],
          [
            [
              [8046, 7406],
              [8060, 7383],
              [8032, 7409],
              [8043, 7418],
              [8046, 7406],
            ],
          ],
          [
            [
              [7928, 7456],
              [7960, 7447],
              [7972, 7436],
              [7975, 7416],
              [7967, 7401],
              [7928, 7456],
            ],
          ],
          [
            [
              [8087, 7376],
              [8088, 7384],
              [8069, 7402],
              [8064, 7414],
              [8093, 7415],
              [8106, 7402],
              [8107, 7379],
              [8117, 7360],
              [8102, 7359],
              [8087, 7376],
            ],
          ],
          [
            [
              [8111, 7165],
              [8084, 7177],
              [8077, 7186],
              [8074, 7229],
              [8053, 7237],
              [8054, 7221],
              [8038, 7220],
              [8029, 7236],
              [8018, 7224],
              [8008, 7185],
              [8005, 7215],
              [8014, 7244],
              [8036, 7250],
              [8049, 7271],
              [8062, 7267],
              [8067, 7250],
              [8077, 7252],
              [8083, 7267],
              [8094, 7263],
              [8094, 7284],
              [8105, 7275],
              [8118, 7283],
              [8112, 7307],
              [8117, 7319],
              [8119, 7306],
              [8130, 7310],
              [8135, 7291],
              [8146, 7276],
              [8151, 7238],
              [8159, 7217],
              [8151, 7207],
              [8148, 7180],
              [8132, 7220],
              [8120, 7195],
              [8132, 7174],
              [8123, 7154],
              [8111, 7165],
            ],
          ],
          [
            [
              [7871, 7290],
              [7910, 7346],
              [7913, 7372],
              [7925, 7387],
              [7922, 7405],
              [7938, 7396],
              [7915, 7367],
              [7918, 7344],
              [7930, 7337],
              [7912, 7331],
              [7894, 7315],
              [7887, 7293],
              [7852, 7262],
              [7849, 7268],
              [7871, 7290],
            ],
          ],
          [
            [
              [8018, 7467],
              [8053, 7460],
              [8035, 7453],
              [8046, 7440],
              [8059, 7437],
              [8058, 7414],
              [8035, 7432],
              [8030, 7427],
              [8024, 7447],
              [8001, 7466],
              [8009, 7439],
              [7974, 7467],
              [7966, 7455],
              [7936, 7474],
              [7947, 7488],
              [7931, 7499],
              [7935, 7487],
              [7916, 7498],
              [7900, 7539],
              [7899, 7556],
              [7911, 7544],
              [7919, 7548],
              [7913, 7565],
              [7915, 7579],
              [7909, 7600],
              [7910, 7635],
              [7927, 7641],
              [7955, 7627],
              [7961, 7636],
              [7949, 7648],
              [7952, 7654],
              [7968, 7631],
              [7966, 7607],
              [7983, 7583],
              [7977, 7551],
              [7959, 7540],
              [7956, 7518],
              [7970, 7495],
              [7973, 7475],
              [7992, 7471],
              [7997, 7481],
              [8018, 7467],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'ES',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.74,
        'hc-middle-y': 0.27,
        'hc-key': 'es',
        'hc-a2': 'ES',
        name: 'Spain',
        labelrank: '2',
        'country-abbrev': 'Sp.',
        subregion: 'Southern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'ESP',
        'iso-a2': 'ES',
        'woe-id': '23424950',
        continent: 'Europe',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [3439, 8006],
              [3441, 8021],
              [3458, 7997],
              [3494, 8010],
              [3515, 7994],
              [3510, 7979],
              [3502, 7989],
              [3483, 7995],
              [3475, 7989],
              [3454, 7993],
              [3439, 8006],
            ],
          ],
          [
            [
              [4121, 8437],
              [4098, 8411],
              [4077, 8424],
              [4101, 8437],
              [4110, 8429],
              [4121, 8437],
            ],
          ],
          [
            [
              [3796, 8437],
              [3796, 8437],
              [3796, 8437],
              [3796, 8473],
              [3818, 8493],
              [3808, 8506],
              [3759, 8502],
              [3758, 8514],
              [3742, 8507],
              [3741, 8533],
              [3728, 8540],
              [3730, 8550],
              [3757, 8559],
              [3770, 8572],
              [3789, 8565],
              [3845, 8564],
              [3880, 8559],
              [3898, 8563],
              [3951, 8558],
              [3965, 8548],
              [4004, 8533],
              [4024, 8539],
              [4048, 8530],
              [4050, 8524],
              [4056, 8526],
              [4063, 8525],
              [4063, 8525],
              [4064, 8526],
              [4065, 8524],
              [4064, 8524],
              [4080, 8520],
              [4100, 8524],
              [4102, 8507],
              [4067, 8482],
              [4035, 8473],
              [3995, 8420],
              [4001, 8399],
              [4012, 8392],
              [3989, 8376],
              [3983, 8349],
              [3954, 8339],
              [3941, 8317],
              [3868, 8315],
              [3845, 8303],
              [3840, 8293],
              [3840, 8293],
              [3832, 8288],
              [3815, 8299],
              [3805, 8324],
              [3777, 8333],
              [3774, 8347],
              [3790, 8364],
              [3780, 8380],
              [3792, 8402],
              [3775, 8426],
              [3792, 8427],
              [3796, 8437],
              [3796, 8437],
              [3796, 8436],
              [3796, 8437],
              [3796, 8437],
              [3796, 8437],
              [3796, 8437],
              [3796, 8437],
              [3796, 8437],
            ],
          ],
          [
            [
              [3838, 8285],
              [3841, 8284],
              [3840, 8282],
              [3839, 8283],
              [3838, 8285],
            ],
          ],
          [
            [
              [3914, 8260],
              [3913, 8262],
              [3914, 8262],
              [3914, 8262],
              [3914, 8262],
              [3915, 8260],
              [3914, 8260],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'BU',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.46,
        'hc-middle-y': 0.67,
        'hc-key': 'bu',
        'hc-a2': 'BU',
        name: 'Bajo Nuevo Bank (Petrel Is.)',
        labelrank: '8',
        'country-abbrev': null,
        subregion: 'Caribbean',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': '-99',
        'iso-a2': 'BU',
        'woe-id': '-99',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1403, 7535],
            [1403, 7535],
            [1403, 7535],
            [1403, 7535],
            [1403, 7535],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'MV',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.6,
        'hc-middle-y': 0.59,
        'hc-key': 'mv',
        'hc-a2': 'MV',
        name: 'Maldives',
        labelrank: '5',
        'country-abbrev': 'Mald.',
        subregion: 'Southern Asia',
        'region-wb': 'South Asia',
        'iso-a3': 'MDV',
        'iso-a2': 'MV',
        'woe-id': '23424899',
        continent: 'Seven seas (open ocean)',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [6422, 7143],
            [6413, 7146],
            [6417, 7153],
            [6423, 7148],
            [6422, 7143],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SP',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.5,
        'hc-middle-y': 0.51,
        'hc-key': 'sp',
        'hc-a2': 'SP',
        name: 'Spratly Islands',
        labelrank: '6',
        'country-abbrev': 'Spratly Is.',
        subregion: 'South-Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': '-99',
        'iso-a2': 'SP',
        'woe-id': '23424921',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [7795, 7349],
            [7795, 7349],
            [7795, 7350],
            [7795, 7350],
            [7795, 7349],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'GB',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.6,
        'hc-middle-y': 0.06,
        'hc-key': 'gb',
        'hc-a2': 'GB',
        name: 'United Kingdom',
        labelrank: '2',
        'country-abbrev': 'U.K.',
        subregion: 'Northern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'GBR',
        'iso-a2': 'GB',
        'woe-id': '-90',
        continent: 'Europe',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [3814, 9077],
              [3815, 9090],
              [3838, 9101],
              [3835, 9085],
              [3807, 9061],
              [3814, 9077],
            ],
          ],
          [
            [
              [2291, 5043],
              [2322, 5046],
              [2332, 5041],
              [2320, 5022],
              [2303, 5011],
              [2281, 5026],
              [2302, 5020],
              [2306, 5032],
              [2291, 5043],
            ],
          ],
          [
            [
              [2329, 5009],
              [2326, 5020],
              [2335, 5030],
              [2337, 5047],
              [2368, 5042],
              [2377, 5031],
              [2360, 5024],
              [2362, 5016],
              [2339, 5020],
              [2329, 5009],
            ],
          ],
          [
            [
              [5056, 8248],
              [5055, 8247],
              [5053, 8249],
              [5052, 8249],
              [5052, 8249],
              [5053, 8249],
              [5050, 8249],
              [5050, 8249],
              [5050, 8250],
              [5049, 8251],
              [5052, 8251],
              [5056, 8252],
              [5056, 8252],
              [5053, 8251],
              [5056, 8248],
            ],
            [
              [5051, 8250],
              [5051, 8250],
              [5051, 8250],
              [5051, 8250],
              [5051, 8250],
            ],
          ],
          [
            [
              [3840, 8293],
              [3840, 8292],
              [3840, 8293],
              [3840, 8293],
            ],
          ],
          [
            [
              [5030, 8236],
              [5027, 8237],
              [5022, 8237],
              [5024, 8238],
              [5030, 8236],
            ],
          ],
          [
            [
              [3806, 8982],
              [3836, 8990],
              [3852, 8967],
              [3838, 8945],
              [3831, 8947],
              [3821, 8945],
              [3811, 8959],
              [3803, 8948],
              [3779, 8960],
              [3792, 8965],
              [3806, 8982],
            ],
          ],
          [
            [
              [3836, 9073],
              [3840, 9062],
              [3850, 9079],
              [3866, 9082],
              [3861, 9093],
              [3872, 9105],
              [3914, 9106],
              [3924, 9130],
              [3934, 9126],
              [3919, 9094],
              [3896, 9082],
              [3903, 9078],
              [3891, 9066],
              [3911, 9074],
              [3953, 9073],
              [3958, 9066],
              [3937, 9035],
              [3935, 9024],
              [3919, 9016],
              [3947, 9011],
              [3960, 9000],
              [3972, 8966],
              [3989, 8961],
              [4003, 8948],
              [4014, 8912],
              [4005, 8905],
              [4040, 8906],
              [4055, 8890],
              [4049, 8876],
              [4025, 8854],
              [4045, 8851],
              [4043, 8842],
              [4013, 8828],
              [4000, 8831],
              [3969, 8822],
              [3952, 8827],
              [3935, 8822],
              [3908, 8824],
              [3897, 8809],
              [3869, 8813],
              [3857, 8800],
              [3850, 8808],
              [3869, 8823],
              [3887, 8845],
              [3918, 8845],
              [3882, 8865],
              [3865, 8859],
              [3855, 8868],
              [3887, 8883],
              [3889, 8916],
              [3916, 8922],
              [3926, 8951],
              [3915, 8948],
              [3905, 8962],
              [3912, 8975],
              [3884, 8976],
              [3885, 8959],
              [3881, 8969],
              [3863, 8975],
              [3879, 8997],
              [3872, 9014],
              [3860, 9009],
              [3866, 8999],
              [3847, 8990],
              [3849, 9017],
              [3840, 9003],
              [3832, 9009],
              [3851, 9028],
              [3827, 9037],
              [3844, 9042],
              [3844, 9050],
              [3822, 9065],
              [3836, 9073],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'GR',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.28,
        'hc-middle-y': 0.45,
        'hc-key': 'gr',
        'hc-a2': 'GR',
        name: 'Greece',
        labelrank: '3',
        'country-abbrev': 'Greece',
        subregion: 'Southern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'GRC',
        'iso-a2': 'GR',
        'woe-id': '23424833',
        continent: 'Europe',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [4774, 8326],
              [4789, 8333],
              [4795, 8321],
              [4773, 8311],
              [4760, 8313],
              [4752, 8352],
              [4767, 8324],
              [4774, 8326],
            ],
          ],
          [
            [
              [4750, 8396],
              [4758, 8393],
              [4739, 8379],
              [4705, 8397],
              [4742, 8388],
              [4750, 8396],
            ],
          ],
          [
            [
              [4838, 8265],
              [4816, 8250],
              [4772, 8247],
              [4771, 8253],
              [4733, 8261],
              [4735, 8273],
              [4799, 8263],
              [4802, 8255],
              [4838, 8265],
            ],
          ],
          [
            [
              [4640, 8461],
              [4643, 8463],
              [4640, 8461],
              [4637, 8463],
              [4638, 8465],
              [4640, 8466],
              [4642, 8467],
              [4665, 8476],
              [4690, 8478],
              [4695, 8484],
              [4742, 8492],
              [4765, 8481],
              [4791, 8485],
              [4796, 8498],
              [4806, 8487],
              [4791, 8462],
              [4765, 8432],
              [4776, 8467],
              [4760, 8472],
              [4754, 8458],
              [4746, 8470],
              [4721, 8460],
              [4743, 8442],
              [4731, 8440],
              [4697, 8450],
              [4688, 8441],
              [4715, 8408],
              [4700, 8393],
              [4737, 8374],
              [4743, 8352],
              [4716, 8362],
              [4715, 8349],
              [4729, 8340],
              [4702, 8347],
              [4720, 8304],
              [4706, 8318],
              [4699, 8305],
              [4686, 8326],
              [4673, 8316],
              [4666, 8347],
              [4652, 8357],
              [4658, 8372],
              [4676, 8376],
              [4704, 8365],
              [4715, 8367],
              [4676, 8379],
              [4652, 8375],
              [4641, 8394],
              [4645, 8402],
              [4618, 8410],
              [4601, 8429],
              [4612, 8427],
              [4631, 8439],
              [4640, 8461],
            ],
          ],
          [
            [
              [4779, 8349],
              [4804, 8350],
              [4799, 8370],
              [4802, 8402],
              [4792, 8411],
              [4806, 8415],
              [4810, 8400],
              [4803, 8372],
              [4813, 8352],
              [4827, 8356],
              [4831, 8329],
              [4847, 8320],
              [4834, 8315],
              [4820, 8351],
              [4785, 8341],
              [4779, 8349],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'DK',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.3,
        'hc-middle-y': 0.55,
        'hc-key': 'dk',
        'hc-a2': 'DK',
        name: 'Denmark',
        labelrank: '4',
        'country-abbrev': 'Den.',
        subregion: 'Northern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'DNK',
        'iso-a2': 'DK',
        'woe-id': '23424796',
        continent: 'Europe',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [4292, 9007],
              [4305, 8985],
              [4301, 8970],
              [4290, 8973],
              [4270, 8997],
              [4292, 9007],
            ],
          ],
          [
            [
              [4338, 8976],
              [4314, 8986],
              [4308, 9002],
              [4323, 9011],
              [4327, 9003],
              [4338, 9019],
              [4351, 9000],
              [4339, 8994],
              [4338, 8976],
            ],
          ],
          [
            [
              [4265, 8973],
              [4247, 8976],
              [4243, 8976],
              [4241, 8995],
              [4226, 8998],
              [4234, 9011],
              [4225, 9033],
              [4237, 9034],
              [4269, 9053],
              [4245, 9049],
              [4235, 9035],
              [4228, 9043],
              [4237, 9053],
              [4259, 9055],
              [4273, 9070],
              [4288, 9075],
              [4286, 9034],
              [4302, 9030],
              [4265, 8996],
              [4265, 8985],
              [4282, 8975],
              [4265, 8973],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'GL',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.51,
        'hc-middle-y': 0.37,
        'hc-key': 'gl',
        'hc-a2': 'GL',
        name: 'Greenland',
        labelrank: '3',
        'country-abbrev': 'Grlnd.',
        subregion: 'Northern America',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'GRL',
        'iso-a2': 'GL',
        'woe-id': '23424828',
        continent: 'North America',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [3446, 9571],
              [3464, 9571],
              [3498, 9549],
              [3492, 9544],
              [3447, 9559],
              [3446, 9571],
            ],
          ],
          [
            [
              [3077, 9833],
              [3132, 9824],
              [3110, 9820],
              [3084, 9824],
              [3077, 9833],
            ],
          ],
          [
            [
              [2712, 9491],
              [2749, 9486],
              [2773, 9473],
              [2768, 9465],
              [2728, 9456],
              [2725, 9466],
              [2700, 9470],
              [2712, 9491],
            ],
          ],
          [
            [
              [3372, 9494],
              [3345, 9493],
              [3357, 9502],
              [3356, 9506],
              [3405, 9513],
              [3412, 9500],
              [3385, 9495],
              [3376, 9494],
              [3346, 9482],
              [3360, 9479],
              [3410, 9492],
              [3449, 9483],
              [3477, 9483],
              [3453, 9469],
              [3432, 9465],
              [3374, 9439],
              [3331, 9434],
              [3296, 9423],
              [3255, 9418],
              [3239, 9420],
              [3226, 9436],
              [3231, 9418],
              [3195, 9403],
              [3193, 9394],
              [3151, 9364],
              [3104, 9347],
              [3087, 9348],
              [3067, 9338],
              [3071, 9354],
              [3088, 9364],
              [3068, 9360],
              [3049, 9342],
              [3007, 9335],
              [3021, 9331],
              [2991, 9314],
              [2979, 9278],
              [2961, 9271],
              [2959, 9261],
              [2925, 9240],
              [2905, 9211],
              [2899, 9193],
              [2884, 9194],
              [2895, 9183],
              [2869, 9169],
              [2869, 9151],
              [2844, 9146],
              [2815, 9160],
              [2822, 9167],
              [2805, 9176],
              [2805, 9186],
              [2785, 9178],
              [2748, 9181],
              [2753, 9193],
              [2734, 9195],
              [2730, 9212],
              [2736, 9225],
              [2715, 9237],
              [2725, 9252],
              [2706, 9259],
              [2699, 9276],
              [2716, 9300],
              [2691, 9291],
              [2705, 9319],
              [2680, 9356],
              [2686, 9369],
              [2725, 9382],
              [2691, 9382],
              [2686, 9387],
              [2735, 9397],
              [2690, 9392],
              [2703, 9411],
              [2722, 9423],
              [2739, 9422],
              [2746, 9438],
              [2775, 9434],
              [2798, 9468],
              [2787, 9465],
              [2788, 9478],
              [2738, 9491],
              [2726, 9502],
              [2753, 9503],
              [2746, 9514],
              [2752, 9524],
              [2720, 9522],
              [2710, 9531],
              [2727, 9545],
              [2727, 9564],
              [2759, 9566],
              [2737, 9571],
              [2753, 9583],
              [2737, 9588],
              [2750, 9611],
              [2738, 9616],
              [2739, 9628],
              [2718, 9632],
              [2713, 9641],
              [2725, 9651],
              [2680, 9663],
              [2628, 9670],
              [2611, 9663],
              [2567, 9667],
              [2553, 9657],
              [2514, 9661],
              [2495, 9670],
              [2502, 9676],
              [2473, 9687],
              [2488, 9698],
              [2506, 9698],
              [2528, 9706],
              [2492, 9709],
              [2469, 9719],
              [2484, 9729],
              [2559, 9736],
              [2593, 9744],
              [2636, 9744],
              [2668, 9755],
              [2676, 9768],
              [2636, 9769],
              [2634, 9776],
              [2691, 9787],
              [2703, 9792],
              [2744, 9798],
              [2769, 9794],
              [2794, 9804],
              [2785, 9810],
              [2848, 9818],
              [2935, 9824],
              [2948, 9818],
              [2934, 9805],
              [2956, 9812],
              [2962, 9823],
              [2993, 9816],
              [3026, 9814],
              [3003, 9827],
              [3043, 9826],
              [3096, 9816],
              [3109, 9811],
              [3146, 9825],
              [3112, 9833],
              [3205, 9833],
              [3116, 9835],
              [3139, 9841],
              [3230, 9843],
              [3255, 9840],
              [3258, 9847],
              [3380, 9851],
              [3415, 9850],
              [3509, 9844],
              [3500, 9842],
              [3409, 9841],
              [3473, 9839],
              [3516, 9841],
              [3528, 9836],
              [3587, 9830],
              [3564, 9823],
              [3416, 9819],
              [3355, 9812],
              [3457, 9817],
              [3518, 9815],
              [3515, 9811],
              [3481, 9807],
              [3478, 9802],
              [3533, 9810],
              [3547, 9816],
              [3583, 9817],
              [3581, 9804],
              [3540, 9790],
              [3564, 9793],
              [3625, 9807],
              [3628, 9817],
              [3662, 9804],
              [3692, 9812],
              [3729, 9811],
              [3778, 9803],
              [3717, 9787],
              [3660, 9784],
              [3684, 9778],
              [3670, 9773],
              [3625, 9773],
              [3652, 9768],
              [3625, 9759],
              [3607, 9764],
              [3609, 9774],
              [3588, 9765],
              [3610, 9760],
              [3613, 9749],
              [3600, 9734],
              [3568, 9736],
              [3538, 9706],
              [3555, 9714],
              [3587, 9712],
              [3592, 9724],
              [3624, 9732],
              [3595, 9712],
              [3601, 9704],
              [3562, 9705],
              [3568, 9698],
              [3613, 9693],
              [3600, 9674],
              [3596, 9681],
              [3564, 9686],
              [3536, 9678],
              [3533, 9666],
              [3572, 9666],
              [3579, 9642],
              [3621, 9631],
              [3596, 9630],
              [3597, 9619],
              [3571, 9608],
              [3528, 9603],
              [3539, 9597],
              [3540, 9584],
              [3518, 9586],
              [3499, 9578],
              [3463, 9589],
              [3411, 9578],
              [3435, 9573],
              [3428, 9568],
              [3442, 9554],
              [3485, 9538],
              [3471, 9532],
              [3497, 9519],
              [3501, 9496],
              [3456, 9493],
              [3443, 9498],
              [3439, 9513],
              [3405, 9528],
              [3406, 9515],
              [3352, 9507],
              [3340, 9491],
              [3372, 9494],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'PR',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.5,
        'hc-middle-y': 0.5,
        'hc-key': 'pr',
        'hc-a2': 'PR',
        name: 'Puerto Rico',
        labelrank: '5',
        'country-abbrev': 'P.R.',
        subregion: 'Caribbean',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'PRI',
        'iso-a2': 'PR',
        'woe-id': '23424935',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1885, 7623],
            [1871, 7618],
            [1829, 7615],
            [1829, 7635],
            [1879, 7631],
            [1885, 7623],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'UM',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.48,
        'hc-middle-y': 0.5,
        'hc-key': 'um',
        'hc-a2': 'UM',
        name: 'United States Minor Outlying Islands',
        labelrank: '5',
        'country-abbrev': 'U.S. MOI',
        subregion: 'Seven seas (open ocean)',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'UMI',
        'iso-a2': 'UM',
        'woe-id': '28289407',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1574, 7632],
            [1575, 7632],
            [1575, 7631],
            [1575, 7631],
            [1574, 7632],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'VI',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.47,
        'hc-middle-y': 0.16,
        'hc-key': 'vi',
        'hc-a2': 'VI',
        name: 'United States Virgin Islands',
        labelrank: '6',
        'country-abbrev': 'V.I. (U.S.)',
        subregion: 'Caribbean',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'VIR',
        'iso-a2': 'VI',
        'woe-id': '23424985',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1906, 7608],
            [1911, 7608],
            [1900, 7605],
            [1901, 7608],
            [1906, 7608],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'CA',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.26,
        'hc-middle-y': 0.54,
        'hc-key': 'ca',
        'hc-a2': 'CA',
        name: 'Canada',
        labelrank: '2',
        'country-abbrev': 'Can.',
        subregion: 'Northern America',
        'region-wb': 'North America',
        'iso-a3': 'CAN',
        'iso-a2': 'CA',
        'woe-id': '23424775',
        continent: 'North America',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [1802, 8616],
              [1784, 8611],
              [1764, 8598],
              [1746, 8590],
              [1749, 8589],
              [1736, 8588],
              [1716, 8575],
              [1704, 8582],
              [1657, 8574],
              [1630, 8556],
              [1651, 8554],
              [1649, 8551],
              [1648, 8548],
              [1647, 8545],
              [1650, 8542],
              [1610, 8537],
              [1598, 8529],
              [1573, 8532],
              [1553, 8518],
              [1527, 8510],
              [1517, 8519],
              [1517, 8519],
              [1518, 8520],
              [1537, 8521],
              [1534, 8528],
              [1539, 8532],
              [1547, 8545],
              [1571, 8557],
              [1582, 8584],
              [1604, 8603],
              [1601, 8627],
              [1612, 8629],
              [1610, 8609],
              [1636, 8597],
              [1652, 8609],
              [1638, 8653],
              [1615, 8660],
              [1600, 8639],
              [1557, 8652],
              [1612, 8660],
              [1546, 8668],
              [1548, 8675],
              [1536, 8672],
              [1536, 8692],
              [1546, 8703],
              [1539, 8715],
              [1547, 8727],
              [1523, 8727],
              [1514, 8718],
              [1517, 8757],
              [1460, 8754],
              [1459, 8759],
              [1432, 8745],
              [1413, 8728],
              [1360, 8730],
              [1347, 8741],
              [1336, 8737],
              [1333, 8748],
              [1279, 8758],
              [1284, 8776],
              [1269, 8765],
              [476, 8765],
              [474, 8768],
              [468, 8765],
              [466, 8765],
              [469, 8775],
              [454, 8784],
              [442, 8782],
              [446, 8812],
              [438, 8814],
              [429, 8790],
              [434, 8779],
              [453, 8771],
              [447, 8744],
              [437, 8740],
              [411, 8749],
              [383, 8775],
              [357, 8823],
              [379, 8835],
              [389, 8823],
              [421, 8816],
              [428, 8816],
              [404, 8822],
              [389, 8845],
              [400, 8854],
              [395, 8870],
              [420, 8913],
              [418, 8914],
              [392, 8882],
              [395, 8899],
              [403, 8912],
              [418, 8914],
              [406, 8923],
              [400, 8942],
              [408, 8949],
              [410, 8971],
              [419, 8975],
              [436, 8985],
              [444, 8989],
              [461, 9011],
              [465, 9018],
              [440, 9035],
              [448, 9098],
              [436, 9128],
              [439, 9145],
              [409, 9139],
              [388, 9124],
              [358, 9115],
              [364, 9126],
              [351, 9155],
              [363, 9164],
              [333, 9159],
              [312, 9163],
              [395, 9242],
              [486, 9324],
              [574, 9400],
              [658, 9469],
              [706, 9467],
              [708, 9453],
              [730, 9444],
              [752, 9445],
              [768, 9458],
              [820, 9470],
              [833, 9461],
              [949, 9488],
              [944, 9480],
              [868, 9465],
              [809, 9443],
              [875, 9463],
              [883, 9457],
              [913, 9470],
              [1009, 9487],
              [1002, 9471],
              [1016, 9458],
              [1055, 9480],
              [1063, 9471],
              [1042, 9460],
              [1076, 9464],
              [1093, 9474],
              [1127, 9472],
              [1142, 9461],
              [1174, 9455],
              [1183, 9449],
              [1225, 9442],
              [1232, 9448],
              [1265, 9438],
              [1254, 9424],
              [1233, 9426],
              [1214, 9410],
              [1241, 9407],
              [1298, 9408],
              [1327, 9413],
              [1360, 9424],
              [1372, 9394],
              [1398, 9420],
              [1425, 9420],
              [1468, 9437],
              [1407, 9422],
              [1381, 9425],
              [1404, 9436],
              [1459, 9445],
              [1479, 9434],
              [1478, 9418],
              [1505, 9417],
              [1540, 9406],
              [1565, 9412],
              [1620, 9410],
              [1634, 9404],
              [1650, 9410],
              [1630, 9413],
              [1627, 9428],
              [1665, 9431],
              [1665, 9419],
              [1693, 9426],
              [1658, 9400],
              [1676, 9395],
              [1697, 9419],
              [1713, 9418],
              [1756, 9434],
              [1759, 9448],
              [1735, 9441],
              [1758, 9458],
              [1765, 9454],
              [1781, 9465],
              [1761, 9462],
              [1727, 9475],
              [1732, 9490],
              [1752, 9499],
              [1744, 9505],
              [1761, 9520],
              [1807, 9539],
              [1822, 9541],
              [1809, 9540],
              [1823, 9555],
              [1820, 9565],
              [1844, 9590],
              [1855, 9594],
              [1880, 9604],
              [1915, 9606],
              [1932, 9600],
              [1976, 9598],
              [1909, 9566],
              [1893, 9562],
              [1855, 9564],
              [1862, 9555],
              [1834, 9542],
              [1824, 9541],
              [1842, 9522],
              [1828, 9506],
              [1845, 9484],
              [1830, 9485],
              [1834, 9466],
              [1859, 9462],
              [1831, 9457],
              [1839, 9444],
              [1827, 9424],
              [1851, 9437],
              [1858, 9447],
              [1883, 9456],
              [1895, 9440],
              [1889, 9427],
              [1874, 9426],
              [1865, 9406],
              [1867, 9388],
              [1898, 9397],
              [1903, 9419],
              [1928, 9418],
              [1950, 9440],
              [1971, 9440],
              [1968, 9453],
              [1978, 9472],
              [2008, 9475],
              [2043, 9470],
              [2047, 9458],
              [2065, 9461],
              [2063, 9451],
              [2046, 9446],
              [2053, 9437],
              [2021, 9428],
              [2017, 9414],
              [2028, 9399],
              [2011, 9385],
              [1951, 9364],
              [1941, 9384],
              [1941, 9356],
              [1935, 9340],
              [1919, 9345],
              [1918, 9359],
              [1905, 9371],
              [1869, 9367],
              [1886, 9358],
              [1829, 9331],
              [1815, 9331],
              [1786, 9351],
              [1747, 9352],
              [1776, 9346],
              [1791, 9330],
              [1835, 9328],
              [1788, 9293],
              [1755, 9285],
              [1737, 9291],
              [1728, 9279],
              [1703, 9273],
              [1681, 9277],
              [1700, 9265],
              [1694, 9256],
              [1671, 9248],
              [1652, 9250],
              [1652, 9242],
              [1627, 9236],
              [1613, 9218],
              [1570, 9202],
              [1513, 9151],
              [1492, 9120],
              [1494, 9109],
              [1529, 9109],
              [1519, 9065],
              [1501, 9047],
              [1553, 9058],
              [1602, 9044],
              [1618, 9030],
              [1621, 9016],
              [1663, 9000],
              [1686, 8988],
              [1706, 8991],
              [1745, 8982],
              [1728, 8957],
              [1727, 8937],
              [1707, 8907],
              [1718, 8889],
              [1707, 8882],
              [1727, 8873],
              [1731, 8849],
              [1747, 8842],
              [1768, 8861],
              [1802, 8886],
              [1800, 8910],
              [1819, 8950],
              [1810, 8951],
              [1808, 8967],
              [1873, 8989],
              [1917, 9016],
              [1929, 9030],
              [1943, 9063],
              [1942, 9082],
              [1911, 9105],
              [1914, 9111],
              [1953, 9132],
              [1955, 9142],
              [1976, 9153],
              [1971, 9167],
              [1981, 9178],
              [1964, 9179],
              [1997, 9203],
              [1990, 9211],
              [2005, 9240],
              [2020, 9240],
              [2082, 9225],
              [2110, 9236],
              [2140, 9221],
              [2152, 9209],
              [2142, 9201],
              [2179, 9183],
              [2198, 9184],
              [2231, 9168],
              [2213, 9163],
              [2196, 9180],
              [2180, 9170],
              [2164, 9136],
              [2191, 9102],
              [2204, 9094],
              [2248, 9111],
              [2276, 9128],
              [2279, 9143],
              [2295, 9152],
              [2310, 9169],
              [2319, 9152],
              [2315, 9142],
              [2332, 9120],
              [2330, 9104],
              [2350, 9053],
              [2330, 9042],
              [2340, 9031],
              [2321, 9022],
              [2343, 9020],
              [2364, 8983],
              [2386, 8985],
              [2385, 8974],
              [2422, 8967],
              [2425, 8962],
              [2398, 8957],
              [2382, 8946],
              [2338, 8936],
              [2325, 8918],
              [2375, 8942],
              [2414, 8951],
              [2420, 8935],
              [2449, 8928],
              [2452, 8918],
              [2445, 8889],
              [2431, 8871],
              [2395, 8852],
              [2376, 8854],
              [2338, 8840],
              [2291, 8809],
              [2257, 8808],
              [2187, 8812],
              [2111, 8811],
              [2086, 8795],
              [2073, 8777],
              [2052, 8776],
              [2017, 8757],
              [1978, 8720],
              [1928, 8686],
              [1951, 8692],
              [2010, 8737],
              [2040, 8752],
              [2104, 8772],
              [2140, 8773],
              [2156, 8763],
              [2149, 8744],
              [2112, 8729],
              [2082, 8732],
              [2102, 8716],
              [2127, 8718],
              [2111, 8699],
              [2118, 8667],
              [2147, 8646],
              [2170, 8642],
              [2189, 8652],
              [2210, 8631],
              [2183, 8623],
              [2120, 8597],
              [2118, 8605],
              [2080, 8574],
              [2068, 8573],
              [2053, 8560],
              [2042, 8583],
              [2045, 8594],
              [2030, 8604],
              [2034, 8626],
              [2027, 8626],
              [2019, 8629],
              [2024, 8641],
              [2018, 8644],
              [2015, 8647],
              [2031, 8695],
              [2019, 8705],
              [2001, 8699],
              [1994, 8709],
              [1962, 8681],
              [1944, 8652],
              [1897, 8620],
              [1818, 8619],
              [1802, 8616],
              [1837, 8635],
              [1823, 8631],
              [1802, 8616],
            ],
            [
              [1864, 8658],
              [1908, 8680],
              [1913, 8681],
              [1908, 8681],
              [1869, 8663],
              [1864, 8658],
            ],
          ],
          [
            [
              [2173, 8799],
              [2193, 8795],
              [2230, 8778],
              [2232, 8768],
              [2216, 8767],
              [2182, 8779],
              [2164, 8794],
              [2173, 8799],
            ],
          ],
          [
            [
              [1736, 8917],
              [1744, 8916],
              [1747, 8898],
              [1714, 8909],
              [1736, 8917],
            ],
          ],
          [
            [
              [1966, 9233],
              [1961, 9220],
              [1941, 9206],
              [1934, 9213],
              [1954, 9233],
              [1966, 9233],
            ],
          ],
          [
            [
              [1910, 9253],
              [1908, 9244],
              [1867, 9226],
              [1851, 9225],
              [1853, 9237],
              [1879, 9251],
              [1910, 9253],
            ],
          ],
          [
            [
              [2041, 9285],
              [2046, 9288],
              [2061, 9269],
              [2045, 9272],
              [2018, 9257],
              [2009, 9267],
              [2032, 9268],
              [2045, 9277],
              [2041, 9285],
            ],
          ],
          [
            [
              [2183, 9427],
              [2192, 9424],
              [2180, 9402],
              [2154, 9393],
              [2127, 9392],
              [2128, 9407],
              [2155, 9425],
              [2183, 9427],
            ],
          ],
          [
            [
              [2137, 9461],
              [2117, 9445],
              [2118, 9434],
              [2104, 9446],
              [2137, 9461],
            ],
          ],
          [
            [
              [1633, 9580],
              [1603, 9566],
              [1593, 9583],
              [1601, 9592],
              [1635, 9593],
              [1633, 9580],
            ],
          ],
          [
            [
              [1982, 9709],
              [2020, 9709],
              [2009, 9699],
              [1959, 9701],
              [1982, 9709],
            ],
          ],
          [
            [
              [1624, 9722],
              [1629, 9726],
              [1701, 9735],
              [1705, 9723],
              [1671, 9725],
              [1624, 9722],
            ],
          ],
          [
            [
              [2149, 8662],
              [2130, 8671],
              [2136, 8684],
              [2156, 8670],
              [2182, 8669],
              [2172, 8655],
              [2149, 8662],
            ],
          ],
          [
            [
              [321, 8899],
              [318, 8872],
              [308, 8914],
              [333, 8918],
              [321, 8899],
            ],
          ],
          [
            [
              [1930, 9653],
              [1943, 9638],
              [1922, 9620],
              [1878, 9615],
              [1865, 9630],
              [1899, 9644],
              [1930, 9653],
            ],
          ],
          [
            [
              [1598, 9710],
              [1581, 9707],
              [1571, 9714],
              [1592, 9717],
              [1608, 9712],
              [1657, 9717],
              [1691, 9718],
              [1658, 9711],
              [1657, 9701],
              [1610, 9696],
              [1598, 9710],
            ],
          ],
          [
            [
              [390, 8938],
              [397, 8946],
              [404, 8921],
              [389, 8911],
              [378, 8923],
              [390, 8938],
            ],
          ],
          [
            [
              [2242, 8688],
              [2243, 8677],
              [2212, 8644],
              [2235, 8664],
              [2255, 8655],
              [2211, 8636],
              [2201, 8644],
              [2202, 8657],
              [2240, 8693],
              [2242, 8688],
            ],
          ],
          [
            [
              [314, 8940],
              [327, 8951],
              [346, 8944],
              [364, 8950],
              [327, 8918],
              [310, 8925],
              [314, 8940],
            ],
          ],
          [
            [
              [1843, 9040],
              [1849, 9043],
              [1865, 9021],
              [1843, 9010],
              [1839, 9018],
              [1851, 9034],
              [1843, 9040],
            ],
          ],
          [
            [
              [1708, 9463],
              [1715, 9459],
              [1706, 9440],
              [1682, 9431],
              [1648, 9441],
              [1601, 9449],
              [1624, 9449],
              [1660, 9458],
              [1687, 9476],
              [1708, 9463],
            ],
          ],
          [
            [
              [2180, 9572],
              [2172, 9582],
              [2183, 9592],
              [2242, 9591],
              [2259, 9586],
              [2271, 9574],
              [2263, 9565],
              [2223, 9568],
              [2196, 9564],
              [2180, 9572],
            ],
          ],
          [
            [
              [1967, 9762],
              [1971, 9771],
              [1986, 9767],
              [1974, 9759],
              [1973, 9736],
              [2010, 9727],
              [1994, 9714],
              [1956, 9711],
              [1940, 9716],
              [1963, 9719],
              [1943, 9723],
              [1959, 9737],
              [1967, 9762],
            ],
          ],
          [
            [
              [2386, 9449],
              [2362, 9436],
              [2394, 9430],
              [2392, 9417],
              [2407, 9424],
              [2406, 9411],
              [2439, 9417],
              [2453, 9401],
              [2446, 9394],
              [2469, 9394],
              [2454, 9381],
              [2482, 9391],
              [2500, 9374],
              [2491, 9364],
              [2462, 9360],
              [2463, 9342],
              [2422, 9335],
              [2426, 9327],
              [2413, 9317],
              [2400, 9329],
              [2393, 9323],
              [2381, 9344],
              [2388, 9352],
              [2349, 9370],
              [2335, 9367],
              [2342, 9350],
              [2315, 9346],
              [2335, 9341],
              [2333, 9323],
              [2369, 9308],
              [2358, 9297],
              [2378, 9274],
              [2365, 9263],
              [2353, 9272],
              [2355, 9251],
              [2337, 9246],
              [2310, 9255],
              [2300, 9251],
              [2286, 9275],
              [2275, 9258],
              [2296, 9243],
              [2309, 9227],
              [2301, 9221],
              [2313, 9209],
              [2333, 9207],
              [2322, 9198],
              [2303, 9216],
              [2243, 9229],
              [2224, 9243],
              [2202, 9246],
              [2179, 9260],
              [2197, 9272],
              [2186, 9279],
              [2168, 9277],
              [2172, 9288],
              [2157, 9292],
              [2157, 9309],
              [2149, 9311],
              [2126, 9299],
              [2103, 9307],
              [2101, 9299],
              [2072, 9293],
              [2046, 9299],
              [2051, 9318],
              [2077, 9326],
              [2079, 9335],
              [2131, 9328],
              [2161, 9337],
              [2178, 9335],
              [2166, 9357],
              [2215, 9376],
              [2241, 9395],
              [2244, 9424],
              [2220, 9433],
              [2210, 9419],
              [2225, 9409],
              [2201, 9410],
              [2210, 9422],
              [2191, 9433],
              [2208, 9442],
              [2194, 9445],
              [2166, 9438],
              [2164, 9461],
              [2180, 9461],
              [2165, 9474],
              [2173, 9485],
              [2145, 9490],
              [2143, 9477],
              [2118, 9475],
              [2104, 9468],
              [2076, 9479],
              [2058, 9473],
              [2042, 9480],
              [2026, 9478],
              [1979, 9483],
              [1943, 9480],
              [1941, 9488],
              [1920, 9494],
              [1916, 9513],
              [1941, 9509],
              [1967, 9511],
              [1953, 9517],
              [1916, 9520],
              [1924, 9539],
              [1980, 9576],
              [2026, 9592],
              [2053, 9596],
              [2092, 9593],
              [2054, 9580],
              [2027, 9566],
              [2026, 9554],
              [2012, 9541],
              [2031, 9523],
              [2005, 9515],
              [2027, 9515],
              [2043, 9531],
              [2030, 9531],
              [2022, 9542],
              [2050, 9549],
              [2044, 9560],
              [2084, 9583],
              [2137, 9593],
              [2167, 9592],
              [2163, 9579],
              [2171, 9563],
              [2142, 9547],
              [2142, 9540],
              [2173, 9554],
              [2191, 9548],
              [2232, 9564],
              [2281, 9556],
              [2276, 9545],
              [2294, 9543],
              [2288, 9535],
              [2255, 9526],
              [2302, 9534],
              [2294, 9524],
              [2312, 9527],
              [2344, 9526],
              [2356, 9508],
              [2340, 9499],
              [2371, 9507],
              [2400, 9498],
              [2413, 9471],
              [2393, 9473],
              [2414, 9459],
              [2410, 9452],
              [2361, 9460],
              [2386, 9449],
            ],
          ],
          [
            [
              [1468, 9697],
              [1528, 9703],
              [1539, 9696],
              [1516, 9693],
              [1504, 9679],
              [1471, 9674],
              [1455, 9666],
              [1446, 9671],
              [1468, 9681],
              [1429, 9673],
              [1414, 9657],
              [1446, 9661],
              [1411, 9647],
              [1384, 9647],
              [1371, 9663],
              [1357, 9654],
              [1332, 9663],
              [1468, 9697],
            ],
          ],
          [
            [
              [2478, 8750],
              [2458, 8736],
              [2444, 8718],
              [2451, 8712],
              [2463, 8729],
              [2475, 8732],
              [2460, 8715],
              [2475, 8721],
              [2478, 8711],
              [2461, 8684],
              [2442, 8678],
              [2444, 8697],
              [2426, 8689],
              [2442, 8707],
              [2436, 8724],
              [2432, 8705],
              [2412, 8705],
              [2394, 8689],
              [2374, 8690],
              [2387, 8713],
              [2355, 8711],
              [2322, 8717],
              [2289, 8712],
              [2285, 8724],
              [2320, 8747],
              [2312, 8749],
              [2374, 8823],
              [2401, 8849],
              [2430, 8859],
              [2441, 8858],
              [2428, 8844],
              [2429, 8830],
              [2412, 8827],
              [2386, 8803],
              [2377, 8785],
              [2404, 8807],
              [2420, 8799],
              [2401, 8790],
              [2402, 8783],
              [2430, 8775],
              [2444, 8789],
              [2471, 8774],
              [2452, 8759],
              [2451, 8749],
              [2478, 8750],
            ],
          ],
          [
            [
              [1826, 9258],
              [1831, 9277],
              [1796, 9272],
              [1809, 9285],
              [1831, 9290],
              [1836, 9306],
              [1875, 9345],
              [1895, 9345],
              [1905, 9355],
              [1906, 9328],
              [1951, 9304],
              [1952, 9290],
              [1976, 9281],
              [1948, 9269],
              [1926, 9277],
              [1923, 9284],
              [1899, 9291],
              [1888, 9279],
              [1868, 9274],
              [1842, 9260],
              [1826, 9258],
            ],
          ],
          [
            [
              [1547, 9468],
              [1581, 9452],
              [1525, 9441],
              [1465, 9454],
              [1471, 9464],
              [1439, 9449],
              [1407, 9447],
              [1389, 9440],
              [1285, 9432],
              [1281, 9442],
              [1292, 9454],
              [1241, 9458],
              [1226, 9472],
              [1244, 9483],
              [1308, 9489],
              [1351, 9486],
              [1369, 9495],
              [1333, 9502],
              [1279, 9497],
              [1251, 9497],
              [1241, 9511],
              [1302, 9521],
              [1318, 9527],
              [1272, 9522],
              [1270, 9531],
              [1246, 9529],
              [1256, 9539],
              [1288, 9548],
              [1287, 9555],
              [1330, 9568],
              [1409, 9582],
              [1410, 9562],
              [1432, 9571],
              [1463, 9563],
              [1436, 9552],
              [1456, 9553],
              [1498, 9571],
              [1517, 9558],
              [1501, 9535],
              [1509, 9530],
              [1528, 9538],
              [1523, 9545],
              [1536, 9564],
              [1564, 9587],
              [1574, 9590],
              [1599, 9565],
              [1586, 9544],
              [1585, 9528],
              [1564, 9513],
              [1569, 9503],
              [1608, 9483],
              [1622, 9485],
              [1598, 9463],
              [1587, 9476],
              [1569, 9466],
              [1547, 9468],
            ],
          ],
          [
            [
              [1707, 9519],
              [1689, 9546],
              [1673, 9548],
              [1658, 9561],
              [1686, 9574],
              [1689, 9563],
              [1710, 9563],
              [1719, 9575],
              [1706, 9584],
              [1733, 9596],
              [1768, 9593],
              [1797, 9597],
              [1770, 9598],
              [1813, 9604],
              [1815, 9590],
              [1803, 9582],
              [1762, 9571],
              [1796, 9569],
              [1796, 9554],
              [1773, 9536],
              [1707, 9519],
            ],
          ],
          [
            [
              [1145, 9559],
              [1153, 9567],
              [1216, 9594],
              [1216, 9611],
              [1295, 9617],
              [1316, 9609],
              [1363, 9609],
              [1383, 9603],
              [1396, 9585],
              [1313, 9568],
              [1278, 9560],
              [1264, 9551],
              [1241, 9548],
              [1204, 9525],
              [1133, 9513],
              [1132, 9532],
              [1099, 9540],
              [1145, 9559],
            ],
          ],
          [
            [
              [1835, 9631],
              [1783, 9631],
              [1789, 9643],
              [1816, 9649],
              [1749, 9644],
              [1756, 9652],
              [1731, 9661],
              [1752, 9678],
              [1752, 9693],
              [1754, 9708],
              [1774, 9696],
              [1759, 9690],
              [1760, 9678],
              [1773, 9672],
              [1775, 9656],
              [1786, 9653],
              [1785, 9665],
              [1807, 9676],
              [1836, 9680],
              [1890, 9673],
              [1863, 9644],
              [1849, 9644],
              [1835, 9631],
            ],
          ],
          [
            [
              [1640, 9660],
              [1651, 9656],
              [1682, 9661],
              [1697, 9659],
              [1698, 9640],
              [1718, 9641],
              [1697, 9630],
              [1683, 9643],
              [1659, 9632],
              [1601, 9628],
              [1601, 9632],
              [1547, 9624],
              [1514, 9615],
              [1480, 9612],
              [1458, 9620],
              [1512, 9630],
              [1535, 9630],
              [1557, 9637],
              [1441, 9629],
              [1410, 9636],
              [1447, 9653],
              [1495, 9655],
              [1455, 9656],
              [1503, 9672],
              [1528, 9673],
              [1529, 9681],
              [1537, 9680],
              [1526, 9664],
              [1550, 9667],
              [1568, 9654],
              [1560, 9645],
              [1608, 9644],
              [1616, 9652],
              [1600, 9656],
              [1624, 9662],
              [1608, 9667],
              [1664, 9683],
              [1640, 9660],
            ],
          ],
          [
            [
              [2032, 9679],
              [2061, 9664],
              [2040, 9661],
              [2067, 9645],
              [2111, 9645],
              [2173, 9654],
              [2229, 9652],
              [2253, 9644],
              [2246, 9635],
              [2225, 9631],
              [2245, 9627],
              [2218, 9618],
              [2179, 9614],
              [2145, 9618],
              [2049, 9614],
              [2027, 9620],
              [2000, 9616],
              [1961, 9623],
              [1963, 9636],
              [1991, 9655],
              [1985, 9669],
              [1932, 9666],
              [1925, 9687],
              [1951, 9689],
              [1990, 9685],
              [1997, 9677],
              [2032, 9679],
            ],
          ],
          [
            [
              [1909, 9712],
              [1874, 9711],
              [1877, 9720],
              [1842, 9722],
              [1836, 9712],
              [1826, 9724],
              [1804, 9729],
              [1835, 9728],
              [1844, 9739],
              [1812, 9743],
              [1826, 9750],
              [1862, 9751],
              [1877, 9742],
              [1890, 9744],
              [1922, 9731],
              [1910, 9727],
              [1909, 9712],
            ],
          ],
          [
            [
              [2248, 9749],
              [2209, 9743],
              [2129, 9720],
              [2075, 9720],
              [2059, 9724],
              [2045, 9741],
              [2098, 9747],
              [2095, 9753],
              [2035, 9749],
              [2030, 9770],
              [2068, 9769],
              [2040, 9774],
              [2066, 9777],
              [2062, 9784],
              [2136, 9794],
              [2116, 9798],
              [2142, 9801],
              [2165, 9796],
              [2168, 9782],
              [2196, 9781],
              [2198, 9770],
              [2225, 9778],
              [2225, 9765],
              [2214, 9759],
              [2244, 9757],
              [2248, 9749],
            ],
          ],
          [
            [
              [2298, 9685],
              [2331, 9686],
              [2326, 9678],
              [2283, 9667],
              [2288, 9661],
              [2267, 9653],
              [2264, 9665],
              [2240, 9663],
              [2254, 9671],
              [2170, 9672],
              [2154, 9667],
              [2111, 9672],
              [2103, 9668],
              [2054, 9673],
              [2074, 9678],
              [2076, 9693],
              [2066, 9704],
              [2085, 9705],
              [2100, 9688],
              [2146, 9695],
              [2133, 9697],
              [2138, 9710],
              [2160, 9712],
              [2180, 9707],
              [2175, 9699],
              [2200, 9710],
              [2202, 9718],
              [2160, 9718],
              [2170, 9727],
              [2199, 9737],
              [2231, 9739],
              [2270, 9736],
              [2296, 9739],
              [2252, 9740],
              [2256, 9758],
              [2230, 9761],
              [2246, 9775],
              [2300, 9774],
              [2322, 9764],
              [2339, 9766],
              [2313, 9775],
              [2426, 9782],
              [2387, 9783],
              [2428, 9787],
              [2400, 9788],
              [2337, 9781],
              [2250, 9783],
              [2205, 9789],
              [2263, 9792],
              [2270, 9795],
              [2200, 9792],
              [2199, 9801],
              [2223, 9807],
              [2176, 9807],
              [2201, 9812],
              [2326, 9822],
              [2323, 9826],
              [2373, 9822],
              [2434, 9811],
              [2427, 9816],
              [2380, 9824],
              [2413, 9833],
              [2445, 9836],
              [2502, 9835],
              [2526, 9839],
              [2566, 9835],
              [2596, 9840],
              [2653, 9840],
              [2651, 9837],
              [2715, 9836],
              [2686, 9830],
              [2745, 9836],
              [2773, 9827],
              [2798, 9827],
              [2797, 9820],
              [2727, 9809],
              [2613, 9797],
              [2695, 9804],
              [2719, 9803],
              [2627, 9786],
              [2564, 9771],
              [2546, 9762],
              [2455, 9751],
              [2405, 9749],
              [2463, 9748],
              [2458, 9743],
              [2426, 9745],
              [2387, 9743],
              [2430, 9741],
              [2448, 9736],
              [2440, 9731],
              [2403, 9730],
              [2428, 9725],
              [2411, 9718],
              [2360, 9710],
              [2334, 9698],
              [2280, 9697],
              [2311, 9690],
              [2298, 9685],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'AR',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.46,
        'hc-middle-y': 0.33,
        'hc-key': 'ar',
        'hc-a2': 'AR',
        name: 'Argentina',
        labelrank: '2',
        'country-abbrev': 'Arg.',
        subregion: 'South America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'ARG',
        'iso-a2': 'AR',
        'woe-id': '23424747',
        continent: 'South America',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [1832, 5456],
              [1832, 5457],
              [1832, 5456],
              [1832, 5456],
            ],
          ],
          [
            [
              [2116, 4921],
              [2120, 4918],
              [2117, 4918],
              [2116, 4921],
            ],
          ],
          [
            [
              [2116, 4921],
              [2084, 4997],
              [2132, 4952],
              [2174, 4932],
              [2210, 4926],
              [2227, 4917],
              [2198, 4917],
              [2178, 4912],
              [2162, 4917],
              [2116, 4921],
            ],
          ],
          [
            [
              [2187, 5822],
              [2179, 5759],
              [2182, 5738],
              [2188, 5716],
              [2181, 5715],
              [2183, 5670],
              [2200, 5652],
              [2221, 5643],
              [2237, 5626],
              [2231, 5610],
              [2261, 5573],
              [2244, 5536],
              [2243, 5524],
              [2203, 5503],
              [2142, 5492],
              [2124, 5493],
              [2107, 5484],
              [2118, 5479],
              [2116, 5450],
              [2127, 5451],
              [2124, 5425],
              [2105, 5415],
              [2082, 5415],
              [2045, 5431],
              [2039, 5422],
              [2052, 5386],
              [2072, 5369],
              [2092, 5382],
              [2105, 5357],
              [2091, 5353],
              [2077, 5366],
              [2064, 5356],
              [2083, 5349],
              [2064, 5325],
              [2075, 5299],
              [2065, 5287],
              [2069, 5271],
              [2053, 5277],
              [2027, 5251],
              [2025, 5231],
              [2036, 5216],
              [2060, 5201],
              [2084, 5198],
              [2097, 5182],
              [2097, 5163],
              [2063, 5127],
              [2066, 5092],
              [2043, 5080],
              [2044, 5056],
              [2060, 5033],
              [2084, 5007],
              [2037, 5020],
              [1981, 5020],
              [1960, 5036],
              [1950, 5068],
              [1927, 5065],
              [1908, 5087],
              [1897, 5108],
              [1915, 5136],
              [1917, 5152],
              [1905, 5167],
              [1913, 5212],
              [1906, 5238],
              [1897, 5247],
              [1906, 5263],
              [1894, 5277],
              [1878, 5285],
              [1900, 5284],
              [1898, 5297],
              [1880, 5298],
              [1879, 5315],
              [1865, 5332],
              [1867, 5342],
              [1853, 5348],
              [1845, 5375],
              [1854, 5381],
              [1843, 5398],
              [1832, 5431],
              [1836, 5445],
              [1828, 5494],
              [1842, 5503],
              [1823, 5541],
              [1815, 5568],
              [1815, 5587],
              [1832, 5603],
              [1824, 5637],
              [1826, 5670],
              [1833, 5672],
              [1816, 5722],
              [1787, 5771],
              [1793, 5791],
              [1792, 5816],
              [1799, 5817],
              [1789, 5853],
              [1794, 5863],
              [1795, 5889],
              [1807, 5905],
              [1814, 5936],
              [1829, 5945],
              [1818, 5958],
              [1821, 5973],
              [1811, 5999],
              [1817, 6012],
              [1809, 6024],
              [1818, 6038],
              [1845, 6053],
              [1851, 6090],
              [1845, 6097],
              [1871, 6135],
              [1889, 6123],
              [1926, 6119],
              [1937, 6095],
              [1946, 6127],
              [1982, 6127],
              [1989, 6118],
              [2001, 6109],
              [2014, 6089],
              [2047, 6060],
              [2079, 6052],
              [2122, 6024],
              [2157, 6009],
              [2164, 5999],
              [2151, 5973],
              [2140, 5929],
              [2158, 5931],
              [2186, 5923],
              [2219, 5930],
              [2231, 5924],
              [2240, 5942],
              [2258, 5954],
              [2260, 5994],
              [2282, 5992],
              [2292, 5968],
              [2291, 5935],
              [2259, 5918],
              [2234, 5895],
              [2218, 5864],
              [2187, 5822],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'CL',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.62,
        'hc-middle-y': 0.91,
        'hc-key': 'cl',
        'hc-a2': 'CL',
        name: 'Chile',
        labelrank: '2',
        'country-abbrev': 'Chile',
        subregion: 'South America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'CHL',
        'iso-a2': 'CL',
        'woe-id': '23424782',
        continent: 'South America',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [1724, 6264],
              [1738, 6267],
              [1739, 6286],
              [1750, 6294],
              [1764, 6271],
              [1772, 6241],
              [1791, 6223],
              [1784, 6211],
              [1785, 6186],
              [1806, 6154],
              [1822, 6097],
              [1845, 6097],
              [1851, 6090],
              [1845, 6053],
              [1818, 6038],
              [1809, 6024],
              [1817, 6012],
              [1811, 5999],
              [1821, 5973],
              [1818, 5958],
              [1829, 5945],
              [1814, 5936],
              [1807, 5905],
              [1795, 5889],
              [1794, 5863],
              [1789, 5853],
              [1799, 5817],
              [1792, 5816],
              [1793, 5791],
              [1787, 5771],
              [1816, 5722],
              [1833, 5672],
              [1826, 5670],
              [1824, 5637],
              [1832, 5603],
              [1815, 5587],
              [1815, 5568],
              [1823, 5541],
              [1842, 5503],
              [1828, 5494],
              [1836, 5445],
              [1832, 5431],
              [1843, 5398],
              [1854, 5381],
              [1845, 5375],
              [1853, 5348],
              [1867, 5342],
              [1865, 5332],
              [1879, 5315],
              [1880, 5298],
              [1898, 5297],
              [1900, 5284],
              [1878, 5285],
              [1894, 5277],
              [1906, 5263],
              [1897, 5247],
              [1906, 5238],
              [1913, 5212],
              [1905, 5167],
              [1917, 5152],
              [1915, 5136],
              [1897, 5108],
              [1908, 5087],
              [1927, 5065],
              [1950, 5068],
              [1960, 5036],
              [1981, 5020],
              [2037, 5020],
              [2084, 5007],
              [2063, 5012],
              [2027, 4994],
              [2035, 4956],
              [2003, 4960],
              [1991, 4967],
              [2015, 4980],
              [2010, 4991],
              [1984, 4975],
              [1993, 4965],
              [1961, 4979],
              [1962, 4982],
              [1924, 5027],
              [1914, 5045],
              [1899, 5058],
              [1912, 5057],
              [1876, 5084],
              [1884, 5089],
              [1865, 5127],
              [1865, 5147],
              [1846, 5164],
              [1871, 5163],
              [1874, 5171],
              [1838, 5175],
              [1852, 5200],
              [1839, 5209],
              [1828, 5205],
              [1814, 5218],
              [1804, 5203],
              [1795, 5214],
              [1814, 5232],
              [1814, 5243],
              [1829, 5245],
              [1850, 5225],
              [1844, 5257],
              [1850, 5262],
              [1841, 5277],
              [1858, 5285],
              [1856, 5295],
              [1834, 5306],
              [1837, 5327],
              [1830, 5332],
              [1835, 5348],
              [1824, 5376],
              [1831, 5382],
              [1811, 5403],
              [1807, 5392],
              [1789, 5394],
              [1774, 5422],
              [1772, 5456],
              [1779, 5473],
              [1747, 5540],
              [1744, 5561],
              [1755, 5561],
              [1757, 5622],
              [1766, 5639],
              [1764, 5674],
              [1771, 5698],
              [1768, 5741],
              [1750, 5786],
              [1744, 5820],
              [1753, 5832],
              [1739, 5869],
              [1750, 5918],
              [1749, 5979],
              [1751, 6001],
              [1745, 6025],
              [1743, 6061],
              [1737, 6086],
              [1744, 6089],
              [1747, 6148],
              [1742, 6164],
              [1737, 6212],
              [1724, 6264],
            ],
            [
              [1962, 4982],
              [1963, 4981],
              [1971, 4992],
              [1971, 4992],
              [1971, 4992],
              [2000, 5000],
              [1978, 5001],
              [1971, 4992],
              [1971, 4992],
              [1971, 4992],
              [1965, 4990],
              [1962, 4982],
            ],
          ],
          [
            [
              [2178, 4907],
              [2162, 4903],
              [2138, 4906],
              [2130, 4917],
              [2155, 4916],
              [2178, 4907],
            ],
          ],
          [
            [
              [1877, 5074],
              [1897, 5066],
              [1899, 5048],
              [1880, 5033],
              [1894, 5056],
              [1873, 5063],
              [1889, 5065],
              [1877, 5074],
            ],
          ],
          [
            [
              [1962, 4964],
              [1972, 4971],
              [2004, 4956],
              [2008, 4944],
              [1977, 4945],
              [1962, 4964],
            ],
          ],
          [
            [
              [1800, 5371],
              [1809, 5356],
              [1811, 5334],
              [1789, 5340],
              [1790, 5360],
              [1783, 5387],
              [1795, 5392],
              [1807, 5373],
              [1800, 5371],
            ],
          ],
          [
            [
              [1808, 5292],
              [1809, 5305],
              [1823, 5309],
              [1818, 5295],
              [1830, 5290],
              [1825, 5278],
              [1834, 5268],
              [1834, 5248],
              [1818, 5268],
              [1816, 5281],
              [1797, 5288],
              [1808, 5292],
            ],
          ],
          [
            [
              [1826, 5170],
              [1837, 5171],
              [1863, 5130],
              [1878, 5094],
              [1862, 5064],
              [1855, 5085],
              [1862, 5095],
              [1841, 5105],
              [1842, 5118],
              [1855, 5118],
              [1830, 5129],
              [1823, 5143],
              [1826, 5170],
            ],
          ],
          [
            [
              [2085, 4912],
              [2087, 4918],
              [2114, 4914],
              [2136, 4904],
              [2147, 4893],
              [2164, 4893],
              [2172, 4884],
              [2157, 4882],
              [2138, 4895],
              [2094, 4899],
              [2085, 4912],
            ],
          ],
          [
            [
              [2084, 4997],
              [2116, 4921],
              [2114, 4922],
              [2116, 4921],
              [2117, 4918],
              [2087, 4922],
              [2069, 4913],
              [2037, 4931],
              [2034, 4940],
              [2008, 4945],
              [2010, 4954],
              [2045, 4945],
              [2047, 4964],
              [2063, 4937],
              [2101, 4934],
              [2066, 4946],
              [2058, 4958],
              [2074, 4972],
              [2052, 4968],
              [2039, 4984],
              [2055, 4992],
              [2059, 5004],
              [2084, 4997],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'CV',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.57,
        'hc-middle-y': 0.5,
        'hc-key': 'cv',
        'hc-a2': 'CV',
        name: 'Cape Verde',
        labelrank: '4',
        'country-abbrev': 'C.Vd.',
        subregion: 'Western Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'CPV',
        'iso-a2': 'CV',
        'woe-id': '23424794',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3232, 7517],
            [3239, 7510],
            [3240, 7502],
            [3231, 7506],
            [3232, 7517],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'DM',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.54,
        'hc-middle-y': 0.48,
        'hc-key': 'dm',
        'hc-a2': 'DM',
        name: 'Dominica',
        labelrank: '6',
        'country-abbrev': "D'inca",
        subregion: 'Caribbean',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'DMA',
        'iso-a2': 'DM',
        'woe-id': '23424798',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [2007, 7527],
            [2011, 7520],
            [2007, 7513],
            [2004, 7523],
            [2007, 7527],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SC',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.59,
        'hc-middle-y': 0.79,
        'hc-key': 'sc',
        'hc-a2': 'SC',
        name: 'Seychelles',
        labelrank: '6',
        'country-abbrev': 'Syc.',
        subregion: 'Eastern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'SYC',
        'iso-a2': 'SC',
        'woe-id': '23424941',
        continent: 'Seven seas (open ocean)',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5527, 6599],
            [5527, 6595],
            [5519, 6594],
            [5526, 6597],
            [5527, 6599],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'JM',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.5,
        'hc-middle-y': 0.5,
        'hc-key': 'jm',
        'hc-a2': 'JM',
        name: 'Jamaica',
        labelrank: '4',
        'country-abbrev': 'Jam.',
        subregion: 'Caribbean',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'JAM',
        'iso-a2': 'JM',
        'woe-id': '23424858',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1497, 7634],
            [1514, 7632],
            [1535, 7614],
            [1514, 7616],
            [1501, 7606],
            [1484, 7611],
            [1472, 7634],
            [1497, 7634],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'OM',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.83,
        'hc-middle-y': 0.45,
        'hc-key': 'om',
        'hc-a2': 'OM',
        name: 'Oman',
        labelrank: '4',
        'country-abbrev': 'Oman',
        subregion: 'Western Asia',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'OMN',
        'iso-a2': 'OM',
        'woe-id': '23424898',
        continent: 'Asia',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [5805, 7886],
              [5804, 7885],
              [5803, 7889],
              [5807, 7888],
              [5805, 7886],
            ],
          ],
          [
            [
              [5795, 7917],
              [5803, 7929],
              [5804, 7901],
              [5799, 7902],
              [5795, 7917],
            ],
          ],
          [
            [
              [5730, 7566],
              [5716, 7591],
              [5687, 7654],
              [5781, 7691],
              [5796, 7765],
              [5779, 7792],
              [5792, 7849],
              [5791, 7873],
              [5800, 7867],
              [5810, 7877],
              [5819, 7859],
              [5838, 7838],
              [5891, 7823],
              [5930, 7774],
              [5917, 7745],
              [5898, 7722],
              [5908, 7710],
              [5899, 7705],
              [5880, 7712],
              [5870, 7681],
              [5877, 7655],
              [5857, 7651],
              [5840, 7639],
              [5832, 7614],
              [5803, 7611],
              [5792, 7580],
              [5761, 7580],
              [5730, 7566],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'VC',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.48,
        'hc-middle-y': 0.5,
        'hc-key': 'vc',
        'hc-a2': 'VC',
        name: 'Saint Vincent and the Grenadines',
        labelrank: '6',
        'country-abbrev': 'St.V.G.',
        subregion: 'Caribbean',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'VCT',
        'iso-a2': 'VC',
        'woe-id': '23424981',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [2007, 7432],
            [2005, 7439],
            [2010, 7444],
            [2009, 7437],
            [2007, 7432],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SB',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.79,
        'hc-middle-y': 0.57,
        'hc-key': 'sb',
        'hc-a2': 'SB',
        name: 'Solomon Islands',
        labelrank: '3',
        'country-abbrev': 'S. Is.',
        subregion: 'Melanesia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'SLB',
        'iso-a2': 'SB',
        'woe-id': '23424766',
        continent: 'Oceania',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [9290, 6588],
              [9276, 6606],
              [9270, 6636],
              [9282, 6627],
              [9291, 6592],
              [9296, 6588],
              [9289, 6566],
              [9310, 6557],
              [9314, 6544],
              [9299, 6547],
              [9284, 6562],
              [9290, 6588],
            ],
          ],
          [
            [
              [9218, 6607],
              [9234, 6600],
              [9250, 6610],
              [9271, 6584],
              [9265, 6576],
              [9239, 6582],
              [9233, 6598],
              [9218, 6607],
            ],
          ],
          [
            [
              [9148, 6644],
              [9138, 6645],
              [9142, 6665],
              [9170, 6650],
              [9191, 6618],
              [9148, 6644],
            ],
          ],
          [
            [
              [9179, 6668],
              [9159, 6673],
              [9140, 6696],
              [9158, 6690],
              [9162, 6679],
              [9181, 6668],
              [9212, 6664],
              [9245, 6636],
              [9246, 6628],
              [9214, 6649],
              [9206, 6661],
              [9179, 6668],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'LC',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.51,
        'hc-middle-y': 0.48,
        'hc-key': 'lc',
        'hc-a2': 'LC',
        name: 'Saint Lucia',
        labelrank: '6',
        'country-abbrev': 'S.L.',
        subregion: 'Caribbean',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'LCA',
        'iso-a2': 'LC',
        'woe-id': '23424951',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [2017, 7457],
            [2013, 7463],
            [2018, 7472],
            [2019, 7466],
            [2017, 7457],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NO',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.11,
        'hc-middle-y': 0.92,
        'hc-key': 'no',
        'hc-a2': 'NO',
        name: 'Norway',
        labelrank: '3',
        'country-abbrev': 'Nor.',
        subregion: 'Northern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'NOR',
        'iso-a2': 'NO',
        'woe-id': '-90',
        continent: 'Europe',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [4448, 9720],
              [4428, 9728],
              [4467, 9731],
              [4477, 9720],
              [4522, 9710],
              [4502, 9695],
              [4484, 9695],
              [4490, 9703],
              [4450, 9700],
              [4462, 9713],
              [4448, 9720],
            ],
          ],
          [
            [
              [4736, 9473],
              [4718, 9460],
              [4697, 9449],
              [4697, 9469],
              [4665, 9481],
              [4633, 9477],
              [4622, 9470],
              [4619, 9444],
              [4603, 9434],
              [4578, 9442],
              [4562, 9436],
              [4543, 9439],
              [4521, 9457],
              [4498, 9449],
              [4486, 9428],
              [4442, 9433],
              [4439, 9416],
              [4423, 9420],
              [4398, 9398],
              [4406, 9386],
              [4384, 9368],
              [4387, 9361],
              [4364, 9356],
              [4366, 9330],
              [4347, 9306],
              [4359, 9302],
              [4357, 9287],
              [4325, 9285],
              [4310, 9263],
              [4321, 9230],
              [4319, 9211],
              [4339, 9199],
              [4324, 9186],
              [4335, 9169],
              [4333, 9156],
              [4317, 9148],
              [4314, 9115],
              [4308, 9118],
              [4302, 9119],
              [4293, 9121],
              [4285, 9133],
              [4269, 9117],
              [4263, 9119],
              [4232, 9093],
              [4209, 9085],
              [4179, 9088],
              [4150, 9110],
              [4153, 9122],
              [4142, 9136],
              [4153, 9155],
              [4134, 9162],
              [4134, 9190],
              [4145, 9206],
              [4129, 9215],
              [4148, 9231],
              [4174, 9239],
              [4185, 9253],
              [4211, 9257],
              [4230, 9270],
              [4211, 9265],
              [4214, 9276],
              [4227, 9280],
              [4237, 9270],
              [4251, 9275],
              [4262, 9264],
              [4278, 9274],
              [4257, 9271],
              [4246, 9279],
              [4260, 9285],
              [4270, 9301],
              [4301, 9313],
              [4276, 9315],
              [4300, 9319],
              [4316, 9333],
              [4309, 9353],
              [4339, 9360],
              [4325, 9364],
              [4355, 9399],
              [4378, 9421],
              [4401, 9418],
              [4396, 9428],
              [4398, 9430],
              [4379, 9431],
              [4364, 9424],
              [4320, 9420],
              [4360, 9430],
              [4350, 9438],
              [4375, 9445],
              [4402, 9447],
              [4400, 9432],
              [4412, 9444],
              [4423, 9444],
              [4408, 9461],
              [4429, 9467],
              [4436, 9459],
              [4446, 9483],
              [4490, 9487],
              [4506, 9476],
              [4525, 9473],
              [4505, 9486],
              [4534, 9489],
              [4530, 9501],
              [4555, 9504],
              [4571, 9496],
              [4584, 9509],
              [4606, 9515],
              [4611, 9506],
              [4594, 9495],
              [4599, 9482],
              [4629, 9509],
              [4629, 9491],
              [4647, 9507],
              [4672, 9510],
              [4659, 9494],
              [4669, 9492],
              [4678, 9506],
              [4708, 9502],
              [4737, 9488],
              [4717, 9482],
              [4683, 9485],
              [4718, 9474],
              [4736, 9473],
            ],
          ],
          [
            [
              [4360, 9712],
              [4301, 9707],
              [4292, 9716],
              [4322, 9718],
              [4337, 9724],
              [4314, 9735],
              [4314, 9725],
              [4277, 9722],
              [4256, 9731],
              [4261, 9721],
              [4238, 9727],
              [4225, 9739],
              [4241, 9741],
              [4225, 9761],
              [4291, 9756],
              [4303, 9763],
              [4348, 9739],
              [4327, 9764],
              [4338, 9769],
              [4391, 9756],
              [4398, 9746],
              [4421, 9743],
              [4453, 9738],
              [4403, 9727],
              [4393, 9701],
              [4383, 9701],
              [4368, 9675],
              [4314, 9692],
              [4301, 9702],
              [4360, 9712],
            ],
          ],
          [
            [
              [4503, 9747],
              [4477, 9753],
              [4412, 9750],
              [4409, 9758],
              [4454, 9760],
              [4454, 9763],
              [4390, 9761],
              [4390, 9768],
              [4367, 9771],
              [4377, 9777],
              [4398, 9770],
              [4419, 9784],
              [4430, 9773],
              [4449, 9774],
              [4462, 9768],
              [4466, 9780],
              [4485, 9771],
              [4497, 9780],
              [4509, 9774],
              [4551, 9772],
              [4562, 9765],
              [4549, 9760],
              [4564, 9732],
              [4540, 9755],
              [4503, 9747],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'KN',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.59,
        'hc-middle-y': 0.5,
        'hc-key': 'kn',
        'hc-a2': 'KN',
        name: 'Saint Kitts and Nevis',
        labelrank: '6',
        'country-abbrev': 'St.K.N.',
        subregion: 'Caribbean',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'KNA',
        'iso-a2': 'KN',
        'woe-id': '23424940',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1973, 7587],
            [1965, 7593],
            [1966, 7595],
            [1970, 7592],
            [1973, 7587],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'BH',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.56,
        'hc-middle-y': 0.5,
        'hc-key': 'bh',
        'hc-a2': 'BH',
        name: 'Bahrain',
        labelrank: '4',
        'country-abbrev': 'Bahr.',
        subregion: 'Western Asia',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'BHR',
        'iso-a2': 'BH',
        'woe-id': '23424753',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5616, 7924],
            [5621, 7922],
            [5620, 7907],
            [5616, 7914],
            [5616, 7924],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'ID',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.39,
        'hc-middle-y': 0.4,
        'hc-key': 'id',
        'hc-a2': 'ID',
        name: 'Indonesia',
        labelrank: '2',
        'country-abbrev': 'Indo.',
        subregion: 'South-Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'IDN',
        'iso-a2': 'ID',
        'woe-id': '23424846',
        continent: 'Asia',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [7937, 6598],
              [7951, 6587],
              [7961, 6571],
              [7948, 6562],
              [7922, 6582],
              [7904, 6586],
              [7912, 6598],
              [7937, 6598],
            ],
          ],
          [
            [
              [7832, 6634],
              [7813, 6614],
              [7809, 6632],
              [7821, 6641],
              [7832, 6634],
            ],
          ],
          [
            [
              [7793, 6623],
              [7781, 6618],
              [7758, 6645],
              [7782, 6646],
              [7798, 6636],
              [7793, 6623],
            ],
          ],
          [
            [
              [8164, 6661],
              [8152, 6650],
              [8137, 6661],
              [8161, 6661],
              [8183, 6667],
              [8197, 6645],
              [8189, 6641],
              [8183, 6662],
              [8164, 6661],
            ],
          ],
          [
            [
              [8556, 6643],
              [8558, 6633],
              [8517, 6633],
              [8532, 6662],
              [8558, 6672],
              [8567, 6664],
              [8556, 6643],
            ],
          ],
          [
            [
              [8328, 6682],
              [8323, 6663],
              [8306, 6643],
              [8306, 6663],
              [8328, 6682],
            ],
          ],
          [
            [
              [7754, 6683],
              [7730, 6677],
              [7703, 6680],
              [7709, 6690],
              [7746, 6690],
              [7754, 6683],
            ],
          ],
          [
            [
              [8013, 6744],
              [8021, 6748],
              [8025, 6770],
              [8037, 6773],
              [8029, 6744],
              [8013, 6744],
            ],
          ],
          [
            [
              [8065, 6750],
              [8052, 6750],
              [8038, 6735],
              [8030, 6741],
              [8043, 6780],
              [8043, 6754],
              [8065, 6750],
            ],
          ],
          [
            [
              [8176, 6831],
              [8187, 6812],
              [8170, 6803],
              [8152, 6812],
              [8148, 6828],
              [8176, 6831],
            ],
          ],
          [
            [
              [7538, 6838],
              [7545, 6851],
              [7558, 6850],
              [7562, 6830],
              [7543, 6826],
              [7538, 6838],
            ],
          ],
          [
            [
              [8127, 6879],
              [8160, 6879],
              [8144, 6869],
              [8136, 6875],
              [8095, 6872],
              [8096, 6884],
              [8127, 6879],
            ],
          ],
          [
            [
              [7280, 6871],
              [7308, 6834],
              [7293, 6841],
              [7293, 6854],
              [7257, 6884],
              [7248, 6902],
              [7257, 6912],
              [7269, 6880],
              [7280, 6871],
            ],
          ],
          [
            [
              [8296, 6927],
              [8295, 6942],
              [8308, 6946],
              [8324, 6940],
              [8322, 6932],
              [8302, 6927],
              [8316, 6906],
              [8292, 6883],
              [8284, 6869],
              [8271, 6876],
              [8288, 6882],
              [8306, 6900],
              [8295, 6913],
              [8296, 6927],
            ],
          ],
          [
            [
              [7433, 6987],
              [7452, 6985],
              [7434, 6976],
              [7451, 6939],
              [7438, 6922],
              [7434, 6929],
              [7446, 6950],
              [7427, 6991],
              [7433, 6987],
            ],
          ],
          [
            [
              [7208, 7003],
              [7226, 6983],
              [7219, 6968],
              [7197, 6999],
              [7208, 7003],
            ],
          ],
          [
            [
              [7514, 6836],
              [7490, 6841],
              [7483, 6866],
              [7468, 6867],
              [7470, 6885],
              [7493, 6887],
              [7502, 6855],
              [7518, 6851],
              [7514, 6836],
            ],
          ],
          [
            [
              [8418, 6712],
              [8427, 6704],
              [8408, 6689],
              [8404, 6694],
              [8409, 6723],
              [8422, 6744],
              [8430, 6735],
              [8427, 6711],
              [8418, 6712],
            ],
          ],
          [
            [
              [7375, 6982],
              [7361, 7007],
              [7376, 7002],
              [7375, 6986],
              [7394, 6985],
              [7396, 6975],
              [7375, 6982],
            ],
          ],
          [
            [
              [7859, 6634],
              [7857, 6642],
              [7879, 6643],
              [7884, 6635],
              [7906, 6637],
              [7907, 6625],
              [7887, 6616],
              [7839, 6607],
              [7831, 6611],
              [7835, 6630],
              [7859, 6634],
            ],
          ],
          [
            [
              [8205, 6826],
              [8212, 6838],
              [8264, 6843],
              [8298, 6830],
              [8305, 6809],
              [8323, 6796],
              [8263, 6824],
              [8261, 6817],
              [8242, 6827],
              [8231, 6813],
              [8210, 6806],
              [8205, 6826],
            ],
          ],
          [
            [
              [8082, 6605],
              [8086, 6605],
              [8099, 6613],
              [8099, 6603],
              [8102, 6593],
              [8079, 6569],
              [8057, 6560],
              [8045, 6562],
              [8045, 6562],
              [8045, 6562],
              [8056, 6588],
              [8068, 6599],
              [8075, 6593],
              [8082, 6605],
            ],
          ],
          [
            [
              [7873, 7101],
              [7879, 7101],
              [7870, 7098],
              [7877, 7080],
              [7853, 7082],
              [7873, 7074],
              [7863, 7069],
              [7888, 7031],
              [7881, 7017],
              [7919, 6985],
              [7913, 6976],
              [7892, 6979],
              [7878, 6974],
              [7871, 6957],
              [7868, 6927],
              [7854, 6902],
              [7838, 6891],
              [7833, 6864],
              [7839, 6865],
              [7827, 6834],
              [7832, 6819],
              [7821, 6796],
              [7817, 6813],
              [7772, 6791],
              [7772, 6809],
              [7760, 6821],
              [7740, 6818],
              [7740, 6828],
              [7720, 6829],
              [7704, 6818],
              [7693, 6822],
              [7680, 6815],
              [7678, 6843],
              [7643, 6832],
              [7630, 6835],
              [7621, 6905],
              [7588, 6886],
              [7609, 6913],
              [7595, 6927],
              [7596, 6951],
              [7586, 6977],
              [7592, 7004],
              [7611, 7024],
              [7611, 7006],
              [7641, 6978],
              [7662, 6986],
              [7673, 6982],
              [7692, 6989],
              [7694, 7000],
              [7720, 7005],
              [7742, 6992],
              [7751, 7000],
              [7771, 7000],
              [7781, 7017],
              [7779, 7030],
              [7793, 7039],
              [7788, 7052],
              [7801, 7059],
              [7805, 7102],
              [7811, 7110],
              [7829, 7106],
              [7856, 7109],
              [7868, 7101],
              [7870, 7098],
              [7873, 7101],
            ],
          ],
          [
            [
              [8640, 6850],
              [8633, 6710],
              [8624, 6607],
              [8593, 6644],
              [8559, 6638],
              [8567, 6665],
              [8554, 6678],
              [8570, 6677],
              [8552, 6688],
              [8559, 6698],
              [8550, 6708],
              [8531, 6751],
              [8501, 6763],
              [8472, 6779],
              [8448, 6780],
              [8420, 6802],
              [8408, 6803],
              [8398, 6817],
              [8384, 6795],
              [8373, 6794],
              [8371, 6824],
              [8350, 6846],
              [8369, 6842],
              [8384, 6856],
              [8405, 6848],
              [8411, 6857],
              [8388, 6864],
              [8368, 6860],
              [8348, 6868],
              [8340, 6887],
              [8326, 6894],
              [8313, 6892],
              [8322, 6916],
              [8343, 6921],
              [8350, 6929],
              [8370, 6933],
              [8393, 6919],
              [8412, 6919],
              [8422, 6896],
              [8415, 6867],
              [8426, 6840],
              [8429, 6855],
              [8442, 6822],
              [8454, 6820],
              [8473, 6835],
              [8490, 6863],
              [8516, 6868],
              [8506, 6879],
              [8486, 6875],
              [8461, 6884],
              [8474, 6885],
              [8471, 6915],
              [8485, 6907],
              [8484, 6885],
              [8515, 6879],
              [8538, 6892],
              [8604, 6858],
              [8614, 6860],
              [8640, 6850],
            ],
          ],
          [
            [
              [8045, 6561],
              [8045, 6562],
              [8045, 6562],
              [8045, 6562],
              [8045, 6562],
              [8045, 6561],
              [8045, 6561],
            ],
          ],
          [
            [
              [8045, 6561],
              [8043, 6549],
              [8024, 6540],
              [8043, 6558],
              [8045, 6561],
              [8045, 6561],
            ],
          ],
          [
            [
              [7139, 7157],
              [7171, 7141],
              [7207, 7142],
              [7221, 7128],
              [7234, 7102],
              [7284, 7065],
              [7291, 7047],
              [7325, 7016],
              [7320, 7029],
              [7340, 7017],
              [7348, 7026],
              [7351, 7008],
              [7364, 6998],
              [7378, 6974],
              [7405, 6966],
              [7419, 6946],
              [7407, 6938],
              [7418, 6933],
              [7405, 6919],
              [7419, 6909],
              [7438, 6908],
              [7443, 6877],
              [7453, 6861],
              [7478, 6856],
              [7492, 6825],
              [7487, 6804],
              [7480, 6736],
              [7472, 6730],
              [7463, 6743],
              [7460, 6732],
              [7443, 6726],
              [7418, 6755],
              [7367, 6798],
              [7365, 6811],
              [7345, 6826],
              [7321, 6866],
              [7322, 6876],
              [7304, 6916],
              [7286, 6945],
              [7266, 6956],
              [7265, 6969],
              [7245, 7018],
              [7226, 7031],
              [7205, 7022],
              [7176, 7034],
              [7151, 7050],
              [7154, 7056],
              [7177, 7034],
              [7205, 7028],
              [7216, 7036],
              [7214, 7053],
              [7185, 7086],
              [7174, 7089],
              [7140, 7126],
              [7132, 7143],
              [7139, 7157],
            ],
          ],
          [
            [
              [7946, 6637],
              [7971, 6636],
              [7988, 6626],
              [7995, 6635],
              [8013, 6625],
              [8036, 6640],
              [8064, 6642],
              [8072, 6637],
              [8086, 6643],
              [8106, 6643],
              [8106, 6635],
              [8072, 6628],
              [8063, 6638],
              [8051, 6626],
              [7984, 6619],
              [7968, 6614],
              [7957, 6619],
              [7935, 6616],
              [7917, 6621],
              [7946, 6637],
            ],
          ],
          [
            [
              [7483, 6693],
              [7467, 6693],
              [7487, 6727],
              [7511, 6719],
              [7520, 6726],
              [7540, 6714],
              [7562, 6714],
              [7569, 6695],
              [7630, 6688],
              [7639, 6706],
              [7653, 6697],
              [7664, 6700],
              [7683, 6689],
              [7695, 6691],
              [7704, 6666],
              [7722, 6656],
              [7745, 6663],
              [7759, 6655],
              [7752, 6626],
              [7720, 6637],
              [7699, 6632],
              [7670, 6639],
              [7667, 6635],
              [7624, 6646],
              [7592, 6659],
              [7558, 6655],
              [7528, 6667],
              [7499, 6670],
              [7501, 6684],
              [7483, 6693],
            ],
          ],
          [
            [
              [8041, 6781],
              [8017, 6778],
              [8015, 6766],
              [7996, 6773],
              [8002, 6794],
              [7979, 6815],
              [7986, 6844],
              [7977, 6849],
              [7957, 6836],
              [7964, 6825],
              [7962, 6773],
              [7956, 6741],
              [7931, 6736],
              [7925, 6745],
              [7936, 6786],
              [7926, 6819],
              [7914, 6814],
              [7911, 6848],
              [7922, 6855],
              [7930, 6873],
              [7929, 6900],
              [7943, 6923],
              [7945, 6955],
              [7954, 6974],
              [7971, 6976],
              [7982, 6997],
              [8006, 6986],
              [8082, 6977],
              [8103, 6991],
              [8120, 7013],
              [8125, 6999],
              [8094, 6961],
              [8059, 6958],
              [8053, 6966],
              [8011, 6962],
              [7965, 6964],
              [7952, 6938],
              [7955, 6922],
              [7974, 6894],
              [7988, 6894],
              [8007, 6929],
              [8025, 6918],
              [8065, 6922],
              [8056, 6898],
              [8046, 6887],
              [8041, 6905],
              [8030, 6891],
              [8002, 6875],
              [8017, 6846],
              [8031, 6829],
              [8024, 6821],
              [8036, 6794],
              [8048, 6798],
              [8041, 6781],
            ],
          ],
          [
            [
              [8215, 6995],
              [8203, 6984],
              [8209, 6976],
              [8229, 7004],
              [8238, 7005],
              [8238, 6986],
              [8225, 6980],
              [8243, 6956],
              [8215, 6964],
              [8212, 6946],
              [8227, 6915],
              [8206, 6936],
              [8210, 6920],
              [8200, 6903],
              [8220, 6885],
              [8194, 6886],
              [8197, 6916],
              [8187, 6918],
              [8205, 6938],
              [8205, 6952],
              [8195, 6991],
              [8211, 7027],
              [8232, 7044],
              [8230, 7023],
              [8215, 7010],
              [8215, 6995],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'MU',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.6,
        'hc-middle-y': 0.58,
        'hc-key': 'mu',
        'hc-a2': 'MU',
        name: 'Mauritius',
        labelrank: '5',
        'country-abbrev': 'Mus.',
        subregion: 'Eastern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'MUS',
        'iso-a2': 'MU',
        'woe-id': '23424894',
        continent: 'Seven seas (open ocean)',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5869, 6198],
            [5867, 6184],
            [5857, 6183],
            [5864, 6201],
            [5869, 6198],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SE',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.47,
        'hc-middle-y': 0.62,
        'hc-key': 'se',
        'hc-a2': 'SE',
        name: 'Sweden',
        labelrank: '3',
        'country-abbrev': 'Swe.',
        subregion: 'Northern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'SWE',
        'iso-a2': 'SE',
        'woe-id': '23424954',
        continent: 'Europe',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [4515, 9080],
              [4514, 9063],
              [4500, 9047],
              [4492, 9068],
              [4515, 9080],
            ],
          ],
          [
            [
              [4498, 9449],
              [4536, 9432],
              [4554, 9429],
              [4578, 9415],
              [4575, 9400],
              [4593, 9378],
              [4587, 9366],
              [4603, 9347],
              [4579, 9343],
              [4558, 9346],
              [4562, 9334],
              [4546, 9329],
              [4535, 9309],
              [4548, 9302],
              [4530, 9282],
              [4490, 9260],
              [4462, 9237],
              [4450, 9205],
              [4451, 9187],
              [4466, 9170],
              [4473, 9173],
              [4506, 9149],
              [4495, 9121],
              [4488, 9122],
              [4455, 9105],
              [4446, 9080],
              [4454, 9065],
              [4454, 9045],
              [4462, 9060],
              [4453, 9023],
              [4445, 9037],
              [4436, 9017],
              [4407, 9020],
              [4392, 9008],
              [4393, 8993],
              [4360, 8993],
              [4345, 9024],
              [4353, 9037],
              [4339, 9046],
              [4319, 9074],
              [4320, 9088],
              [4304, 9096],
              [4302, 9119],
              [4301, 9121],
              [4308, 9118],
              [4314, 9115],
              [4317, 9148],
              [4333, 9156],
              [4335, 9169],
              [4324, 9186],
              [4339, 9199],
              [4319, 9211],
              [4321, 9230],
              [4310, 9263],
              [4325, 9285],
              [4357, 9287],
              [4359, 9302],
              [4347, 9306],
              [4366, 9330],
              [4364, 9356],
              [4387, 9361],
              [4384, 9368],
              [4406, 9386],
              [4398, 9398],
              [4423, 9420],
              [4439, 9416],
              [4442, 9433],
              [4486, 9428],
              [4498, 9449],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'RU',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.86,
        'hc-middle-y': 0.48,
        'hc-key': 'ru',
        'hc-a2': 'RU',
        name: 'Russia',
        labelrank: '2',
        'country-abbrev': 'Rus.',
        subregion: 'Eastern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'RUS',
        'iso-a2': 'RU',
        'woe-id': '23424936',
        continent: 'Europe',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [8395, 8641],
              [8369, 8626],
              [8352, 8596],
              [8364, 8576],
              [8357, 8573],
              [8349, 8596],
              [8332, 8590],
              [8328, 8570],
              [8321, 8574],
              [8325, 8599],
              [8340, 8597],
              [8352, 8606],
              [8351, 8623],
              [8373, 8637],
              [8395, 8641],
            ],
          ],
          [
            [
              [8423, 8830],
              [8444, 8833],
              [8449, 8825],
              [8440, 8806],
              [8445, 8777],
              [8442, 8760],
              [8436, 8788],
              [8436, 8815],
              [8423, 8830],
            ],
          ],
          [
            [
              [5204, 9447],
              [5171, 9440],
              [5156, 9456],
              [5176, 9464],
              [5201, 9456],
              [5204, 9447],
            ],
          ],
          [
            [
              [5402, 9490],
              [5434, 9478],
              [5439, 9471],
              [5418, 9471],
              [5388, 9482],
              [5382, 9490],
              [5402, 9490],
            ],
          ],
          [
            [
              [8209, 9510],
              [8191, 9504],
              [8171, 9518],
              [8181, 9527],
              [8209, 9510],
            ],
          ],
          [
            [
              [-140, 9528],
              [-127, 9518],
              [-149, 9512],
              [-188, 9508],
              [-199, 9510],
              [-171, 9527],
              [-140, 9528],
            ],
          ],
          [
            [
              [5165, 9776],
              [5168, 9769],
              [5142, 9770],
              [5159, 9780],
              [5209, 9776],
              [5205, 9768],
              [5165, 9776],
            ],
          ],
          [
            [
              [5112, 9780],
              [5095, 9772],
              [5095, 9789],
              [5113, 9785],
              [5112, 9780],
            ],
          ],
          [
            [
              [5157, 9808],
              [5183, 9811],
              [5183, 9802],
              [5147, 9796],
              [5184, 9793],
              [5194, 9787],
              [5144, 9783],
              [5147, 9788],
              [5107, 9792],
              [5130, 9793],
              [5157, 9808],
            ],
          ],
          [
            [
              [5301, 9797],
              [5322, 9790],
              [5280, 9784],
              [5265, 9788],
              [5301, 9797],
            ],
          ],
          [
            [
              [7166, 9598],
              [7145, 9607],
              [7157, 9609],
              [7180, 9597],
              [7199, 9598],
              [7247, 9587],
              [7257, 9576],
              [7183, 9585],
              [7166, 9598],
            ],
          ],
          [
            [
              [7324, 9635],
              [7345, 9627],
              [7296, 9624],
              [7228, 9637],
              [7220, 9647],
              [7247, 9640],
              [7271, 9642],
              [7285, 9636],
              [7324, 9635],
            ],
          ],
          [
            [
              [6187, 9738],
              [6213, 9729],
              [6207, 9724],
              [6137, 9720],
              [6120, 9714],
              [6101, 9716],
              [6102, 9748],
              [6118, 9753],
              [6142, 9743],
              [6157, 9746],
              [6187, 9738],
            ],
          ],
          [
            [
              [5923, 9766],
              [5908, 9759],
              [5871, 9764],
              [5867, 9775],
              [5885, 9780],
              [5875, 9792],
              [5921, 9799],
              [5983, 9785],
              [5970, 9784],
              [5983, 9773],
              [5933, 9771],
              [5923, 9766],
            ],
          ],
          [
            [
              [7909, 8527],
              [7900, 8535],
              [7915, 8539],
              [7910, 8561],
              [7896, 8582],
              [7869, 8610],
              [7891, 8628],
              [7902, 8610],
              [7918, 8599],
              [7919, 8622],
              [7926, 8624],
              [7919, 8661],
              [7922, 8665],
              [7905, 8701],
              [7911, 8719],
              [7897, 8738],
              [7884, 8742],
              [7853, 8732],
              [7847, 8718],
              [7805, 8717],
              [7785, 8731],
              [7783, 8739],
              [7752, 8760],
              [7713, 8780],
              [7673, 8785],
              [7651, 8793],
              [7642, 8809],
              [7601, 8839],
              [7596, 8848],
              [7562, 8873],
              [7561, 8878],
              [7516, 8908],
              [7488, 8912],
              [7463, 8922],
              [7430, 8929],
              [7371, 8918],
              [7362, 8900],
              [7387, 8892],
              [7400, 8877],
              [7393, 8861],
              [7399, 8814],
              [7408, 8802],
              [7394, 8800],
              [7378, 8783],
              [7340, 8795],
              [7322, 8802],
              [7302, 8797],
              [7261, 8811],
              [7241, 8794],
              [7242, 8786],
              [7198, 8778],
              [7185, 8770],
              [7135, 8777],
              [7118, 8777],
              [7093, 8789],
              [7088, 8799],
              [7066, 8801],
              [7043, 8813],
              [7002, 8818],
              [6962, 8806],
              [6912, 8823],
              [6895, 8848],
              [6839, 8863],
              [6824, 8863],
              [6784, 8878],
              [6774, 8854],
              [6777, 8837],
              [6801, 8820],
              [6804, 8803],
              [6789, 8791],
              [6742, 8802],
              [6734, 8797],
              [6705, 8802],
              [6685, 8821],
              [6637, 8825],
              [6625, 8832],
              [6606, 8818],
              [6565, 8798],
              [6571, 8791],
              [6552, 8781],
              [6532, 8781],
              [6526, 8771],
              [6518, 8769],
              [6514, 8768],
              [6484, 8787],
              [6474, 8782],
              [6446, 8786],
              [6430, 8804],
              [6406, 8810],
              [6383, 8832],
              [6370, 8837],
              [6337, 8827],
              [6318, 8827],
              [6302, 8844],
              [6287, 8848],
              [6275, 8830],
              [6249, 8855],
              [6174, 8918],
              [6125, 8943],
              [6121, 8959],
              [6086, 8937],
              [6067, 8930],
              [6038, 8932],
              [6041, 8942],
              [6010, 8949],
              [5974, 8948],
              [5965, 8969],
              [5945, 8989],
              [5931, 8984],
              [5913, 8991],
              [5877, 8986],
              [5878, 8978],
              [5823, 8966],
              [5806, 8956],
              [5773, 8955],
              [5751, 8947],
              [5695, 8940],
              [5710, 8918],
              [5735, 8913],
              [5703, 8897],
              [5718, 8885],
              [5698, 8869],
              [5712, 8859],
              [5742, 8852],
              [5747, 8829],
              [5730, 8825],
              [5707, 8831],
              [5705, 8820],
              [5679, 8826],
              [5665, 8838],
              [5641, 8841],
              [5636, 8832],
              [5624, 8841],
              [5606, 8839],
              [5588, 8820],
              [5555, 8838],
              [5551, 8832],
              [5511, 8855],
              [5487, 8855],
              [5480, 8864],
              [5467, 8855],
              [5432, 8860],
              [5429, 8849],
              [5405, 8841],
              [5406, 8831],
              [5389, 8822],
              [5400, 8802],
              [5389, 8794],
              [5358, 8817],
              [5346, 8795],
              [5355, 8772],
              [5346, 8743],
              [5365, 8738],
              [5370, 8721],
              [5397, 8720],
              [5434, 8684],
              [5419, 8680],
              [5444, 8668],
              [5421, 8645],
              [5403, 8645],
              [5397, 8615],
              [5385, 8604],
              [5418, 8572],
              [5420, 8545],
              [5463, 8503],
              [5443, 8479],
              [5428, 8483],
              [5408, 8503],
              [5398, 8504],
              [5372, 8516],
              [5373, 8525],
              [5344, 8535],
              [5319, 8528],
              [5281, 8550],
              [5244, 8552],
              [5214, 8564],
              [5195, 8558],
              [5160, 8586],
              [5112, 8605],
              [5100, 8620],
              [5082, 8626],
              [5109, 8633],
              [5116, 8656],
              [5134, 8659],
              [5110, 8673],
              [5125, 8685],
              [5149, 8692],
              [5146, 8702],
              [5117, 8696],
              [5118, 8714],
              [5130, 8723],
              [5157, 8722],
              [5160, 8737],
              [5145, 8766],
              [5152, 8783],
              [5125, 8796],
              [5094, 8803],
              [5091, 8797],
              [5070, 8816],
              [5049, 8809],
              [5022, 8814],
              [4998, 8845],
              [4972, 8846],
              [4975, 8864],
              [4953, 8886],
              [4913, 8884],
              [4898, 8877],
              [4877, 8909],
              [4901, 8911],
              [4915, 8924],
              [4886, 8937],
              [4864, 8966],
              [4849, 9000],
              [4771, 9019],
              [4767, 9033],
              [4752, 9044],
              [4755, 9059],
              [4740, 9067],
              [4743, 9077],
              [4745, 9084],
              [4759, 9079],
              [4740, 9118],
              [4742, 9124],
              [4744, 9128],
              [4747, 9129],
              [4747, 9129],
              [4745, 9130],
              [4745, 9130],
              [4747, 9129],
              [4750, 9130],
              [4747, 9133],
              [4745, 9135],
              [4744, 9146],
              [4771, 9153],
              [4798, 9148],
              [4788, 9158],
              [4757, 9161],
              [4753, 9178],
              [4732, 9171],
              [4763, 9195],
              [4806, 9237],
              [4811, 9250],
              [4799, 9261],
              [4764, 9278],
              [4776, 9288],
              [4760, 9300],
              [4762, 9308],
              [4744, 9319],
              [4742, 9340],
              [4752, 9341],
              [4743, 9356],
              [4718, 9379],
              [4733, 9407],
              [4697, 9423],
              [4689, 9433],
              [4697, 9449],
              [4718, 9460],
              [4736, 9473],
              [4760, 9470],
              [4763, 9478],
              [4791, 9471],
              [4766, 9466],
              [4803, 9462],
              [4799, 9455],
              [4825, 9457],
              [4863, 9454],
              [4909, 9439],
              [4931, 9428],
              [4964, 9422],
              [5001, 9406],
              [5014, 9391],
              [5014, 9379],
              [5001, 9365],
              [4958, 9354],
              [4876, 9366],
              [4827, 9376],
              [4802, 9389],
              [4799, 9381],
              [4819, 9375],
              [4833, 9363],
              [4858, 9355],
              [4871, 9343],
              [4863, 9332],
              [4882, 9311],
              [4891, 9324],
              [4916, 9317],
              [4928, 9325],
              [4998, 9305],
              [5017, 9313],
              [4994, 9331],
              [4994, 9340],
              [5026, 9354],
              [5041, 9369],
              [5069, 9366],
              [5099, 9348],
              [5097, 9374],
              [5075, 9390],
              [5072, 9425],
              [5046, 9436],
              [5111, 9431],
              [5137, 9412],
              [5105, 9408],
              [5101, 9395],
              [5127, 9381],
              [5147, 9379],
              [5172, 9385],
              [5167, 9403],
              [5188, 9408],
              [5236, 9433],
              [5260, 9434],
              [5284, 9446],
              [5304, 9449],
              [5288, 9425],
              [5325, 9422],
              [5349, 9438],
              [5383, 9435],
              [5413, 9448],
              [5430, 9441],
              [5427, 9430],
              [5443, 9427],
              [5442, 9439],
              [5456, 9439],
              [5459, 9452],
              [5434, 9466],
              [5447, 9475],
              [5529, 9465],
              [5574, 9451],
              [5609, 9444],
              [5645, 9430],
              [5653, 9423],
              [5661, 9447],
              [5642, 9448],
              [5623, 9464],
              [5603, 9468],
              [5599, 9461],
              [5586, 9480],
              [5582, 9503],
              [5563, 9501],
              [5562, 9519],
              [5588, 9536],
              [5582, 9562],
              [5594, 9570],
              [5589, 9583],
              [5617, 9585],
              [5636, 9568],
              [5670, 9562],
              [5679, 9550],
              [5672, 9527],
              [5699, 9514],
              [5716, 9493],
              [5711, 9488],
              [5742, 9446],
              [5776, 9433],
              [5769, 9423],
              [5780, 9408],
              [5768, 9405],
              [5762, 9374],
              [5743, 9369],
              [5702, 9372],
              [5738, 9363],
              [5783, 9360],
              [5785, 9372],
              [5806, 9379],
              [5807, 9394],
              [5819, 9407],
              [5792, 9439],
              [5832, 9448],
              [5864, 9433],
              [5874, 9410],
              [5894, 9402],
              [5915, 9404],
              [5883, 9410],
              [5889, 9424],
              [5864, 9445],
              [5805, 9456],
              [5772, 9451],
              [5748, 9472],
              [5751, 9496],
              [5717, 9518],
              [5701, 9523],
              [5705, 9535],
              [5731, 9544],
              [5708, 9568],
              [5714, 9587],
              [5741, 9585],
              [5731, 9563],
              [5745, 9550],
              [5757, 9521],
              [5820, 9514],
              [5827, 9518],
              [5774, 9528],
              [5760, 9538],
              [5777, 9542],
              [5798, 9536],
              [5803, 9544],
              [5771, 9552],
              [5796, 9558],
              [5805, 9574],
              [5823, 9563],
              [5808, 9563],
              [5795, 9553],
              [5827, 9552],
              [5897, 9532],
              [5932, 9533],
              [5920, 9519],
              [5940, 9498],
              [5937, 9509],
              [5961, 9502],
              [5941, 9518],
              [5943, 9530],
              [5915, 9537],
              [5894, 9549],
              [5853, 9557],
              [5848, 9569],
              [5829, 9577],
              [5824, 9588],
              [5854, 9591],
              [5853, 9603],
              [5891, 9602],
              [5892, 9615],
              [5914, 9619],
              [5927, 9629],
              [5947, 9631],
              [5965, 9643],
              [6050, 9655],
              [6031, 9661],
              [6066, 9665],
              [6061, 9688],
              [6074, 9691],
              [6085, 9667],
              [6099, 9657],
              [6152, 9666],
              [6144, 9674],
              [6186, 9674],
              [6175, 9690],
              [6198, 9706],
              [6229, 9707],
              [6236, 9722],
              [6248, 9718],
              [6247, 9702],
              [6279, 9696],
              [6283, 9689],
              [6316, 9685],
              [6310, 9675],
              [6338, 9674],
              [6333, 9680],
              [6384, 9680],
              [6436, 9676],
              [6461, 9663],
              [6458, 9671],
              [6510, 9638],
              [6463, 9611],
              [6445, 9590],
              [6424, 9589],
              [6420, 9577],
              [6452, 9576],
              [6507, 9591],
              [6474, 9594],
              [6476, 9601],
              [6501, 9598],
              [6512, 9607],
              [6502, 9616],
              [6533, 9615],
              [6535, 9603],
              [6563, 9591],
              [6565, 9584],
              [6608, 9592],
              [6681, 9588],
              [6708, 9574],
              [6764, 9569],
              [6813, 9569],
              [6791, 9587],
              [6801, 9599],
              [6833, 9588],
              [6902, 9586],
              [6905, 9581],
              [6951, 9572],
              [6976, 9543],
              [6953, 9548],
              [7046, 9509],
              [7079, 9503],
              [7067, 9537],
              [7110, 9524],
              [7131, 9522],
              [7156, 9530],
              [7207, 9526],
              [7220, 9530],
              [7239, 9523],
              [7256, 9525],
              [7209, 9546],
              [7203, 9556],
              [7235, 9559],
              [7211, 9568],
              [7238, 9564],
              [7335, 9558],
              [7377, 9551],
              [7330, 9554],
              [7358, 9547],
              [7384, 9535],
              [7386, 9551],
              [7414, 9550],
              [7470, 9538],
              [7457, 9532],
              [7478, 9531],
              [7585, 9505],
              [7642, 9513],
              [7709, 9509],
              [7749, 9500],
              [7769, 9504],
              [7769, 9492],
              [7784, 9477],
              [7837, 9463],
              [7838, 9468],
              [7890, 9470],
              [7974, 9464],
              [7981, 9480],
              [8014, 9476],
              [8017, 9466],
              [7992, 9470],
              [8018, 9456],
              [8049, 9451],
              [8072, 9441],
              [8091, 9450],
              [8057, 9467],
              [8035, 9471],
              [8032, 9483],
              [8189, 9472],
              [8279, 9457],
              [8311, 9448],
              [8500, 9322],
              [8498, 9314],
              [8475, 9309],
              [8420, 9315],
              [8490, 9294],
              [8490, 9298],
              [8550, 9265],
              [8574, 9259],
              [8600, 9244],
              [8599, 9232],
              [8547, 9240],
              [8517, 9224],
              [8509, 9214],
              [8488, 9212],
              [8494, 9205],
              [8487, 9182],
              [8468, 9167],
              [8483, 9151],
              [8445, 9167],
              [8401, 9173],
              [8378, 9163],
              [8376, 9147],
              [8356, 9169],
              [8339, 9155],
              [8344, 9145],
              [8301, 9154],
              [8311, 9136],
              [8331, 9121],
              [8352, 9119],
              [8359, 9126],
              [8376, 9114],
              [8365, 9112],
              [8360, 9083],
              [8387, 9074],
              [8387, 9061],
              [8409, 9041],
              [8422, 9040],
              [8447, 9021],
              [8445, 9014],
              [8423, 9024],
              [8416, 9019],
              [8426, 9001],
              [8464, 8974],
              [8466, 8962],
              [8437, 8963],
              [8431, 8950],
              [8452, 8918],
              [8437, 8905],
              [8459, 8872],
              [8449, 8837],
              [8433, 8847],
              [8399, 8881],
              [8365, 8906],
              [8283, 8975],
              [8247, 9011],
              [8227, 9041],
              [8228, 9064],
              [8209, 9076],
              [8226, 9077],
              [8244, 9098],
              [8238, 9123],
              [8250, 9159],
              [8242, 9167],
              [8259, 9186],
              [8259, 9198],
              [8223, 9229],
              [8218, 9243],
              [8190, 9238],
              [8213, 9213],
              [8189, 9172],
              [8178, 9188],
              [8166, 9184],
              [8139, 9218],
              [8131, 9208],
              [8115, 9217],
              [8071, 9213],
              [8062, 9204],
              [8073, 9193],
              [8061, 9165],
              [8061, 9148],
              [8071, 9136],
              [8095, 9135],
              [8113, 9124],
              [8088, 9120],
              [8063, 9127],
              [8063, 9115],
              [8043, 9120],
              [8024, 9113],
              [8007, 9122],
              [7995, 9118],
              [7990, 9134],
              [7944, 9144],
              [7932, 9134],
              [7951, 9124],
              [7913, 9132],
              [7909, 9126],
              [7870, 9132],
              [7806, 9133],
              [7773, 9122],
              [7772, 9105],
              [7762, 9097],
              [7770, 9078],
              [7749, 9048],
              [7751, 9019],
              [7722, 8975],
              [7747, 8964],
              [7777, 8965],
              [7800, 8936],
              [7802, 8958],
              [7785, 8975],
              [7761, 8978],
              [7777, 8986],
              [7798, 8979],
              [7798, 8964],
              [7810, 8961],
              [7806, 8946],
              [7822, 8942],
              [7823, 8927],
              [7837, 8929],
              [7837, 8955],
              [7868, 8954],
              [7910, 8931],
              [7943, 8919],
              [7966, 8885],
              [7980, 8881],
              [7981, 8859],
              [7999, 8820],
              [8019, 8803],
              [8049, 8745],
              [8040, 8721],
              [8039, 8694],
              [8046, 8664],
              [8033, 8626],
              [8027, 8572],
              [8002, 8540],
              [7984, 8533],
              [7953, 8540],
              [7944, 8556],
              [7935, 8544],
              [7929, 8557],
              [7927, 8531],
              [7919, 8519],
              [7915, 8523],
              [7909, 8527],
            ],
          ],
          [
            [
              [4550, 8959],
              [4567, 8968],
              [4546, 8960],
              [4546, 8960],
              [4553, 8975],
              [4578, 8989],
              [4580, 8989],
              [4569, 8978],
              [4585, 8976],
              [4588, 8988],
              [4632, 8975],
              [4634, 8957],
              [4632, 8956],
              [4550, 8959],
            ],
          ],
          [
            [
              [5242, 9795],
              [5242, 9793],
              [5260, 9783],
              [5244, 9778],
              [5205, 9781],
              [5211, 9792],
              [5242, 9795],
              [5242, 9795],
              [5242, 9795],
            ],
          ],
          [
            [
              [5261, 9641],
              [5297, 9659],
              [5336, 9661],
              [5331, 9667],
              [5362, 9664],
              [5396, 9668],
              [5444, 9686],
              [5476, 9686],
              [5495, 9675],
              [5467, 9662],
              [5369, 9643],
              [5349, 9634],
              [5345, 9623],
              [5325, 9614],
              [5301, 9618],
              [5320, 9608],
              [5301, 9585],
              [5286, 9578],
              [5277, 9550],
              [5311, 9518],
              [5356, 9502],
              [5348, 9495],
              [5300, 9497],
              [5252, 9506],
              [5259, 9515],
              [5235, 9522],
              [5243, 9509],
              [5194, 9534],
              [5194, 9544],
              [5212, 9543],
              [5212, 9560],
              [5202, 9563],
              [5234, 9579],
              [5214, 9593],
              [5261, 9615],
              [5241, 9620],
              [5261, 9641],
            ],
          ],
          [
            [
              [8073, 8789],
              [8044, 8821],
              [8032, 8843],
              [7999, 8864],
              [7979, 8887],
              [7966, 8909],
              [7951, 8922],
              [7970, 8922],
              [7969, 8934],
              [7936, 8955],
              [7944, 8959],
              [8000, 8914],
              [8037, 8868],
              [8065, 8847],
              [8101, 8812],
              [8145, 8774],
              [8112, 8778],
              [8129, 8729],
              [8141, 8715],
              [8163, 8701],
              [8193, 8675],
              [8163, 8679],
              [8171, 8652],
              [8145, 8678],
              [8140, 8694],
              [8123, 8714],
              [8120, 8727],
              [8089, 8757],
              [8073, 8789],
            ],
          ],
          [
            [
              [-490, 9322],
              [-301, 9448],
              [-285, 9440],
              [-291, 9434],
              [-257, 9411],
              [-255, 9398],
              [-296, 9361],
              [-276, 9368],
              [-254, 9383],
              [-262, 9387],
              [-198, 9383],
              [-201, 9374],
              [-191, 9353],
              [-217, 9348],
              [-229, 9340],
              [-274, 9336],
              [-309, 9314],
              [-326, 9300],
              [-360, 9296],
              [-372, 9311],
              [-390, 9320],
              [-374, 9335],
              [-389, 9340],
              [-408, 9334],
              [-432, 9337],
              [-418, 9354],
              [-435, 9356],
              [-446, 9340],
              [-490, 9322],
            ],
          ],
          [
            [
              [7200, 9645],
              [7193, 9631],
              [7143, 9641],
              [7160, 9632],
              [7190, 9628],
              [7165, 9625],
              [7146, 9630],
              [7105, 9621],
              [7071, 9624],
              [7068, 9597],
              [7056, 9604],
              [7064, 9626],
              [7019, 9640],
              [7007, 9651],
              [6998, 9643],
              [6988, 9641],
              [6971, 9655],
              [6993, 9648],
              [7025, 9665],
              [7090, 9651],
              [7079, 9664],
              [7121, 9655],
              [7153, 9654],
              [7200, 9645],
            ],
          ],
          [
            [
              [6046, 9766],
              [6062, 9758],
              [6063, 9748],
              [6083, 9740],
              [6043, 9737],
              [6017, 9741],
              [5979, 9743],
              [5934, 9756],
              [5942, 9770],
              [5994, 9772],
              [6046, 9766],
            ],
          ],
          [
            [
              [4953, 9775],
              [4976, 9784],
              [4939, 9779],
              [4917, 9784],
              [5016, 9791],
              [5050, 9785],
              [5013, 9780],
              [4992, 9770],
              [4953, 9775],
            ],
          ],
          [
            [
              [5242, 9795],
              [5243, 9805],
              [5243, 9795],
              [5242, 9795],
              [5242, 9795],
              [5242, 9795],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'TT',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.65,
        'hc-middle-y': 0.56,
        'hc-key': 'tt',
        'hc-a2': 'TT',
        name: 'Trinidad and Tobago',
        labelrank: '5',
        'country-abbrev': 'Tr.T.',
        subregion: 'Caribbean',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'TTO',
        'iso-a2': 'TT',
        'woe-id': '23424958',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [2015, 7362],
            [2007, 7343],
            [2008, 7324],
            [1982, 7322],
            [1993, 7329],
            [1995, 7347],
            [2015, 7362],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'BR',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.53,
        'hc-middle-y': 0.38,
        'hc-key': 'br',
        'hc-a2': 'BR',
        name: 'Brazil',
        labelrank: '2',
        'country-abbrev': 'Brazil',
        subregion: 'South America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'BRA',
        'iso-a2': 'BR',
        'woe-id': '23424768',
        continent: 'South America',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [2350, 6966],
              [2348, 6954],
              [2372, 6961],
              [2366, 6947],
              [2329, 6946],
              [2350, 6966],
            ],
          ],
          [
            [
              [2329, 6919],
              [2349, 6943],
              [2414, 6936],
              [2399, 6893],
              [2381, 6889],
              [2367, 6879],
              [2353, 6886],
              [2342, 6880],
              [2334, 6893],
              [2329, 6919],
            ],
          ],
          [
            [
              [2335, 5697],
              [2343, 5725],
              [2359, 5734],
              [2354, 5748],
              [2341, 5731],
              [2324, 5742],
              [2289, 5775],
              [2267, 5783],
              [2254, 5798],
              [2242, 5789],
              [2233, 5808],
              [2211, 5825],
              [2187, 5822],
              [2218, 5864],
              [2234, 5895],
              [2259, 5918],
              [2291, 5935],
              [2292, 5968],
              [2282, 5992],
              [2260, 5994],
              [2260, 5996],
              [2259, 5999],
              [2268, 6027],
              [2265, 6050],
              [2252, 6060],
              [2227, 6054],
              [2216, 6103],
              [2189, 6124],
              [2182, 6118],
              [2138, 6124],
              [2140, 6166],
              [2126, 6195],
              [2135, 6202],
              [2126, 6212],
              [2135, 6237],
              [2140, 6269],
              [2130, 6293],
              [2110, 6303],
              [2105, 6338],
              [2049, 6341],
              [2044, 6370],
              [2032, 6384],
              [2042, 6384],
              [2032, 6433],
              [2013, 6445],
              [1987, 6442],
              [1975, 6458],
              [1956, 6462],
              [1945, 6475],
              [1925, 6482],
              [1901, 6482],
              [1881, 6500],
              [1866, 6531],
              [1863, 6557],
              [1868, 6566],
              [1861, 6586],
              [1823, 6577],
              [1789, 6548],
              [1771, 6538],
              [1729, 6539],
              [1694, 6536],
              [1692, 6580],
              [1695, 6595],
              [1674, 6576],
              [1641, 6574],
              [1636, 6591],
              [1606, 6596],
              [1614, 6608],
              [1594, 6635],
              [1587, 6656],
              [1577, 6665],
              [1587, 6674],
              [1584, 6690],
              [1605, 6708],
              [1601, 6720],
              [1610, 6755],
              [1642, 6778],
              [1673, 6783],
              [1679, 6792],
              [1706, 6789],
              [1722, 6902],
              [1715, 6927],
              [1700, 6940],
              [1701, 6968],
              [1731, 6971],
              [1724, 6986],
              [1707, 6986],
              [1707, 7010],
              [1763, 7010],
              [1790, 7024],
              [1799, 6990],
              [1805, 6992],
              [1829, 6974],
              [1842, 6983],
              [1848, 6971],
              [1862, 6988],
              [1896, 7005],
              [1898, 7017],
              [1920, 7026],
              [1921, 7036],
              [1899, 7038],
              [1895, 7080],
              [1880, 7094],
              [1897, 7099],
              [1899, 7092],
              [1920, 7094],
              [1941, 7081],
              [1942, 7096],
              [1982, 7105],
              [2000, 7115],
              [2014, 7131],
              [2010, 7140],
              [2035, 7136],
              [2030, 7114],
              [2040, 7113],
              [2049, 7093],
              [2038, 7081],
              [2032, 7047],
              [2040, 7015],
              [2070, 6991],
              [2087, 7006],
              [2112, 7010],
              [2127, 7022],
              [2147, 7019],
              [2163, 7015],
              [2164, 7041],
              [2173, 7036],
              [2197, 7041],
              [2209, 7033],
              [2225, 7025],
              [2251, 7034],
              [2263, 7027],
              [2276, 7040],
              [2284, 7064],
              [2306, 7097],
              [2312, 7112],
              [2326, 7091],
              [2328, 7059],
              [2339, 7026],
              [2345, 7028],
              [2363, 7008],
              [2364, 6990],
              [2357, 6975],
              [2345, 6971],
              [2322, 6935],
              [2318, 6901],
              [2329, 6904],
              [2339, 6879],
              [2370, 6875],
              [2382, 6883],
              [2376, 6849],
              [2386, 6874],
              [2418, 6915],
              [2432, 6925],
              [2457, 6916],
              [2486, 6912],
              [2498, 6897],
              [2512, 6893],
              [2514, 6881],
              [2525, 6896],
              [2541, 6876],
              [2543, 6835],
              [2546, 6851],
              [2556, 6842],
              [2568, 6862],
              [2609, 6844],
              [2636, 6839],
              [2690, 6840],
              [2740, 6809],
              [2753, 6792],
              [2783, 6764],
              [2802, 6757],
              [2836, 6756],
              [2847, 6742],
              [2863, 6679],
              [2863, 6651],
              [2848, 6604],
              [2813, 6555],
              [2797, 6545],
              [2774, 6498],
              [2754, 6465],
              [2734, 6453],
              [2736, 6425],
              [2732, 6400],
              [2741, 6356],
              [2732, 6307],
              [2735, 6288],
              [2721, 6269],
              [2721, 6225],
              [2711, 6210],
              [2700, 6179],
              [2690, 6169],
              [2681, 6145],
              [2686, 6129],
              [2655, 6107],
              [2653, 6092],
              [2594, 6087],
              [2580, 6092],
              [2547, 6067],
              [2500, 6043],
              [2471, 6014],
              [2453, 5977],
              [2453, 5951],
              [2465, 5919],
              [2458, 5885],
              [2429, 5850],
              [2418, 5812],
              [2397, 5774],
              [2395, 5790],
              [2407, 5800],
              [2405, 5816],
              [2388, 5822],
              [2386, 5789],
              [2372, 5781],
              [2365, 5765],
              [2368, 5745],
              [2361, 5714],
              [2341, 5690],
              [2336, 5694],
              [2335, 5697],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'BS',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.1,
        'hc-middle-y': 0.53,
        'hc-key': 'bs',
        'hc-a2': 'BS',
        name: 'The Bahamas',
        labelrank: '4',
        'country-abbrev': 'Bhs.',
        subregion: 'Caribbean',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'BHS',
        'iso-a2': 'BS',
        'woe-id': '23424758',
        continent: 'North America',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [1580, 7818],
              [1588, 7828],
              [1600, 7803],
              [1630, 7793],
              [1654, 7778],
              [1615, 7796],
              [1599, 7798],
              [1589, 7821],
              [1580, 7818],
            ],
          ],
          [
            [
              [1523, 7878],
              [1509, 7855],
              [1518, 7845],
              [1509, 7835],
              [1497, 7865],
              [1510, 7882],
              [1512, 7871],
              [1523, 7878],
            ],
          ],
          [
            [
              [1565, 7880],
              [1559, 7890],
              [1559, 7890],
              [1559, 7890],
              [1562, 7889],
              [1565, 7880],
              [1565, 7880],
            ],
          ],
          [
            [
              [1565, 7880],
              [1567, 7876],
              [1582, 7864],
              [1590, 7848],
              [1615, 7844],
              [1613, 7838],
              [1591, 7845],
              [1567, 7872],
              [1565, 7880],
              [1565, 7880],
            ],
          ],
          [
            [
              [1559, 7890],
              [1550, 7893],
              [1534, 7915],
              [1541, 7931],
              [1534, 7947],
              [1493, 7934],
              [1502, 7942],
              [1534, 7948],
              [1548, 7934],
              [1539, 7911],
              [1558, 7892],
              [1559, 7890],
              [1559, 7890],
              [1559, 7890],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'PW',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.5,
        'hc-middle-y': 0.54,
        'hc-key': 'pw',
        'hc-a2': 'PW',
        name: 'Palau',
        labelrank: '6',
        'country-abbrev': 'Palau',
        subregion: 'Micronesia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'PLW',
        'iso-a2': 'PW',
        'woe-id': '23424927',
        continent: 'Oceania',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [8317, 7059],
            [8316, 7059],
            [8317, 7060],
            [8318, 7060],
            [8317, 7059],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'GD',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.5,
        'hc-middle-y': 0.5,
        'hc-key': 'gd',
        'hc-a2': 'GD',
        name: 'Grenada',
        labelrank: '6',
        'country-abbrev': 'Gren.',
        subregion: 'Caribbean',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'GRD',
        'iso-a2': 'GD',
        'woe-id': '23424826',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1991, 7395],
            [1987, 7395],
            [1988, 7399],
            [1992, 7402],
            [1991, 7395],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'AG',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.5,
        'hc-middle-y': 0.51,
        'hc-key': 'ag',
        'hc-a2': 'AG',
        name: 'Antigua and Barbuda',
        labelrank: '6',
        'country-abbrev': 'Ant.B.',
        subregion: 'Caribbean',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'ATG',
        'iso-a2': 'AG',
        'woe-id': '23424737',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [2000, 7584],
            [2002, 7581],
            [1997, 7580],
            [1996, 7583],
            [2000, 7584],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'FJ',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.31,
        'hc-middle-y': 0.75,
        'hc-key': 'fj',
        'hc-a2': 'FJ',
        name: 'Fiji',
        labelrank: '6',
        'country-abbrev': 'Fiji',
        subregion: 'Melanesia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'FJI',
        'iso-a2': 'FJ',
        'woe-id': '23424813',
        continent: 'Oceania',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [9818, 6278],
              [9804, 6286],
              [9797, 6274],
              [9774, 6266],
              [9753, 6272],
              [9753, 6281],
              [9769, 6297],
              [9790, 6300],
              [9818, 6278],
            ],
          ],
          [
            [
              [9835, 6338],
              [9851, 6340],
              [9835, 6325],
              [9809, 6313],
              [9806, 6322],
              [9835, 6338],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'BB',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.25,
        'hc-middle-y': 0.55,
        'hc-key': 'bb',
        'hc-a2': 'BB',
        name: 'Barbados',
        labelrank: '5',
        'country-abbrev': 'Barb.',
        subregion: 'Caribbean',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'BRB',
        'iso-a2': 'BB',
        'woe-id': '23424754',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [2062, 7433],
            [2058, 7435],
            [2059, 7443],
            [2065, 7435],
            [2062, 7433],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'IT',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.83,
        'hc-middle-y': 0.71,
        'hc-key': 'it',
        'hc-a2': 'IT',
        name: 'Italy',
        labelrank: '2',
        'country-abbrev': 'Italy',
        subregion: 'Southern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'ITA',
        'iso-a2': 'IT',
        'woe-id': '23424853',
        continent: 'Europe',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [4284, 8408],
              [4275, 8396],
              [4255, 8408],
              [4264, 8434],
              [4253, 8468],
              [4262, 8466],
              [4289, 8482],
              [4302, 8454],
              [4296, 8406],
              [4284, 8408],
            ],
          ],
          [
            [
              [4469, 8318],
              [4451, 8318],
              [4386, 8356],
              [4395, 8370],
              [4427, 8362],
              [4483, 8374],
              [4471, 8354],
              [4469, 8318],
            ],
          ],
          [
            [
              [4228, 8573],
              [4232, 8587],
              [4211, 8589],
              [4212, 8610],
              [4199, 8623],
              [4215, 8634],
              [4205, 8645],
              [4211, 8653],
              [4235, 8653],
              [4241, 8665],
              [4264, 8658],
              [4266, 8649],
              [4276, 8673],
              [4296, 8669],
              [4310, 8675],
              [4310, 8687],
              [4358, 8695],
              [4367, 8681],
              [4405, 8675],
              [4396, 8666],
              [4408, 8641],
              [4393, 8648],
              [4364, 8631],
              [4374, 8615],
              [4367, 8606],
              [4372, 8588],
              [4410, 8564],
              [4426, 8530],
              [4460, 8506],
              [4486, 8506],
              [4484, 8489],
              [4549, 8459],
              [4566, 8439],
              [4562, 8431],
              [4546, 8446],
              [4520, 8454],
              [4505, 8431],
              [4527, 8416],
              [4526, 8397],
              [4511, 8393],
              [4511, 8380],
              [4498, 8361],
              [4483, 8372],
              [4499, 8393],
              [4481, 8438],
              [4456, 8444],
              [4451, 8460],
              [4429, 8466],
              [4418, 8481],
              [4398, 8480],
              [4385, 8488],
              [4354, 8518],
              [4339, 8527],
              [4319, 8550],
              [4309, 8575],
              [4278, 8593],
              [4264, 8596],
              [4247, 8579],
              [4228, 8573],
            ],
            [
              [4379, 8505],
              [4379, 8505],
              [4379, 8505],
              [4379, 8505],
              [4379, 8505],
            ],
            [
              [4375, 8577],
              [4375, 8580],
              [4373, 8579],
              [4372, 8578],
              [4375, 8577],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'MT',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.49,
        'hc-middle-y': 0.53,
        'hc-key': 'mt',
        'hc-a2': 'MT',
        name: 'Malta',
        labelrank: '5',
        'country-abbrev': 'Malta',
        subregion: 'Southern Europe',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'MLT',
        'iso-a2': 'MT',
        'woe-id': '23424897',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4446, 8288],
            [4453, 8285],
            [4454, 8280],
            [4449, 8282],
            [4446, 8288],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'PG',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.16,
        'hc-middle-y': 0.47,
        'hc-key': 'pg',
        'hc-a2': 'PG',
        name: 'Papua New Guinea',
        labelrank: '2',
        'country-abbrev': 'P.N.G.',
        subregion: 'Melanesia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'PNG',
        'iso-a2': 'PG',
        'woe-id': '23424926',
        continent: 'Oceania',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [9083, 6743],
              [9097, 6740],
              [9101, 6728],
              [9122, 6704],
              [9121, 6693],
              [9104, 6695],
              [9101, 6709],
              [9086, 6726],
              [9083, 6743],
            ],
          ],
          [
            [
              [8624, 6607],
              [8633, 6710],
              [8640, 6850],
              [8675, 6832],
              [8723, 6818],
              [8738, 6805],
              [8754, 6804],
              [8771, 6785],
              [8781, 6783],
              [8795, 6765],
              [8791, 6744],
              [8829, 6729],
              [8838, 6753],
              [8843, 6726],
              [8857, 6710],
              [8857, 6697],
              [8828, 6695],
              [8833, 6668],
              [8849, 6651],
              [8863, 6647],
              [8864, 6628],
              [8875, 6608],
              [8898, 6610],
              [8892, 6598],
              [8900, 6589],
              [8918, 6587],
              [8927, 6604],
              [8944, 6596],
              [8945, 6582],
              [8956, 6567],
              [8926, 6560],
              [8940, 6554],
              [8920, 6548],
              [8916, 6557],
              [8849, 6568],
              [8823, 6594],
              [8795, 6645],
              [8720, 6664],
              [8726, 6650],
              [8715, 6633],
              [8702, 6631],
              [8704, 6613],
              [8678, 6599],
              [8664, 6605],
              [8628, 6603],
              [8624, 6607],
            ],
          ],
          [
            [
              [8981, 6735],
              [8944, 6713],
              [8917, 6711],
              [8889, 6728],
              [8867, 6732],
              [8880, 6744],
              [8905, 6738],
              [8928, 6741],
              [8933, 6759],
              [8936, 6740],
              [8964, 6745],
              [8977, 6764],
              [8988, 6764],
              [8985, 6791],
              [9013, 6785],
              [9008, 6763],
              [8997, 6761],
              [9000, 6743],
              [8981, 6735],
            ],
          ],
          [
            [
              [8971, 6841],
              [8952, 6847],
              [8945, 6858],
              [8964, 6851],
              [8992, 6832],
              [9005, 6837],
              [9007, 6819],
              [9023, 6833],
              [9013, 6815],
              [9037, 6787],
              [9028, 6766],
              [9023, 6791],
              [9011, 6813],
              [8971, 6841],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'VU',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.35,
        'hc-middle-y': 0.5,
        'hc-key': 'vu',
        'hc-a2': 'VU',
        name: 'Vanuatu',
        labelrank: '4',
        'country-abbrev': 'Van.',
        subregion: 'Melanesia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'VUT',
        'iso-a2': 'VU',
        'woe-id': '23424907',
        continent: 'Oceania',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [9446, 6364],
              [9449, 6346],
              [9459, 6334],
              [9447, 6329],
              [9440, 6347],
              [9444, 6365],
              [9428, 6373],
              [9433, 6402],
              [9436, 6382],
              [9446, 6390],
              [9446, 6364],
            ],
          ],
          [
            [
              [9471, 6325],
              [9470, 6325],
              [9471, 6326],
              [9471, 6326],
              [9471, 6325],
              [9471, 6325],
            ],
          ],
          [
            [
              [9471, 6325],
              [9478, 6317],
              [9470, 6284],
              [9458, 6287],
              [9467, 6296],
              [9471, 6325],
              [9471, 6325],
            ],
          ],
          [
            [
              [9471, 6326],
              [9475, 6351],
              [9477, 6371],
              [9462, 6371],
              [9481, 6389],
              [9476, 6340],
              [9471, 6326],
              [9471, 6326],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SG',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.5,
        'hc-middle-y': 0.55,
        'hc-key': 'sg',
        'hc-a2': 'SG',
        name: 'Singapore',
        labelrank: '6',
        'country-abbrev': 'Sing.',
        subregion: 'South-Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'SGP',
        'iso-a2': 'SG',
        'woe-id': '23424948',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [7421, 7000],
            [7425, 6998],
            [7420, 6993],
            [7414, 6995],
            [7421, 7000],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'CY',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.39,
        'hc-middle-y': 0.5,
        'hc-key': 'cy',
        'hc-a2': 'CY',
        name: 'Cyprus',
        labelrank: '5',
        'country-abbrev': 'Cyp.',
        subregion: 'Western Asia',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'CYP',
        'iso-a2': 'CY',
        'woe-id': '-90',
        continent: 'Asia',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [5051, 8250],
              [5051, 8250],
              [5051, 8250],
              [5051, 8250],
              [5051, 8250],
            ],
          ],
          [
            [
              [5060, 8252],
              [5062, 8248],
              [5056, 8248],
              [5053, 8251],
              [5056, 8252],
              [5059, 8251],
              [5060, 8252],
            ],
          ],
          [
            [
              [5052, 8249],
              [5052, 8249],
              [5053, 8249],
              [5053, 8249],
              [5052, 8249],
            ],
          ],
          [
            [
              [5050, 8249],
              [5048, 8243],
              [5030, 8236],
              [5024, 8238],
              [5022, 8237],
              [5006, 8252],
              [5015, 8256],
              [5016, 8256],
              [5017, 8257],
              [5018, 8257],
              [5019, 8257],
              [5019, 8257],
              [5019, 8257],
              [5019, 8257],
              [5019, 8257],
              [5040, 8256],
              [5050, 8249],
              [5050, 8249],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'KM',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.39,
        'hc-middle-y': 0.52,
        'hc-key': 'km',
        'hc-a2': 'KM',
        name: 'Comoros',
        labelrank: '6',
        'country-abbrev': 'Com.',
        subregion: 'Eastern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'COM',
        'iso-a2': 'KM',
        'woe-id': '23424786',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5425, 6502],
            [5418, 6509],
            [5419, 6520],
            [5423, 6523],
            [5425, 6502],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'VA',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.61,
        'hc-middle-y': 0.45,
        'hc-key': 'va',
        'hc-a2': 'VA',
        name: 'Vatican',
        labelrank: '6',
        'country-abbrev': 'Vat.',
        subregion: 'Southern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'VAT',
        'iso-a2': 'VA',
        'woe-id': '23424986',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4379, 8505],
            [4379, 8505],
            [4379, 8505],
            [4379, 8505],
            [4379, 8505],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SM',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.65,
        'hc-middle-y': 0.39,
        'hc-key': 'sm',
        'hc-a2': 'SM',
        name: 'San Marino',
        labelrank: '6',
        'country-abbrev': 'S.M.',
        subregion: 'Southern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'SMR',
        'iso-a2': 'SM',
        'woe-id': '23424947',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4375, 8577],
            [4372, 8578],
            [4373, 8579],
            [4375, 8580],
            [4375, 8577],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'AM',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.17,
        'hc-middle-y': 0.18,
        'hc-key': 'am',
        'hc-a2': 'AM',
        name: 'Armenia',
        labelrank: '6',
        'country-abbrev': 'Arm.',
        subregion: 'Western Asia',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'ARM',
        'iso-a2': 'AM',
        'woe-id': '23424743',
        continent: 'Asia',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [5379, 8458],
              [5379, 8460],
              [5381, 8459],
              [5380, 8457],
              [5379, 8458],
            ],
          ],
          [
            [
              [5411, 8396],
              [5396, 8422],
              [5364, 8427],
              [5353, 8437],
              [5328, 8439],
              [5326, 8460],
              [5314, 8476],
              [5336, 8480],
              [5360, 8483],
              [5381, 8467],
              [5376, 8459],
              [5397, 8444],
              [5393, 8436],
              [5391, 8436],
              [5388, 8437],
              [5388, 8437],
              [5388, 8437],
              [5387, 8438],
              [5388, 8437],
              [5388, 8437],
              [5388, 8437],
              [5388, 8437],
              [5388, 8437],
              [5388, 8436],
              [5389, 8436],
              [5393, 8436],
              [5393, 8436],
              [5393, 8436],
              [5415, 8415],
              [5423, 8397],
              [5418, 8398],
              [5411, 8396],
            ],
            [
              [5363, 8474],
              [5362, 8475],
              [5360, 8475],
              [5361, 8473],
              [5363, 8474],
            ],
            [
              [5369, 8471],
              [5368, 8472],
              [5367, 8472],
              [5368, 8471],
              [5369, 8471],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'AZ',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.76,
        'hc-middle-y': 0.51,
        'hc-key': 'az',
        'hc-a2': 'AZ',
        name: 'Azerbaijan',
        labelrank: '5',
        'country-abbrev': 'Aze.',
        subregion: 'Western Asia',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'AZE',
        'iso-a2': 'AZ',
        'woe-id': '23424741',
        continent: 'Asia',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [5363, 8474],
              [5361, 8473],
              [5360, 8475],
              [5362, 8475],
              [5363, 8474],
            ],
          ],
          [
            [
              [5369, 8471],
              [5368, 8471],
              [5367, 8472],
              [5368, 8472],
              [5369, 8471],
            ],
          ],
          [
            [
              [5393, 8436],
              [5393, 8436],
              [5396, 8436],
              [5397, 8444],
              [5376, 8459],
              [5381, 8467],
              [5360, 8483],
              [5366, 8488],
              [5407, 8474],
              [5411, 8482],
              [5393, 8496],
              [5398, 8504],
              [5408, 8503],
              [5428, 8483],
              [5443, 8479],
              [5463, 8503],
              [5481, 8487],
              [5503, 8458],
              [5518, 8457],
              [5503, 8438],
              [5504, 8402],
              [5496, 8408],
              [5498, 8380],
              [5490, 8378],
              [5469, 8394],
              [5475, 8415],
              [5461, 8427],
              [5432, 8407],
              [5423, 8397],
              [5415, 8415],
              [5393, 8436],
            ],
            [
              [5379, 8458],
              [5380, 8457],
              [5381, 8459],
              [5379, 8460],
              [5379, 8458],
            ],
          ],
          [
            [
              [5366, 8425],
              [5364, 8427],
              [5396, 8422],
              [5411, 8396],
              [5389, 8401],
              [5366, 8425],
            ],
          ],
          [
            [
              [5388, 8437],
              [5388, 8437],
              [5388, 8437],
              [5387, 8438],
              [5388, 8437],
            ],
          ],
          [
            [
              [5388, 8437],
              [5388, 8437],
              [5388, 8437],
              [5393, 8436],
              [5388, 8437],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'TJ',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.57,
        'hc-middle-y': 0.41,
        'hc-key': 'tj',
        'hc-a2': 'TJ',
        name: 'Tajikistan',
        labelrank: '4',
        'country-abbrev': 'Tjk.',
        subregion: 'Central Asia',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'TJK',
        'iso-a2': 'TJ',
        'woe-id': '23424961',
        continent: 'Asia',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [6087, 8333],
              [6086, 8348],
              [6095, 8371],
              [6083, 8384],
              [6080, 8400],
              [6055, 8409],
              [6062, 8424],
              [6084, 8421],
              [6090, 8437],
              [6090, 8438],
              [6090, 8437],
              [6093, 8434],
              [6093, 8433],
              [6091, 8437],
              [6091, 8437],
              [6095, 8438],
              [6103, 8443],
              [6099, 8464],
              [6110, 8459],
              [6129, 8473],
              [6142, 8461],
              [6133, 8453],
              [6153, 8444],
              [6149, 8441],
              [6148, 8440],
              [6146, 8437],
              [6146, 8437],
              [6144, 8436],
              [6143, 8436],
              [6143, 8436],
              [6143, 8436],
              [6142, 8437],
              [6142, 8437],
              [6140, 8437],
              [6136, 8438],
              [6124, 8443],
              [6106, 8438],
              [6111, 8420],
              [6146, 8424],
              [6157, 8415],
              [6175, 8424],
              [6190, 8411],
              [6204, 8408],
              [6214, 8416],
              [6243, 8418],
              [6258, 8386],
              [6288, 8383],
              [6305, 8334],
              [6287, 8341],
              [6269, 8334],
              [6254, 8343],
              [6239, 8327],
              [6217, 8314],
              [6201, 8328],
              [6198, 8360],
              [6187, 8361],
              [6186, 8374],
              [6163, 8376],
              [6153, 8361],
              [6156, 8346],
              [6137, 8348],
              [6133, 8329],
              [6114, 8336],
              [6097, 8323],
              [6087, 8333],
            ],
            [
              [6093, 8433],
              [6093, 8433],
              [6093, 8433],
              [6093, 8433],
            ],
          ],
          [
            [
              [6136, 8470],
              [6135, 8470],
              [6132, 8473],
              [6134, 8472],
              [6136, 8470],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'UZ',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.56,
        'hc-middle-y': 0.57,
        'hc-key': 'uz',
        'hc-a2': 'UZ',
        name: 'Uzbekistan',
        labelrank: '3',
        'country-abbrev': 'Uzb.',
        subregion: 'Central Asia',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'UZB',
        'iso-a2': 'UZ',
        'woe-id': '23424980',
        continent: 'Asia',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [6181, 8435],
              [6179, 8435],
              [6178, 8436],
              [6181, 8438],
              [6181, 8435],
            ],
          ],
          [
            [
              [6163, 8437],
              [6165, 8434],
              [6159, 8434],
              [6155, 8441],
              [6163, 8437],
            ],
          ],
          [
            [
              [5732, 8514],
              [5724, 8521],
              [5717, 8506],
              [5722, 8481],
              [5690, 8484],
              [5655, 8616],
              [5658, 8620],
              [5727, 8639],
              [5723, 8614],
              [5732, 8596],
              [5740, 8607],
              [5732, 8636],
              [5756, 8624],
              [5753, 8607],
              [5779, 8588],
              [5777, 8611],
              [5811, 8594],
              [5850, 8562],
              [5883, 8567],
              [5921, 8564],
              [5933, 8570],
              [5956, 8555],
              [5969, 8540],
              [5977, 8544],
              [5985, 8508],
              [6000, 8508],
              [6014, 8479],
              [6052, 8479],
              [6057, 8465],
              [6078, 8457],
              [6074, 8469],
              [6083, 8486],
              [6130, 8517],
              [6140, 8515],
              [6115, 8493],
              [6137, 8481],
              [6157, 8477],
              [6163, 8489],
              [6198, 8467],
              [6213, 8464],
              [6176, 8441],
              [6153, 8444],
              [6133, 8453],
              [6142, 8461],
              [6129, 8473],
              [6110, 8459],
              [6099, 8464],
              [6103, 8443],
              [6090, 8437],
              [6090, 8437],
              [6084, 8421],
              [6062, 8424],
              [6055, 8409],
              [6080, 8400],
              [6083, 8384],
              [6095, 8371],
              [6086, 8348],
              [6087, 8333],
              [6071, 8333],
              [6047, 8339],
              [6042, 8364],
              [6011, 8372],
              [5965, 8400],
              [5898, 8436],
              [5874, 8472],
              [5855, 8483],
              [5852, 8478],
              [5813, 8486],
              [5798, 8519],
              [5785, 8519],
              [5754, 8537],
              [5746, 8533],
              [5756, 8519],
              [5740, 8526],
              [5732, 8514],
            ],
            [
              [6136, 8470],
              [6134, 8472],
              [6132, 8473],
              [6135, 8470],
              [6136, 8470],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'LS',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.47,
        'hc-middle-y': 0.5,
        'hc-key': 'ls',
        'hc-a2': 'LS',
        name: 'Lesotho',
        labelrank: '6',
        'country-abbrev': 'Les.',
        subregion: 'Southern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'LSO',
        'iso-a2': 'LS',
        'woe-id': '23424880',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4859, 5843],
            [4867, 5846],
            [4884, 5870],
            [4913, 5882],
            [4936, 5854],
            [4925, 5832],
            [4901, 5824],
            [4890, 5805],
            [4868, 5818],
            [4859, 5843],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'BD',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.85,
        'hc-middle-y': 0.91,
        'hc-key': 'bd',
        'hc-a2': 'BD',
        name: 'Bangladesh',
        labelrank: '3',
        'country-abbrev': 'Bang.',
        subregion: 'Southern Asia',
        'region-wb': 'South Asia',
        'iso-a3': 'BGD',
        'iso-a2': 'BD',
        'woe-id': '23424759',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [6873, 7764],
            [6873, 7766],
            [6872, 7770],
            [6867, 7782],
            [6847, 7827],
            [6849, 7851],
            [6824, 7864],
            [6834, 7884],
            [6850, 7884],
            [6818, 7911],
            [6827, 7932],
            [6864, 7913],
            [6874, 7912],
            [6877, 7891],
            [6896, 7883],
            [6949, 7884],
            [6965, 7875],
            [6957, 7855],
            [6935, 7844],
            [6930, 7826],
            [6939, 7807],
            [6949, 7801],
            [6962, 7830],
            [6971, 7813],
            [6986, 7765],
            [6991, 7739],
            [6981, 7745],
            [6980, 7731],
            [6965, 7746],
            [6965, 7760],
            [6945, 7795],
            [6936, 7783],
            [6917, 7798],
            [6928, 7782],
            [6921, 7761],
            [6913, 7767],
            [6879, 7753],
            [6873, 7763],
            [6873, 7764],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'KP',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.67,
        'hc-middle-y': 0.53,
        'hc-key': 'kp',
        'hc-a2': 'KP',
        name: 'North Korea',
        labelrank: '3',
        'country-abbrev': 'N.K.',
        subregion: 'Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'PRK',
        'iso-a2': 'KP',
        'woe-id': '23424865',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [7774, 8438],
            [7773, 8439],
            [7782, 8453],
            [7807, 8468],
            [7810, 8496],
            [7816, 8501],
            [7833, 8490],
            [7862, 8486],
            [7845, 8508],
            [7871, 8509],
            [7875, 8524],
            [7886, 8524],
            [7879, 8543],
            [7909, 8527],
            [7915, 8523],
            [7919, 8519],
            [7905, 8511],
            [7903, 8492],
            [7920, 8466],
            [7908, 8460],
            [7895, 8436],
            [7876, 8429],
            [7885, 8407],
            [7895, 8405],
            [7923, 8387],
            [7922, 8377],
            [7892, 8375],
            [7885, 8357],
            [7870, 8357],
            [7849, 8365],
            [7847, 8352],
            [7825, 8368],
            [7818, 8383],
            [7821, 8413],
            [7775, 8437],
            [7774, 8438],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'KG',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.35,
        'hc-middle-y': 0.5,
        'hc-key': 'kg',
        'hc-a2': 'KG',
        name: 'Kyrgyzstan',
        labelrank: '4',
        'country-abbrev': 'Kgz.',
        subregion: 'Central Asia',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'KGZ',
        'iso-a2': 'KG',
        'woe-id': '23424864',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [6247, 8438],
            [6247, 8437],
            [6247, 8437],
            [6251, 8423],
            [6243, 8418],
            [6214, 8416],
            [6204, 8408],
            [6190, 8411],
            [6175, 8424],
            [6157, 8415],
            [6146, 8424],
            [6111, 8420],
            [6106, 8438],
            [6124, 8443],
            [6140, 8437],
            [6143, 8436],
            [6143, 8436],
            [6148, 8440],
            [6153, 8444],
            [6176, 8441],
            [6213, 8464],
            [6198, 8467],
            [6163, 8489],
            [6157, 8477],
            [6137, 8481],
            [6115, 8493],
            [6140, 8515],
            [6130, 8517],
            [6128, 8529],
            [6150, 8538],
            [6205, 8523],
            [6199, 8546],
            [6214, 8554],
            [6249, 8539],
            [6266, 8542],
            [6346, 8540],
            [6365, 8536],
            [6408, 8515],
            [6410, 8509],
            [6386, 8501],
            [6363, 8486],
            [6359, 8473],
            [6321, 8470],
            [6320, 8458],
            [6296, 8446],
            [6287, 8459],
            [6268, 8454],
            [6257, 8439],
            [6247, 8437],
            [6247, 8437],
            [6247, 8437],
            [6247, 8438],
          ],
          [
            [6181, 8435],
            [6181, 8438],
            [6178, 8436],
            [6179, 8435],
            [6181, 8435],
          ],
          [
            [6163, 8437],
            [6155, 8441],
            [6159, 8434],
            [6165, 8434],
            [6163, 8437],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'MX',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.49,
        'hc-middle-y': 0.58,
        'hc-key': 'mx',
        'hc-a2': 'MX',
        name: 'Mexico',
        labelrank: '2',
        'country-abbrev': 'Mex.',
        subregion: 'Central America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'MEX',
        'iso-a2': 'MX',
        'woe-id': '23424900',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [809, 8043],
            [817, 8031],
            [822, 7999],
            [840, 7974],
            [837, 7954],
            [842, 7944],
            [842, 7936],
            [869, 7917],
            [903, 7913],
            [876, 7859],
            [858, 7793],
            [859, 7752],
            [870, 7715],
            [888, 7686],
            [890, 7666],
            [903, 7645],
            [923, 7643],
            [943, 7622],
            [1003, 7640],
            [1030, 7640],
            [1063, 7660],
            [1081, 7688],
            [1091, 7730],
            [1110, 7739],
            [1165, 7751],
            [1193, 7745],
            [1202, 7749],
            [1209, 7736],
            [1189, 7709],
            [1178, 7675],
            [1158, 7626],
            [1151, 7631],
            [1145, 7635],
            [1139, 7635],
            [1123, 7613],
            [1114, 7610],
            [1055, 7610],
            [1052, 7589],
            [1037, 7589],
            [1067, 7556],
            [1063, 7545],
            [1022, 7545],
            [1003, 7515],
            [999, 7488],
            [952, 7546],
            [922, 7558],
            [901, 7541],
            [863, 7529],
            [825, 7541],
            [802, 7554],
            [795, 7563],
            [769, 7568],
            [725, 7590],
            [704, 7613],
            [692, 7614],
            [652, 7629],
            [630, 7656],
            [609, 7667],
            [592, 7706],
            [609, 7715],
            [600, 7720],
            [615, 7745],
            [604, 7764],
            [602, 7789],
            [586, 7810],
            [575, 7834],
            [542, 7873],
            [540, 7887],
            [525, 7891],
            [508, 7907],
            [520, 7927],
            [516, 7941],
            [505, 7941],
            [502, 7954],
            [487, 7966],
            [492, 7983],
            [481, 7983],
            [451, 8027],
            [442, 8094],
            [448, 8106],
            [426, 8123],
            [408, 8129],
            [396, 8120],
            [386, 8071],
            [390, 8055],
            [408, 8037],
            [413, 8046],
            [423, 8037],
            [408, 8027],
            [424, 8006],
            [421, 7984],
            [431, 7972],
            [442, 7935],
            [449, 7941],
            [449, 7906],
            [457, 7903],
            [456, 7883],
            [465, 7879],
            [457, 7861],
            [464, 7844],
            [469, 7855],
            [484, 7846],
            [489, 7812],
            [472, 7798],
            [464, 7823],
            [416, 7869],
            [423, 7907],
            [421, 7916],
            [394, 7941],
            [360, 7961],
            [342, 7993],
            [354, 7983],
            [372, 7984],
            [376, 7974],
            [387, 8006],
            [367, 8040],
            [348, 8054],
            [349, 8093],
            [339, 8121],
            [338, 8157],
            [416, 8164],
            [410, 8156],
            [513, 8113],
            [603, 8113],
            [608, 8129],
            [661, 8129],
            [699, 8084],
            [700, 8052],
            [712, 8039],
            [737, 8026],
            [759, 8054],
            [773, 8060],
            [800, 8055],
            [802, 8050],
            [802, 8044],
            [809, 8043],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'MA',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.71,
        'hc-middle-y': 0.13,
        'hc-key': 'ma',
        'hc-a2': 'MA',
        name: 'Morocco',
        labelrank: '3',
        'country-abbrev': 'Mor.',
        subregion: 'Northern Africa',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'MAR',
        'iso-a2': 'MA',
        'woe-id': '23424893',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3914, 8260],
            [3915, 8260],
            [3916, 8255],
            [3936, 8253],
            [3950, 8240],
            [3953, 8184],
            [3960, 8165],
            [3972, 8157],
            [3966, 8141],
            [3926, 8143],
            [3913, 8140],
            [3916, 8130],
            [3890, 8125],
            [3885, 8113],
            [3890, 8090],
            [3867, 8082],
            [3823, 8049],
            [3779, 8045],
            [3764, 8041],
            [3730, 8014],
            [3729, 7977],
            [3725, 7956],
            [3705, 7955],
            [3695, 7947],
            [3657, 7952],
            [3642, 7948],
            [3643, 7938],
            [3631, 7918],
            [3621, 7916],
            [3607, 7871],
            [3586, 7855],
            [3578, 7839],
            [3563, 7832],
            [3555, 7818],
            [3547, 7777],
            [3527, 7745],
            [3497, 7747],
            [3457, 7744],
            [3467, 7776],
            [3479, 7787],
            [3484, 7806],
            [3504, 7841],
            [3528, 7866],
            [3532, 7894],
            [3542, 7920],
            [3571, 7940],
            [3593, 7986],
            [3622, 7992],
            [3640, 8001],
            [3670, 8026],
            [3695, 8058],
            [3702, 8079],
            [3693, 8089],
            [3695, 8116],
            [3714, 8145],
            [3715, 8159],
            [3739, 8185],
            [3784, 8206],
            [3793, 8214],
            [3810, 8245],
            [3822, 8279],
            [3838, 8285],
            [3839, 8283],
            [3840, 8282],
            [3842, 8272],
            [3869, 8255],
            [3914, 8262],
            [3914, 8262],
            [3914, 8262],
            [3914, 8260],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'CO',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.51,
        'hc-middle-y': 0.53,
        'hc-key': 'co',
        'hc-a2': 'CO',
        name: 'Colombia',
        labelrank: '2',
        'country-abbrev': 'Col.',
        subregion: 'South America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'COL',
        'iso-a2': 'CO',
        'woe-id': '23424787',
        continent: 'South America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1528, 6942],
            [1495, 6964],
            [1491, 6956],
            [1459, 6961],
            [1457, 6971],
            [1421, 6991],
            [1412, 7000],
            [1421, 7013],
            [1417, 7028],
            [1429, 7045],
            [1443, 7044],
            [1468, 7086],
            [1461, 7102],
            [1466, 7123],
            [1460, 7155],
            [1468, 7162],
            [1461, 7177],
            [1466, 7191],
            [1449, 7216],
            [1474, 7242],
            [1469, 7269],
            [1488, 7241],
            [1483, 7265],
            [1506, 7282],
            [1518, 7297],
            [1528, 7298],
            [1534, 7341],
            [1557, 7360],
            [1572, 7348],
            [1581, 7369],
            [1608, 7367],
            [1643, 7389],
            [1649, 7402],
            [1669, 7410],
            [1681, 7396],
            [1673, 7388],
            [1652, 7381],
            [1633, 7360],
            [1618, 7335],
            [1615, 7312],
            [1601, 7288],
            [1613, 7293],
            [1632, 7256],
            [1627, 7225],
            [1639, 7210],
            [1669, 7206],
            [1689, 7210],
            [1704, 7206],
            [1725, 7174],
            [1789, 7177],
            [1791, 7169],
            [1777, 7144],
            [1775, 7115],
            [1782, 7086],
            [1793, 7074],
            [1775, 7054],
            [1796, 7036],
            [1805, 6992],
            [1799, 6990],
            [1790, 7024],
            [1763, 7010],
            [1707, 7010],
            [1707, 6986],
            [1724, 6986],
            [1731, 6971],
            [1701, 6968],
            [1700, 6940],
            [1715, 6927],
            [1722, 6902],
            [1706, 6789],
            [1694, 6804],
            [1680, 6806],
            [1702, 6845],
            [1673, 6864],
            [1656, 6858],
            [1646, 6867],
            [1625, 6855],
            [1607, 6856],
            [1598, 6864],
            [1598, 6880],
            [1587, 6884],
            [1583, 6900],
            [1562, 6910],
            [1557, 6926],
            [1544, 6940],
            [1528, 6942],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'TZ',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.49,
        'hc-middle-y': 0.5,
        'hc-key': 'tz',
        'hc-a2': 'TZ',
        name: 'United Republic of Tanzania',
        labelrank: '3',
        'country-abbrev': 'Tanz.',
        subregion: 'Eastern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'TZA',
        'iso-a2': 'TZ',
        'woe-id': '23424973',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5148, 6515],
            [5148, 6518],
            [5147, 6521],
            [5146, 6522],
            [5142, 6524],
            [5141, 6527],
            [5141, 6527],
            [5140, 6528],
            [5134, 6576],
            [5128, 6585],
            [5125, 6589],
            [5125, 6589],
            [5124, 6589],
            [5122, 6592],
            [5121, 6592],
            [5121, 6592],
            [5117, 6591],
            [5116, 6585],
            [5099, 6589],
            [5083, 6596],
            [5053, 6609],
            [5027, 6627],
            [5008, 6667],
            [5008, 6687],
            [4981, 6721],
            [4988, 6726],
            [4979, 6781],
            [4991, 6787],
            [5005, 6814],
            [5018, 6825],
            [5005, 6841],
            [5010, 6857],
            [5019, 6859],
            [5019, 6887],
            [5007, 6907],
            [5019, 6909],
            [5050, 6909],
            [5050, 6907],
            [5052, 6909],
            [5052, 6909],
            [5045, 6859],
            [5051, 6867],
            [5062, 6857],
            [5097, 6853],
            [5118, 6864],
            [5085, 6870],
            [5106, 6871],
            [5108, 6884],
            [5126, 6907],
            [5242, 6833],
            [5246, 6810],
            [5292, 6772],
            [5313, 6761],
            [5314, 6751],
            [5296, 6733],
            [5304, 6707],
            [5295, 6714],
            [5286, 6705],
            [5300, 6691],
            [5294, 6656],
            [5313, 6658],
            [5299, 6648],
            [5295, 6622],
            [5308, 6581],
            [5328, 6556],
            [5314, 6544],
            [5264, 6521],
            [5251, 6527],
            [5230, 6510],
            [5216, 6516],
            [5188, 6511],
            [5176, 6521],
            [5168, 6514],
            [5148, 6515],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SA',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.44,
        'hc-middle-y': 0.48,
        'hc-key': 'sa',
        'hc-a2': 'SA',
        name: 'Saudi Arabia',
        labelrank: '2',
        'country-abbrev': 'Saud.',
        subregion: 'Western Asia',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'SAU',
        'iso-a2': 'SA',
        'woe-id': '23424938',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5541, 8009],
            [5560, 7974],
            [5604, 7939],
            [5607, 7905],
            [5619, 7894],
            [5632, 7868],
            [5638, 7861],
            [5645, 7863],
            [5649, 7859],
            [5651, 7863],
            [5651, 7864],
            [5651, 7864],
            [5649, 7852],
            [5658, 7850],
            [5659, 7843],
            [5694, 7801],
            [5777, 7789],
            [5779, 7792],
            [5796, 7765],
            [5781, 7691],
            [5687, 7654],
            [5596, 7639],
            [5566, 7622],
            [5545, 7583],
            [5530, 7578],
            [5521, 7590],
            [5479, 7591],
            [5470, 7595],
            [5406, 7592],
            [5408, 7572],
            [5396, 7556],
            [5386, 7575],
            [5369, 7567],
            [5380, 7580],
            [5377, 7596],
            [5360, 7611],
            [5339, 7643],
            [5329, 7673],
            [5299, 7702],
            [5285, 7708],
            [5265, 7740],
            [5262, 7786],
            [5239, 7832],
            [5208, 7850],
            [5194, 7872],
            [5196, 7884],
            [5171, 7902],
            [5177, 7915],
            [5118, 7994],
            [5103, 7993],
            [5109, 8009],
            [5111, 8039],
            [5146, 8033],
            [5165, 8058],
            [5188, 8063],
            [5202, 8082],
            [5166, 8119],
            [5227, 8137],
            [5232, 8142],
            [5273, 8135],
            [5329, 8104],
            [5420, 8034],
            [5478, 8030],
            [5507, 8026],
            [5517, 8009],
            [5541, 8009],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'QA',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.48,
        'hc-middle-y': 0.5,
        'hc-key': 'qa',
        'hc-a2': 'QA',
        name: 'Qatar',
        labelrank: '5',
        'country-abbrev': 'Qatar',
        subregion: 'Western Asia',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'QAT',
        'iso-a2': 'QA',
        'woe-id': '23424930',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5651, 7863],
            [5649, 7864],
            [5645, 7863],
            [5638, 7861],
            [5632, 7868],
            [5627, 7896],
            [5641, 7921],
            [5652, 7910],
            [5656, 7876],
            [5651, 7864],
            [5651, 7863],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NL',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.98,
        'hc-middle-y': 0.03,
        'hc-key': 'nl',
        'hc-a2': 'NL',
        name: 'Netherlands',
        labelrank: '5',
        'country-abbrev': 'Neth.',
        subregion: 'Western Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'NLD',
        'iso-a2': 'NL',
        'woe-id': '-90',
        continent: 'Europe',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [1962, 7618],
              [1960, 7618],
              [1959, 7619],
              [1962, 7618],
            ],
          ],
          [
            [
              [4100, 8851],
              [4111, 8850],
              [4124, 8850],
              [4113, 8844],
              [4100, 8851],
            ],
          ],
          [
            [
              [4205, 8917],
              [4202, 8881],
              [4185, 8867],
              [4172, 8866],
              [4180, 8855],
              [4175, 8828],
              [4170, 8843],
              [4146, 8854],
              [4125, 8850],
              [4114, 8859],
              [4131, 8885],
              [4141, 8916],
              [4147, 8907],
              [4162, 8925],
              [4196, 8924],
              [4205, 8917],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'YE',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.35,
        'hc-middle-y': 0.5,
        'hc-key': 'ye',
        'hc-a2': 'YE',
        name: 'Yemen',
        labelrank: '3',
        'country-abbrev': 'Yem.',
        subregion: 'Western Asia',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'YEM',
        'iso-a2': 'YE',
        'woe-id': '23425002',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5687, 7654],
            [5716, 7591],
            [5730, 7566],
            [5712, 7559],
            [5701, 7542],
            [5704, 7528],
            [5677, 7514],
            [5620, 7495],
            [5605, 7487],
            [5593, 7469],
            [5571, 7470],
            [5551, 7455],
            [5529, 7447],
            [5500, 7445],
            [5478, 7429],
            [5440, 7416],
            [5424, 7425],
            [5416, 7438],
            [5395, 7526],
            [5396, 7556],
            [5408, 7572],
            [5406, 7592],
            [5470, 7595],
            [5479, 7591],
            [5521, 7590],
            [5530, 7578],
            [5545, 7583],
            [5566, 7622],
            [5596, 7639],
            [5687, 7654],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'AE',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.88,
        'hc-middle-y': 0.48,
        'hc-key': 'ae',
        'hc-a2': 'AE',
        name: 'United Arab Emirates',
        labelrank: '4',
        'country-abbrev': 'U.A.E.',
        subregion: 'Western Asia',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'ARE',
        'iso-a2': 'AE',
        'woe-id': '23424738',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5804, 7901],
            [5807, 7897],
            [5810, 7877],
            [5800, 7867],
            [5791, 7873],
            [5792, 7849],
            [5779, 7792],
            [5777, 7789],
            [5694, 7801],
            [5659, 7843],
            [5658, 7850],
            [5667, 7840],
            [5691, 7846],
            [5724, 7842],
            [5740, 7845],
            [5755, 7868],
            [5768, 7878],
            [5795, 7917],
            [5799, 7902],
            [5804, 7901],
          ],
          [
            [5805, 7886],
            [5807, 7888],
            [5803, 7889],
            [5804, 7885],
            [5805, 7886],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'KE',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.48,
        'hc-middle-y': 0.37,
        'hc-key': 'ke',
        'hc-a2': 'KE',
        name: 'Kenya',
        labelrank: '2',
        'country-abbrev': 'Ken.',
        subregion: 'Eastern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'KEN',
        'iso-a2': 'KE',
        'woe-id': '23424863',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5292, 6772],
            [5246, 6810],
            [5242, 6833],
            [5126, 6907],
            [5129, 6933],
            [5151, 6935],
            [5148, 6943],
            [5131, 6937],
            [5123, 6956],
            [5140, 6987],
            [5155, 7008],
            [5153, 7039],
            [5137, 7064],
            [5137, 7083],
            [5121, 7104],
            [5134, 7118],
            [5168, 7134],
            [5175, 7118],
            [5185, 7118],
            [5189, 7112],
            [5215, 7111],
            [5257, 7081],
            [5305, 7073],
            [5315, 7090],
            [5344, 7106],
            [5358, 7093],
            [5381, 7094],
            [5352, 7051],
            [5353, 6914],
            [5371, 6883],
            [5340, 6851],
            [5326, 6844],
            [5323, 6824],
            [5299, 6774],
            [5292, 6772],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'TR',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.42,
        'hc-middle-y': 0.49,
        'hc-key': 'tr',
        'hc-a2': 'TR',
        name: 'Turkey',
        labelrank: '2',
        'country-abbrev': 'Tur.',
        subregion: 'Western Asia',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'TUR',
        'iso-a2': 'TR',
        'woe-id': '23424969',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4791, 8462],
            [4806, 8487],
            [4796, 8498],
            [4816, 8511],
            [4845, 8507],
            [4849, 8495],
            [4882, 8481],
            [4874, 8471],
            [4854, 8475],
            [4835, 8472],
            [4812, 8452],
            [4887, 8451],
            [4892, 8463],
            [4880, 8471],
            [4885, 8481],
            [4946, 8475],
            [4950, 8484],
            [4974, 8498],
            [5004, 8509],
            [5046, 8506],
            [5053, 8512],
            [5065, 8498],
            [5085, 8499],
            [5103, 8481],
            [5107, 8486],
            [5136, 8473],
            [5161, 8469],
            [5193, 8476],
            [5216, 8469],
            [5254, 8491],
            [5283, 8488],
            [5292, 8493],
            [5314, 8476],
            [5326, 8460],
            [5328, 8439],
            [5353, 8437],
            [5364, 8427],
            [5366, 8425],
            [5343, 8415],
            [5355, 8395],
            [5359, 8363],
            [5372, 8353],
            [5381, 8331],
            [5365, 8325],
            [5364, 8334],
            [5316, 8339],
            [5307, 8330],
            [5301, 8338],
            [5280, 8328],
            [5262, 8330],
            [5229, 8316],
            [5195, 8315],
            [5181, 8322],
            [5158, 8312],
            [5132, 8319],
            [5122, 8281],
            [5114, 8284],
            [5109, 8300],
            [5120, 8310],
            [5112, 8322],
            [5093, 8309],
            [5068, 8317],
            [5040, 8292],
            [5018, 8289],
            [4991, 8308],
            [4969, 8318],
            [4949, 8321],
            [4943, 8297],
            [4921, 8292],
            [4904, 8301],
            [4901, 8313],
            [4884, 8319],
            [4870, 8312],
            [4863, 8318],
            [4875, 8327],
            [4856, 8326],
            [4840, 8339],
            [4839, 8363],
            [4807, 8374],
            [4828, 8380],
            [4820, 8391],
            [4830, 8397],
            [4814, 8411],
            [4822, 8423],
            [4799, 8418],
            [4798, 8438],
            [4785, 8443],
            [4816, 8457],
            [4791, 8462],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'FI',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.62,
        'hc-middle-y': 0.67,
        'hc-key': 'fi',
        'hc-a2': 'FI',
        name: 'Finland',
        labelrank: '3',
        'country-abbrev': 'Fin.',
        subregion: 'Northern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'FIN',
        'iso-a2': 'FI',
        'woe-id': '23424812',
        continent: 'Europe',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [4603, 9347],
              [4587, 9366],
              [4593, 9378],
              [4575, 9400],
              [4578, 9415],
              [4554, 9429],
              [4536, 9432],
              [4498, 9449],
              [4521, 9457],
              [4543, 9439],
              [4562, 9436],
              [4578, 9442],
              [4603, 9434],
              [4619, 9444],
              [4622, 9470],
              [4633, 9477],
              [4665, 9481],
              [4697, 9469],
              [4697, 9449],
              [4689, 9433],
              [4697, 9423],
              [4733, 9407],
              [4718, 9379],
              [4743, 9356],
              [4752, 9341],
              [4742, 9340],
              [4744, 9319],
              [4762, 9308],
              [4760, 9300],
              [4776, 9288],
              [4764, 9278],
              [4799, 9261],
              [4811, 9250],
              [4806, 9237],
              [4763, 9195],
              [4732, 9171],
              [4715, 9172],
              [4684, 9161],
              [4665, 9161],
              [4630, 9151],
              [4593, 9158],
              [4563, 9171],
              [4546, 9153],
              [4540, 9153],
              [4540, 9153],
              [4562, 9176],
              [4562, 9209],
              [4552, 9220],
              [4545, 9252],
              [4549, 9260],
              [4574, 9264],
              [4576, 9275],
              [4601, 9290],
              [4624, 9315],
              [4636, 9314],
              [4634, 9336],
              [4603, 9347],
            ],
          ],
          [
            [
              [4537, 9154],
              [4539, 9153],
              [4539, 9153],
              [4538, 9152],
              [4537, 9154],
              [4537, 9154],
              [4537, 9154],
            ],
          ],
          [
            [
              [4537, 9154],
              [4524, 9155],
              [4531, 9165],
              [4537, 9154],
              [4537, 9154],
              [4537, 9154],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'MY',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.93,
        'hc-middle-y': 0.22,
        'hc-key': 'my',
        'hc-a2': 'MY',
        name: 'Malaysia',
        labelrank: '3',
        'country-abbrev': 'Malay.',
        subregion: 'South-Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'MYS',
        'iso-a2': 'MY',
        'woe-id': '23424901',
        continent: 'Asia',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [7879, 7101],
              [7873, 7101],
              [7874, 7103],
              [7868, 7101],
              [7856, 7109],
              [7829, 7106],
              [7811, 7110],
              [7805, 7102],
              [7801, 7059],
              [7788, 7052],
              [7793, 7039],
              [7779, 7030],
              [7781, 7017],
              [7771, 7000],
              [7751, 7000],
              [7742, 6992],
              [7720, 7005],
              [7694, 7000],
              [7692, 6989],
              [7673, 6982],
              [7662, 6986],
              [7641, 6978],
              [7611, 7006],
              [7611, 7024],
              [7620, 7009],
              [7640, 7011],
              [7656, 7004],
              [7665, 7050],
              [7720, 7064],
              [7749, 7106],
              [7750, 7118],
              [7771, 7096],
              [7782, 7128],
              [7783, 7129],
              [7784, 7126],
              [7795, 7107],
              [7787, 7129],
              [7802, 7140],
              [7789, 7143],
              [7809, 7153],
              [7817, 7175],
              [7833, 7196],
              [7839, 7191],
              [7848, 7213],
              [7855, 7194],
              [7870, 7184],
              [7872, 7166],
              [7879, 7172],
              [7922, 7140],
              [7886, 7128],
              [7900, 7109],
              [7877, 7103],
              [7879, 7101],
            ],
          ],
          [
            [
              [7291, 7186],
              [7292, 7196],
              [7315, 7179],
              [7323, 7179],
              [7326, 7156],
              [7339, 7167],
              [7348, 7160],
              [7356, 7179],
              [7392, 7147],
              [7403, 7125],
              [7401, 7086],
              [7405, 7057],
              [7416, 7045],
              [7432, 7013],
              [7435, 6997],
              [7405, 7004],
              [7354, 7036],
              [7335, 7052],
              [7337, 7061],
              [7315, 7091],
              [7309, 7127],
              [7302, 7136],
              [7300, 7170],
              [7291, 7186],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'PA',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.26,
        'hc-middle-y': 0.5,
        'hc-key': 'pa',
        'hc-a2': 'PA',
        name: 'Panama',
        labelrank: '4',
        'country-abbrev': 'Pan.',
        subregion: 'Central America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'PAN',
        'iso-a2': 'PA',
        'woe-id': '23424924',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1300, 7303],
            [1315, 7292],
            [1314, 7279],
            [1348, 7274],
            [1388, 7294],
            [1397, 7304],
            [1431, 7298],
            [1448, 7290],
            [1469, 7269],
            [1474, 7242],
            [1449, 7216],
            [1437, 7233],
            [1431, 7266],
            [1413, 7281],
            [1397, 7280],
            [1393, 7268],
            [1366, 7247],
            [1380, 7224],
            [1352, 7215],
            [1349, 7229],
            [1331, 7234],
            [1323, 7249],
            [1295, 7256],
            [1287, 7246],
            [1282, 7256],
            [1282, 7257],
            [1282, 7257],
            [1282, 7257],
            [1282, 7257],
            [1294, 7279],
            [1287, 7284],
            [1291, 7304],
            [1300, 7303],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'IR',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.51,
        'hc-middle-y': 0.46,
        'hc-key': 'ir',
        'hc-a2': 'IR',
        name: 'Iran',
        labelrank: '2',
        'country-abbrev': 'Iran',
        subregion: 'Southern Asia',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'IRN',
        'iso-a2': 'IR',
        'woe-id': '23424851',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5381, 8331],
            [5372, 8353],
            [5359, 8363],
            [5355, 8395],
            [5343, 8415],
            [5366, 8425],
            [5389, 8401],
            [5411, 8396],
            [5418, 8398],
            [5423, 8397],
            [5432, 8407],
            [5461, 8427],
            [5475, 8415],
            [5469, 8394],
            [5490, 8378],
            [5498, 8380],
            [5507, 8354],
            [5522, 8344],
            [5546, 8340],
            [5557, 8327],
            [5578, 8315],
            [5604, 8310],
            [5649, 8321],
            [5667, 8319],
            [5660, 8338],
            [5686, 8345],
            [5686, 8354],
            [5702, 8367],
            [5728, 8367],
            [5730, 8373],
            [5754, 8373],
            [5761, 8362],
            [5807, 8352],
            [5850, 8326],
            [5863, 8312],
            [5890, 8309],
            [5900, 8273],
            [5898, 8224],
            [5887, 8216],
            [5891, 8199],
            [5902, 8196],
            [5897, 8177],
            [5911, 8147],
            [5916, 8119],
            [5944, 8114],
            [5951, 8095],
            [5927, 8058],
            [5968, 8009],
            [5997, 7998],
            [6002, 7962],
            [6021, 7956],
            [6017, 7938],
            [5992, 7933],
            [5979, 7924],
            [5975, 7885],
            [5970, 7880],
            [5944, 7888],
            [5941, 7894],
            [5921, 7890],
            [5895, 7892],
            [5885, 7898],
            [5864, 7898],
            [5836, 7906],
            [5822, 7946],
            [5814, 7957],
            [5792, 7958],
            [5792, 7944],
            [5766, 7944],
            [5752, 7933],
            [5736, 7941],
            [5717, 7941],
            [5707, 7951],
            [5679, 7965],
            [5673, 7975],
            [5638, 7987],
            [5607, 8043],
            [5585, 8071],
            [5571, 8065],
            [5549, 8078],
            [5548, 8064],
            [5538, 8062],
            [5519, 8081],
            [5516, 8100],
            [5505, 8100],
            [5506, 8129],
            [5490, 8152],
            [5451, 8173],
            [5436, 8198],
            [5418, 8211],
            [5416, 8229],
            [5428, 8253],
            [5427, 8268],
            [5437, 8280],
            [5404, 8287],
            [5381, 8331],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'HT',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.23,
        'hc-middle-y': 0.78,
        'hc-key': 'ht',
        'hc-a2': 'HT',
        name: 'Haiti',
        labelrank: '5',
        'country-abbrev': 'Haiti',
        subregion: 'Caribbean',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'HTI',
        'iso-a2': 'HT',
        'woe-id': '23424839',
        continent: 'North America',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [1676, 7635],
              [1675, 7636],
              [1675, 7636],
              [1675, 7636],
              [1676, 7635],
            ],
          ],
          [
            [
              [1673, 7639],
              [1674, 7635],
              [1676, 7635],
              [1681, 7628],
              [1678, 7618],
              [1669, 7626],
              [1643, 7622],
              [1629, 7626],
              [1607, 7623],
              [1592, 7633],
              [1603, 7641],
              [1649, 7633],
              [1635, 7648],
              [1647, 7647],
              [1653, 7670],
              [1632, 7683],
              [1653, 7689],
              [1685, 7680],
              [1683, 7645],
              [1673, 7639],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'DO',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.48,
        'hc-middle-y': 0.41,
        'hc-key': 'do',
        'hc-a2': 'DO',
        name: 'Dominican Republic',
        labelrank: '5',
        'country-abbrev': 'Dom. Rep.',
        subregion: 'Caribbean',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'DOM',
        'iso-a2': 'DO',
        'woe-id': '23424800',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1675, 7636],
            [1673, 7639],
            [1683, 7645],
            [1685, 7680],
            [1689, 7687],
            [1711, 7689],
            [1744, 7679],
            [1752, 7657],
            [1780, 7653],
            [1791, 7641],
            [1778, 7621],
            [1772, 7632],
            [1741, 7634],
            [1718, 7624],
            [1714, 7633],
            [1688, 7602],
            [1678, 7618],
            [1681, 7628],
            [1676, 7635],
            [1676, 7635],
            [1675, 7636],
            [1675, 7636],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'HR',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.37,
        'hc-middle-y': 0.6,
        'hc-key': 'hr',
        'hc-a2': 'HR',
        name: 'Croatia',
        labelrank: '6',
        'country-abbrev': 'Cro.',
        subregion: 'Southern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'HRV',
        'iso-a2': 'HR',
        'woe-id': '23424843',
        continent: 'Europe',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [4558, 8523],
              [4537, 8538],
              [4532, 8540],
              [4538, 8538],
              [4556, 8529],
              [4556, 8526],
              [4558, 8523],
            ],
          ],
          [
            [
              [4404, 8637],
              [4455, 8636],
              [4463, 8663],
              [4487, 8674],
              [4513, 8654],
              [4545, 8646],
              [4559, 8653],
              [4566, 8624],
              [4566, 8612],
              [4555, 8622],
              [4530, 8622],
              [4503, 8630],
              [4487, 8620],
              [4470, 8626],
              [4469, 8609],
              [4485, 8588],
              [4529, 8547],
              [4529, 8542],
              [4502, 8549],
              [4453, 8587],
              [4445, 8615],
              [4436, 8616],
              [4426, 8632],
              [4433, 8603],
              [4422, 8616],
              [4414, 8610],
              [4404, 8637],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'TH',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.32,
        'hc-middle-y': 0.41,
        'hc-key': 'th',
        'hc-a2': 'TH',
        name: 'Thailand',
        labelrank: '3',
        'country-abbrev': 'Thai.',
        subregion: 'South-Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'THA',
        'iso-a2': 'TH',
        'woe-id': '23424960',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [7356, 7179],
            [7348, 7160],
            [7339, 7167],
            [7326, 7156],
            [7323, 7179],
            [7315, 7179],
            [7292, 7196],
            [7291, 7186],
            [7277, 7202],
            [7270, 7221],
            [7249, 7246],
            [7233, 7247],
            [7229, 7236],
            [7224, 7265],
            [7228, 7310],
            [7237, 7332],
            [7237, 7344],
            [7250, 7360],
            [7262, 7386],
            [7240, 7432],
            [7239, 7457],
            [7205, 7498],
            [7201, 7513],
            [7212, 7517],
            [7209, 7544],
            [7218, 7548],
            [7200, 7581],
            [7172, 7610],
            [7161, 7635],
            [7171, 7638],
            [7166, 7651],
            [7173, 7684],
            [7190, 7679],
            [7204, 7693],
            [7231, 7708],
            [7237, 7703],
            [7253, 7694],
            [7254, 7673],
            [7279, 7674],
            [7284, 7656],
            [7278, 7633],
            [7284, 7619],
            [7278, 7602],
            [7286, 7597],
            [7313, 7625],
            [7330, 7616],
            [7342, 7617],
            [7354, 7633],
            [7375, 7629],
            [7406, 7593],
            [7409, 7562],
            [7441, 7532],
            [7444, 7505],
            [7440, 7484],
            [7433, 7481],
            [7419, 7484],
            [7365, 7479],
            [7352, 7453],
            [7344, 7452],
            [7353, 7417],
            [7370, 7380],
            [7359, 7399],
            [7349, 7401],
            [7331, 7418],
            [7303, 7416],
            [7299, 7448],
            [7276, 7449],
            [7268, 7440],
            [7273, 7400],
            [7255, 7342],
            [7252, 7310],
            [7264, 7289],
            [7278, 7290],
            [7282, 7267],
            [7292, 7256],
            [7300, 7225],
            [7291, 7227],
            [7319, 7202],
            [7338, 7201],
            [7356, 7179],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'EE',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.78,
        'hc-middle-y': 0.52,
        'hc-key': 'ee',
        'hc-a2': 'EE',
        name: 'Estonia',
        labelrank: '6',
        'country-abbrev': 'Est.',
        subregion: 'Northern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'EST',
        'iso-a2': 'EE',
        'woe-id': '23424805',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4745, 9135],
            [4747, 9133],
            [4750, 9130],
            [4748, 9130],
            [4745, 9130],
            [4747, 9129],
            [4747, 9129],
            [4748, 9129],
            [4747, 9129],
            [4744, 9129],
            [4742, 9124],
            [4740, 9118],
            [4721, 9112],
            [4745, 9084],
            [4743, 9077],
            [4740, 9067],
            [4717, 9067],
            [4681, 9086],
            [4656, 9079],
            [4660, 9095],
            [4649, 9092],
            [4623, 9102],
            [4627, 9118],
            [4605, 9107],
            [4590, 9116],
            [4604, 9121],
            [4625, 9118],
            [4626, 9126],
            [4681, 9141],
            [4713, 9135],
            [4745, 9135],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'CD',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.58,
        'hc-middle-y': 0.43,
        'hc-key': 'cd',
        'hc-a2': 'CD',
        name: 'Democratic Republic of the Congo',
        labelrank: '2',
        'country-abbrev': 'D.R.C.',
        subregion: 'Middle Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'COD',
        'iso-a2': 'CD',
        'woe-id': '23424780',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4965, 6822],
            [4959, 6786],
            [4964, 6782],
            [4961, 6758],
            [4969, 6737],
            [4963, 6726],
            [4973, 6697],
            [4993, 6676],
            [4998, 6655],
            [5007, 6640],
            [4952, 6631],
            [4933, 6607],
            [4939, 6597],
            [4945, 6582],
            [4942, 6555],
            [4932, 6520],
            [4937, 6504],
            [4953, 6485],
            [4969, 6483],
            [4979, 6494],
            [4977, 6446],
            [4969, 6454],
            [4957, 6446],
            [4930, 6483],
            [4908, 6489],
            [4894, 6516],
            [4877, 6499],
            [4854, 6503],
            [4834, 6513],
            [4833, 6530],
            [4799, 6523],
            [4802, 6533],
            [4789, 6542],
            [4758, 6533],
            [4742, 6535],
            [4732, 6527],
            [4735, 6546],
            [4731, 6577],
            [4719, 6596],
            [4724, 6631],
            [4718, 6648],
            [4720, 6675],
            [4678, 6675],
            [4681, 6689],
            [4645, 6686],
            [4640, 6648],
            [4601, 6649],
            [4582, 6645],
            [4562, 6675],
            [4550, 6726],
            [4541, 6728],
            [4438, 6728],
            [4413, 6721],
            [4406, 6732],
            [4416, 6733],
            [4414, 6758],
            [4434, 6774],
            [4445, 6764],
            [4478, 6787],
            [4478, 6764],
            [4492, 6767],
            [4515, 6795],
            [4528, 6801],
            [4538, 6823],
            [4539, 6867],
            [4559, 6899],
            [4574, 6909],
            [4589, 6927],
            [4595, 6960],
            [4593, 6984],
            [4599, 7004],
            [4599, 7027],
            [4617, 7063],
            [4617, 7076],
            [4614, 7108],
            [4632, 7129],
            [4653, 7138],
            [4673, 7124],
            [4681, 7111],
            [4745, 7102],
            [4757, 7126],
            [4775, 7120],
            [4810, 7136],
            [4815, 7130],
            [4836, 7134],
            [4845, 7147],
            [4874, 7135],
            [4896, 7140],
            [4906, 7135],
            [4917, 7118],
            [4937, 7106],
            [4950, 7116],
            [4964, 7108],
            [4973, 7120],
            [4984, 7116],
            [4997, 7094],
            [5019, 7076],
            [5015, 7037],
            [5033, 7027],
            [5008, 7003],
            [5007, 6993],
            [4990, 6977],
            [4981, 6943],
            [4969, 6924],
            [4980, 6928],
            [4977, 6912],
            [4978, 6895],
            [4970, 6890],
            [4966, 6884],
            [4956, 6873],
            [4954, 6854],
            [4955, 6848],
            [4959, 6845],
            [4966, 6833],
            [4965, 6822],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'KW',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.62,
        'hc-middle-y': 0.49,
        'hc-key': 'kw',
        'hc-a2': 'KW',
        name: 'Kuwait',
        labelrank: '6',
        'country-abbrev': 'Kwt.',
        subregion: 'Western Asia',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'KWT',
        'iso-a2': 'KW',
        'woe-id': '23424870',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5519, 8063],
            [5533, 8056],
            [5527, 8039],
            [5541, 8009],
            [5517, 8009],
            [5507, 8026],
            [5478, 8030],
            [5493, 8062],
            [5519, 8063],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'DE',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.51,
        'hc-middle-y': 0.34,
        'hc-key': 'de',
        'hc-a2': 'DE',
        name: 'Germany',
        labelrank: '2',
        'country-abbrev': 'Ger.',
        subregion: 'Western Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'DEU',
        'iso-a2': 'DE',
        'woe-id': '23424829',
        continent: 'Europe',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [4243, 8976],
              [4247, 8976],
              [4265, 8973],
              [4279, 8971],
              [4285, 8961],
              [4303, 8955],
              [4303, 8946],
              [4322, 8941],
              [4350, 8961],
              [4367, 8956],
              [4370, 8967],
              [4399, 8942],
              [4398, 8941],
              [4399, 8940],
              [4388, 8939],
              [4401, 8933],
              [4406, 8918],
              [4400, 8903],
              [4415, 8893],
              [4416, 8866],
              [4430, 8847],
              [4425, 8832],
              [4412, 8833],
              [4361, 8815],
              [4359, 8792],
              [4403, 8756],
              [4400, 8747],
              [4373, 8733],
              [4375, 8716],
              [4342, 8713],
              [4324, 8706],
              [4307, 8713],
              [4300, 8702],
              [4287, 8712],
              [4268, 8722],
              [4271, 8716],
              [4254, 8721],
              [4250, 8713],
              [4225, 8713],
              [4224, 8733],
              [4241, 8763],
              [4201, 8772],
              [4187, 8781],
              [4191, 8794],
              [4179, 8805],
              [4186, 8812],
              [4175, 8828],
              [4180, 8855],
              [4172, 8866],
              [4185, 8867],
              [4202, 8881],
              [4205, 8917],
              [4209, 8934],
              [4235, 8930],
              [4254, 8940],
              [4242, 8963],
              [4253, 8962],
              [4243, 8976],
            ],
          ],
          [
            [
              [4271, 8716],
              [4272, 8716],
              [4272, 8716],
              [4271, 8716],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'IE',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.44,
        'hc-middle-y': 0.51,
        'hc-key': 'ie',
        'hc-a2': 'IE',
        name: 'Ireland',
        labelrank: '3',
        'country-abbrev': 'Ire.',
        subregion: 'Northern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'IRL',
        'iso-a2': 'IE',
        'woe-id': '23424803',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3806, 8982],
            [3792, 8965],
            [3779, 8960],
            [3803, 8948],
            [3811, 8959],
            [3821, 8945],
            [3831, 8947],
            [3838, 8907],
            [3826, 8880],
            [3796, 8877],
            [3759, 8858],
            [3727, 8853],
            [3711, 8869],
            [3726, 8875],
            [3737, 8896],
            [3727, 8893],
            [3754, 8918],
            [3735, 8917],
            [3729, 8955],
            [3767, 8953],
            [3781, 8967],
            [3763, 8967],
            [3778, 8985],
            [3807, 8991],
            [3806, 8982],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'MM',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.29,
        'hc-middle-y': 0.53,
        'hc-key': 'mm',
        'hc-a2': 'MM',
        name: 'Myanmar',
        labelrank: '3',
        'country-abbrev': 'Myan.',
        subregion: 'South-Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'MMR',
        'iso-a2': 'MM',
        'woe-id': '23424763',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [6980, 7731],
            [6981, 7745],
            [6991, 7739],
            [6986, 7765],
            [6995, 7764],
            [7002, 7780],
            [6998, 7803],
            [7005, 7808],
            [6998, 7840],
            [7024, 7834],
            [7036, 7878],
            [7030, 7892],
            [7041, 7905],
            [7036, 7932],
            [7065, 7961],
            [7082, 7965],
            [7096, 7959],
            [7085, 7974],
            [7098, 7985],
            [7095, 7997],
            [7099, 8009],
            [7121, 7994],
            [7131, 7972],
            [7144, 7973],
            [7154, 7938],
            [7151, 7919],
            [7157, 7911],
            [7132, 7880],
            [7128, 7868],
            [7137, 7835],
            [7153, 7844],
            [7166, 7843],
            [7181, 7810],
            [7202, 7805],
            [7196, 7771],
            [7222, 7767],
            [7234, 7744],
            [7262, 7757],
            [7264, 7749],
            [7252, 7740],
            [7249, 7721],
            [7239, 7718],
            [7237, 7703],
            [7231, 7708],
            [7204, 7693],
            [7190, 7679],
            [7173, 7684],
            [7166, 7651],
            [7171, 7638],
            [7161, 7635],
            [7172, 7610],
            [7200, 7581],
            [7218, 7548],
            [7209, 7544],
            [7212, 7517],
            [7201, 7513],
            [7205, 7498],
            [7239, 7457],
            [7240, 7432],
            [7262, 7386],
            [7250, 7360],
            [7237, 7344],
            [7237, 7332],
            [7219, 7313],
            [7230, 7332],
            [7216, 7353],
            [7234, 7353],
            [7233, 7376],
            [7216, 7374],
            [7222, 7397],
            [7231, 7392],
            [7223, 7437],
            [7210, 7457],
            [7198, 7462],
            [7203, 7474],
            [7190, 7500],
            [7179, 7552],
            [7173, 7553],
            [7161, 7580],
            [7151, 7582],
            [7144, 7561],
            [7122, 7551],
            [7109, 7532],
            [7068, 7544],
            [7074, 7600],
            [7053, 7647],
            [7037, 7642],
            [7029, 7667],
            [7044, 7669],
            [7022, 7694],
            [7014, 7685],
            [6986, 7717],
            [6980, 7731],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'GQ',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.54,
        'hc-middle-y': 0.55,
        'hc-key': 'gq',
        'hc-a2': 'GQ',
        name: 'Equatorial Guinea',
        labelrank: '4',
        'country-abbrev': 'Eq. G.',
        subregion: 'Middle Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'GNQ',
        'iso-a2': 'GQ',
        'woe-id': '23424804',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4327, 6984],
            [4312, 6990],
            [4327, 7018],
            [4327, 7034],
            [4333, 7027],
            [4377, 7027],
            [4378, 6984],
            [4327, 6984],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'UG',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.21,
        'hc-middle-y': 0.67,
        'hc-key': 'ug',
        'hc-a2': 'UG',
        name: 'Uganda',
        labelrank: '3',
        'country-abbrev': 'Uga.',
        subregion: 'Eastern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'UGA',
        'iso-a2': 'UG',
        'woe-id': '23424974',
        continent: 'Africa',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [5052, 6909],
              [5052, 6910],
              [5052, 6909],
              [5052, 6909],
            ],
          ],
          [
            [
              [5050, 6909],
              [5019, 6909],
              [5007, 6907],
              [4990, 6892],
              [4978, 6895],
              [4977, 6912],
              [4980, 6928],
              [4988, 6941],
              [4981, 6943],
              [4990, 6977],
              [5007, 6993],
              [5011, 6985],
              [5038, 7018],
              [5033, 7027],
              [5015, 7037],
              [5019, 7076],
              [5029, 7088],
              [5049, 7088],
              [5062, 7077],
              [5089, 7091],
              [5106, 7086],
              [5121, 7104],
              [5137, 7083],
              [5137, 7064],
              [5153, 7039],
              [5155, 7008],
              [5140, 6987],
              [5123, 6956],
              [5098, 6957],
              [5084, 6947],
              [5077, 6952],
              [5055, 6941],
              [5050, 6909],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'KZ',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.61,
        'hc-middle-y': 0.5,
        'hc-key': 'kz',
        'hc-a2': 'KZ',
        name: 'Kazakhstan',
        labelrank: '3',
        'country-abbrev': 'Kaz.',
        subregion: 'Central Asia',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'KAZ',
        'iso-a2': 'KZ',
        'woe-id': '-90',
        continent: 'Asia',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [5732, 8636],
              [5739, 8649],
              [5756, 8624],
              [5732, 8636],
            ],
          ],
          [
            [
              [5777, 8611],
              [5770, 8638],
              [5759, 8653],
              [5777, 8650],
              [5773, 8659],
              [5727, 8651],
              [5727, 8639],
              [5658, 8620],
              [5655, 8616],
              [5690, 8484],
              [5677, 8481],
              [5652, 8506],
              [5628, 8520],
              [5593, 8513],
              [5580, 8499],
              [5576, 8512],
              [5580, 8535],
              [5555, 8538],
              [5531, 8561],
              [5511, 8587],
              [5495, 8592],
              [5479, 8614],
              [5488, 8622],
              [5491, 8604],
              [5521, 8602],
              [5509, 8611],
              [5517, 8631],
              [5549, 8634],
              [5560, 8656],
              [5551, 8688],
              [5532, 8692],
              [5524, 8685],
              [5495, 8696],
              [5474, 8688],
              [5444, 8668],
              [5419, 8680],
              [5434, 8684],
              [5397, 8720],
              [5370, 8721],
              [5365, 8738],
              [5346, 8743],
              [5355, 8772],
              [5346, 8795],
              [5358, 8817],
              [5389, 8794],
              [5400, 8802],
              [5389, 8822],
              [5406, 8831],
              [5405, 8841],
              [5429, 8849],
              [5432, 8860],
              [5467, 8855],
              [5480, 8864],
              [5487, 8855],
              [5511, 8855],
              [5551, 8832],
              [5555, 8838],
              [5588, 8820],
              [5606, 8839],
              [5624, 8841],
              [5636, 8832],
              [5641, 8841],
              [5665, 8838],
              [5679, 8826],
              [5705, 8820],
              [5707, 8831],
              [5730, 8825],
              [5747, 8829],
              [5742, 8852],
              [5712, 8859],
              [5698, 8869],
              [5718, 8885],
              [5703, 8897],
              [5735, 8913],
              [5710, 8918],
              [5695, 8940],
              [5751, 8947],
              [5773, 8955],
              [5806, 8956],
              [5823, 8966],
              [5878, 8978],
              [5877, 8986],
              [5913, 8991],
              [5931, 8984],
              [5945, 8989],
              [5965, 8969],
              [5974, 8948],
              [6010, 8949],
              [6041, 8942],
              [6038, 8932],
              [6067, 8930],
              [6086, 8937],
              [6121, 8959],
              [6125, 8943],
              [6174, 8918],
              [6249, 8855],
              [6275, 8830],
              [6287, 8848],
              [6302, 8844],
              [6318, 8827],
              [6337, 8827],
              [6370, 8837],
              [6383, 8832],
              [6406, 8810],
              [6430, 8804],
              [6446, 8786],
              [6474, 8782],
              [6484, 8787],
              [6514, 8768],
              [6500, 8769],
              [6501, 8748],
              [6481, 8743],
              [6481, 8726],
              [6494, 8706],
              [6494, 8694],
              [6476, 8685],
              [6419, 8700],
              [6423, 8639],
              [6435, 8624],
              [6407, 8632],
              [6365, 8620],
              [6360, 8613],
              [6379, 8604],
              [6389, 8582],
              [6413, 8550],
              [6400, 8532],
              [6408, 8515],
              [6365, 8536],
              [6346, 8540],
              [6266, 8542],
              [6249, 8539],
              [6214, 8554],
              [6199, 8546],
              [6205, 8523],
              [6150, 8538],
              [6128, 8529],
              [6130, 8517],
              [6083, 8486],
              [6074, 8469],
              [6078, 8457],
              [6057, 8465],
              [6052, 8479],
              [6014, 8479],
              [6000, 8508],
              [5985, 8508],
              [5977, 8544],
              [5969, 8540],
              [5956, 8555],
              [5933, 8570],
              [5921, 8564],
              [5883, 8567],
              [5850, 8562],
              [5811, 8594],
              [5777, 8611],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'GA',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.23,
        'hc-middle-y': 0.45,
        'hc-key': 'ga',
        'hc-a2': 'GA',
        name: 'Gabon',
        labelrank: '4',
        'country-abbrev': 'Gabon',
        subregion: 'Middle Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'GAB',
        'iso-a2': 'GA',
        'woe-id': '23424822',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4327, 6984],
            [4378, 6984],
            [4377, 7027],
            [4378, 7032],
            [4440, 7031],
            [4442, 7027],
            [4437, 7006],
            [4441, 6992],
            [4459, 7000],
            [4474, 6996],
            [4481, 6980],
            [4461, 6954],
            [4460, 6939],
            [4482, 6924],
            [4479, 6876],
            [4468, 6853],
            [4457, 6868],
            [4447, 6855],
            [4433, 6859],
            [4426, 6875],
            [4414, 6876],
            [4415, 6860],
            [4385, 6860],
            [4389, 6828],
            [4398, 6823],
            [4394, 6808],
            [4382, 6816],
            [4370, 6800],
            [4355, 6823],
            [4330, 6846],
            [4309, 6878],
            [4313, 6896],
            [4302, 6898],
            [4291, 6925],
            [4302, 6919],
            [4310, 6931],
            [4311, 6970],
            [4322, 6969],
            [4327, 6984],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'KR',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.51,
        'hc-middle-y': 0.4,
        'hc-key': 'kr',
        'hc-a2': 'KR',
        name: 'South Korea',
        labelrank: '2',
        'country-abbrev': 'S.K.',
        subregion: 'Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'KOR',
        'iso-a2': 'KR',
        'woe-id': '23424868',
        continent: 'Asia',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [7885, 8357],
              [7892, 8375],
              [7922, 8377],
              [7923, 8387],
              [7977, 8336],
              [8004, 8291],
              [8011, 8269],
              [7998, 8239],
              [7972, 8248],
              [7962, 8229],
              [7943, 8225],
              [7945, 8219],
              [7945, 8219],
              [7936, 8233],
              [7924, 8224],
              [7914, 8238],
              [7923, 8250],
              [7916, 8274],
              [7924, 8280],
              [7909, 8299],
              [7887, 8316],
              [7902, 8327],
              [7872, 8356],
              [7885, 8357],
            ],
          ],
          [
            [
              [7947, 8216],
              [7945, 8219],
              [7945, 8219],
              [7947, 8217],
              [7947, 8216],
              [7947, 8216],
            ],
          ],
          [
            [
              [7947, 8216],
              [7955, 8195],
              [7966, 8191],
              [7944, 8185],
              [7947, 8216],
              [7947, 8216],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'TL',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.61,
        'hc-middle-y': 0.33,
        'hc-key': 'tl',
        'hc-a2': 'TL',
        name: 'East Timor',
        labelrank: '5',
        'country-abbrev': 'T.L.',
        subregion: 'South-Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'TLS',
        'iso-a2': 'TL',
        'woe-id': '23424968',
        continent: 'Asia',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [8068, 6599],
              [8075, 6602],
              [8082, 6605],
              [8075, 6593],
              [8068, 6599],
            ],
          ],
          [
            [
              [8099, 6613],
              [8106, 6624],
              [8168, 6637],
              [8178, 6632],
              [8149, 6613],
              [8120, 6604],
              [8102, 6593],
              [8099, 6603],
              [8099, 6613],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'MR',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.48,
        'hc-middle-y': 0.7,
        'hc-key': 'mr',
        'hc-a2': 'MR',
        name: 'Mauritania',
        labelrank: '3',
        'country-abbrev': 'Mrt.',
        subregion: 'Western Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'MRT',
        'iso-a2': 'MR',
        'woe-id': '23424896',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3729, 7963],
            [3829, 7893],
            [3851, 7877],
            [3794, 7877],
            [3822, 7562],
            [3831, 7554],
            [3826, 7523],
            [3701, 7523],
            [3676, 7519],
            [3656, 7521],
            [3649, 7509],
            [3634, 7527],
            [3623, 7525],
            [3620, 7501],
            [3605, 7497],
            [3574, 7528],
            [3566, 7548],
            [3555, 7547],
            [3539, 7566],
            [3520, 7566],
            [3474, 7559],
            [3467, 7535],
            [3470, 7566],
            [3485, 7615],
            [3480, 7653],
            [3471, 7669],
            [3482, 7699],
            [3459, 7734],
            [3455, 7720],
            [3458, 7741],
            [3585, 7741],
            [3584, 7784],
            [3587, 7804],
            [3619, 7820],
            [3621, 7914],
            [3727, 7915],
            [3729, 7963],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'DZ',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.51,
        'hc-middle-y': 0.5,
        'hc-key': 'dz',
        'hc-a2': 'DZ',
        name: 'Algeria',
        labelrank: '3',
        'country-abbrev': 'Alg.',
        subregion: 'Northern Africa',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'DZA',
        'iso-a2': 'DZ',
        'woe-id': '23424740',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3851, 7877],
            [3829, 7893],
            [3729, 7963],
            [3729, 7977],
            [3730, 8014],
            [3764, 8041],
            [3779, 8045],
            [3823, 8049],
            [3867, 8082],
            [3890, 8090],
            [3885, 8113],
            [3890, 8125],
            [3916, 8130],
            [3913, 8140],
            [3926, 8143],
            [3966, 8141],
            [3972, 8157],
            [3960, 8165],
            [3953, 8184],
            [3950, 8240],
            [3936, 8253],
            [3950, 8255],
            [3968, 8271],
            [3990, 8283],
            [4002, 8280],
            [4009, 8289],
            [4037, 8306],
            [4085, 8310],
            [4095, 8318],
            [4124, 8322],
            [4152, 8322],
            [4166, 8312],
            [4232, 8329],
            [4248, 8320],
            [4269, 8323],
            [4262, 8305],
            [4261, 8236],
            [4248, 8228],
            [4238, 8208],
            [4247, 8183],
            [4258, 8178],
            [4266, 8157],
            [4289, 8140],
            [4305, 8072],
            [4298, 8068],
            [4316, 8031],
            [4315, 7999],
            [4321, 7984],
            [4314, 7963],
            [4319, 7933],
            [4305, 7919],
            [4324, 7892],
            [4326, 7872],
            [4338, 7858],
            [4348, 7861],
            [4375, 7851],
            [4389, 7822],
            [4246, 7724],
            [4192, 7671],
            [4142, 7659],
            [4114, 7653],
            [4105, 7659],
            [4109, 7683],
            [4066, 7700],
            [4042, 7719],
            [4042, 7732],
            [3851, 7877],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'PE',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.7,
        'hc-middle-y': 0.71,
        'hc-key': 'pe',
        'hc-a2': 'PE',
        name: 'Peru',
        labelrank: '2',
        'country-abbrev': 'Peru',
        subregion: 'South America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'PER',
        'iso-a2': 'PE',
        'woe-id': '23424919',
        continent: 'South America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1747, 6368],
            [1728, 6373],
            [1728, 6356],
            [1758, 6342],
            [1760, 6343],
            [1763, 6342],
            [1760, 6332],
            [1762, 6330],
            [1744, 6303],
            [1750, 6294],
            [1739, 6286],
            [1738, 6267],
            [1724, 6264],
            [1690, 6287],
            [1684, 6302],
            [1654, 6323],
            [1609, 6342],
            [1557, 6374],
            [1531, 6401],
            [1517, 6422],
            [1518, 6449],
            [1483, 6495],
            [1481, 6513],
            [1465, 6526],
            [1464, 6539],
            [1450, 6561],
            [1433, 6604],
            [1415, 6640],
            [1399, 6659],
            [1381, 6694],
            [1342, 6720],
            [1350, 6736],
            [1338, 6752],
            [1335, 6789],
            [1364, 6820],
            [1370, 6802],
            [1359, 6794],
            [1364, 6780],
            [1372, 6787],
            [1393, 6778],
            [1408, 6760],
            [1420, 6777],
            [1429, 6819],
            [1445, 6835],
            [1483, 6851],
            [1503, 6867],
            [1519, 6889],
            [1529, 6926],
            [1517, 6942],
            [1528, 6942],
            [1544, 6940],
            [1557, 6926],
            [1562, 6910],
            [1583, 6900],
            [1587, 6884],
            [1598, 6880],
            [1598, 6864],
            [1607, 6856],
            [1625, 6855],
            [1646, 6867],
            [1656, 6858],
            [1673, 6864],
            [1702, 6845],
            [1680, 6806],
            [1694, 6804],
            [1706, 6789],
            [1679, 6792],
            [1673, 6783],
            [1642, 6778],
            [1610, 6755],
            [1601, 6720],
            [1605, 6708],
            [1584, 6690],
            [1587, 6674],
            [1577, 6665],
            [1587, 6656],
            [1594, 6635],
            [1614, 6608],
            [1606, 6596],
            [1636, 6591],
            [1641, 6574],
            [1674, 6576],
            [1695, 6595],
            [1692, 6580],
            [1694, 6536],
            [1729, 6539],
            [1761, 6481],
            [1752, 6466],
            [1751, 6437],
            [1760, 6418],
            [1745, 6388],
            [1754, 6379],
            [1747, 6368],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'AO',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.5,
        'hc-middle-y': 0.64,
        'hc-key': 'ao',
        'hc-a2': 'AO',
        name: 'Angola',
        labelrank: '3',
        'country-abbrev': 'Ang.',
        subregion: 'Middle Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'AGO',
        'iso-a2': 'AO',
        'woe-id': '23424745',
        continent: 'Africa',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [4406, 6732],
              [4407, 6743],
              [4399, 6759],
              [4424, 6783],
              [4434, 6774],
              [4414, 6758],
              [4416, 6733],
              [4406, 6732],
            ],
          ],
          [
            [
              [4387, 6304],
              [4387, 6358],
              [4395, 6365],
              [4405, 6397],
              [4413, 6446],
              [4435, 6477],
              [4451, 6490],
              [4456, 6507],
              [4456, 6549],
              [4437, 6586],
              [4431, 6608],
              [4443, 6620],
              [4444, 6636],
              [4426, 6676],
              [4426, 6689],
              [4408, 6719],
              [4438, 6728],
              [4541, 6728],
              [4550, 6726],
              [4562, 6675],
              [4582, 6645],
              [4601, 6649],
              [4640, 6648],
              [4645, 6686],
              [4681, 6689],
              [4678, 6675],
              [4720, 6675],
              [4718, 6648],
              [4724, 6631],
              [4719, 6596],
              [4731, 6577],
              [4735, 6546],
              [4732, 6527],
              [4742, 6535],
              [4758, 6533],
              [4789, 6542],
              [4788, 6462],
              [4722, 6462],
              [4720, 6344],
              [4723, 6331],
              [4763, 6289],
              [4698, 6276],
              [4679, 6275],
              [4613, 6285],
              [4604, 6299],
              [4457, 6298],
              [4432, 6315],
              [4413, 6305],
              [4387, 6304],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'MZ',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.61,
        'hc-middle-y': 0.39,
        'hc-key': 'mz',
        'hc-a2': 'MZ',
        name: 'Mozambique',
        labelrank: '3',
        'country-abbrev': 'Moz.',
        subregion: 'Eastern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'MOZ',
        'iso-a2': 'MZ',
        'woe-id': '23424902',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5142, 6443],
            [5139, 6493],
            [5148, 6515],
            [5168, 6514],
            [5176, 6521],
            [5188, 6511],
            [5216, 6516],
            [5230, 6510],
            [5251, 6527],
            [5264, 6521],
            [5314, 6544],
            [5328, 6556],
            [5334, 6543],
            [5326, 6525],
            [5332, 6471],
            [5327, 6439],
            [5335, 6395],
            [5326, 6369],
            [5302, 6335],
            [5276, 6318],
            [5235, 6300],
            [5207, 6281],
            [5178, 6243],
            [5174, 6246],
            [5132, 6207],
            [5124, 6186],
            [5148, 6124],
            [5147, 6093],
            [5138, 6054],
            [5143, 6049],
            [5130, 6030],
            [5084, 6012],
            [5056, 5995],
            [5043, 5980],
            [5053, 5967],
            [5053, 5947],
            [5036, 5946],
            [5028, 5947],
            [5027, 5968],
            [5025, 5980],
            [5030, 6037],
            [5017, 6073],
            [5012, 6112],
            [5050, 6154],
            [5054, 6181],
            [5071, 6200],
            [5064, 6222],
            [5075, 6263],
            [5076, 6325],
            [5042, 6335],
            [5021, 6350],
            [4994, 6351],
            [4994, 6364],
            [4989, 6388],
            [5088, 6425],
            [5101, 6403],
            [5124, 6411],
            [5130, 6377],
            [5118, 6355],
            [5123, 6344],
            [5151, 6309],
            [5146, 6331],
            [5155, 6345],
            [5169, 6349],
            [5173, 6401],
            [5142, 6443],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'CR',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.18,
        'hc-middle-y': 0.13,
        'hc-key': 'cr',
        'hc-a2': 'CR',
        name: 'Costa Rica',
        labelrank: '5',
        'country-abbrev': 'C.R.',
        subregion: 'Central America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'CRI',
        'iso-a2': 'CR',
        'woe-id': '23424791',
        continent: 'North America',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [1268, 7353],
              [1273, 7337],
              [1293, 7307],
              [1300, 7303],
              [1291, 7304],
              [1287, 7284],
              [1294, 7279],
              [1282, 7257],
              [1282, 7257],
              [1279, 7268],
              [1264, 7283],
              [1231, 7306],
              [1230, 7318],
              [1217, 7302],
              [1201, 7315],
              [1194, 7332],
              [1201, 7359],
              [1205, 7364],
              [1227, 7354],
              [1245, 7356],
              [1259, 7345],
              [1268, 7353],
            ],
          ],
          [
            [
              [1287, 7246],
              [1282, 7256],
              [1282, 7257],
              [1282, 7257],
              [1287, 7246],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SV',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.5,
        'hc-middle-y': 0.51,
        'hc-key': 'sv',
        'hc-a2': 'SV',
        name: 'El Salvador',
        labelrank: '6',
        'country-abbrev': 'El. S.',
        subregion: 'Central America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'SLV',
        'iso-a2': 'SV',
        'woe-id': '23424807',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1139, 7446],
            [1135, 7436],
            [1107, 7440],
            [1066, 7458],
            [1066, 7461],
            [1092, 7483],
            [1119, 7467],
            [1144, 7461],
            [1139, 7446],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'GT',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.51,
        'hc-middle-y': 0.47,
        'hc-key': 'gt',
        'hc-a2': 'GT',
        name: 'Guatemala',
        labelrank: '3',
        'country-abbrev': 'Guat.',
        subregion: 'Central America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'GTM',
        'iso-a2': 'GT',
        'woe-id': '23424834',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1113, 7538],
            [1123, 7532],
            [1135, 7532],
            [1102, 7507],
            [1092, 7483],
            [1066, 7461],
            [1066, 7458],
            [1027, 7466],
            [999, 7488],
            [1003, 7515],
            [1022, 7545],
            [1063, 7545],
            [1067, 7556],
            [1037, 7589],
            [1052, 7589],
            [1055, 7610],
            [1114, 7610],
            [1103, 7538],
            [1113, 7538],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'BZ',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.48,
        'hc-middle-y': 0.5,
        'hc-key': 'bz',
        'hc-a2': 'BZ',
        name: 'Belize',
        labelrank: '6',
        'country-abbrev': 'Belize',
        subregion: 'Central America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'BLZ',
        'iso-a2': 'BZ',
        'woe-id': '23424760',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1114, 7610],
            [1123, 7613],
            [1139, 7635],
            [1145, 7635],
            [1151, 7631],
            [1151, 7631],
            [1143, 7605],
            [1140, 7578],
            [1127, 7552],
            [1113, 7538],
            [1103, 7538],
            [1114, 7610],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'VE',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.53,
        'hc-middle-y': 0.37,
        'hc-key': 've',
        'hc-a2': 'VE',
        name: 'Venezuela',
        labelrank: '3',
        'country-abbrev': 'Ven.',
        subregion: 'South America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'VEN',
        'iso-a2': 'VE',
        'woe-id': '23424982',
        continent: 'South America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [2037, 7265],
            [2044, 7255],
            [2020, 7237],
            [2016, 7214],
            [2026, 7212],
            [2012, 7198],
            [1999, 7196],
            [1998, 7177],
            [1990, 7166],
            [2010, 7140],
            [2014, 7131],
            [2000, 7115],
            [1982, 7105],
            [1942, 7096],
            [1941, 7081],
            [1920, 7094],
            [1899, 7092],
            [1897, 7099],
            [1880, 7094],
            [1895, 7080],
            [1899, 7038],
            [1921, 7036],
            [1920, 7026],
            [1898, 7017],
            [1896, 7005],
            [1862, 6988],
            [1848, 6971],
            [1842, 6983],
            [1829, 6974],
            [1805, 6992],
            [1796, 7036],
            [1775, 7054],
            [1793, 7074],
            [1782, 7086],
            [1775, 7115],
            [1777, 7144],
            [1791, 7169],
            [1789, 7177],
            [1725, 7174],
            [1704, 7206],
            [1689, 7210],
            [1669, 7206],
            [1639, 7210],
            [1627, 7225],
            [1632, 7256],
            [1613, 7293],
            [1601, 7288],
            [1615, 7312],
            [1618, 7335],
            [1633, 7360],
            [1652, 7381],
            [1673, 7388],
            [1654, 7379],
            [1652, 7370],
            [1663, 7346],
            [1643, 7312],
            [1661, 7283],
            [1677, 7295],
            [1678, 7309],
            [1663, 7349],
            [1687, 7363],
            [1718, 7375],
            [1707, 7388],
            [1717, 7401],
            [1728, 7373],
            [1753, 7373],
            [1768, 7361],
            [1770, 7343],
            [1781, 7336],
            [1836, 7343],
            [1858, 7326],
            [1884, 7322],
            [1909, 7343],
            [1953, 7347],
            [1977, 7343],
            [1950, 7337],
            [1964, 7308],
            [1967, 7319],
            [1987, 7315],
            [2013, 7293],
            [2003, 7273],
            [2037, 7265],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'GY',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.7,
        'hc-middle-y': 0.27,
        'hc-key': 'gy',
        'hc-a2': 'GY',
        name: 'Guyana',
        labelrank: '4',
        'country-abbrev': 'Guy.',
        subregion: 'South America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'GUY',
        'iso-a2': 'GY',
        'woe-id': '23424836',
        continent: 'South America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [2010, 7140],
            [1990, 7166],
            [1998, 7177],
            [1999, 7196],
            [2012, 7198],
            [2026, 7212],
            [2016, 7214],
            [2020, 7237],
            [2044, 7255],
            [2037, 7265],
            [2067, 7245],
            [2087, 7219],
            [2088, 7206],
            [2101, 7199],
            [2128, 7173],
            [2125, 7151],
            [2123, 7134],
            [2109, 7132],
            [2097, 7102],
            [2110, 7073],
            [2121, 7073],
            [2125, 7051],
            [2140, 7022],
            [2147, 7019],
            [2127, 7022],
            [2112, 7010],
            [2087, 7006],
            [2070, 6991],
            [2040, 7015],
            [2032, 7047],
            [2038, 7081],
            [2049, 7093],
            [2040, 7113],
            [2030, 7114],
            [2035, 7136],
            [2010, 7140],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'HN',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.67,
        'hc-middle-y': 0.14,
        'hc-key': 'hn',
        'hc-a2': 'HN',
        name: 'Honduras',
        labelrank: '5',
        'country-abbrev': 'Hond.',
        subregion: 'Central America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'HND',
        'iso-a2': 'HN',
        'woe-id': '23424841',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1092, 7483],
            [1102, 7507],
            [1135, 7532],
            [1152, 7539],
            [1177, 7533],
            [1196, 7534],
            [1211, 7542],
            [1224, 7537],
            [1241, 7542],
            [1263, 7535],
            [1278, 7512],
            [1298, 7505],
            [1252, 7491],
            [1235, 7495],
            [1229, 7480],
            [1209, 7466],
            [1198, 7469],
            [1176, 7459],
            [1175, 7441],
            [1154, 7430],
            [1149, 7441],
            [1139, 7446],
            [1144, 7461],
            [1119, 7467],
            [1092, 7483],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NI',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.76,
        'hc-middle-y': 0.48,
        'hc-key': 'ni',
        'hc-a2': 'NI',
        name: 'Nicaragua',
        labelrank: '5',
        'country-abbrev': 'Nic.',
        subregion: 'Central America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'NIC',
        'iso-a2': 'NI',
        'woe-id': '23424915',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1201, 7359],
            [1177, 7384],
            [1170, 7401],
            [1143, 7426],
            [1154, 7430],
            [1175, 7441],
            [1176, 7459],
            [1198, 7469],
            [1209, 7466],
            [1229, 7480],
            [1235, 7495],
            [1252, 7491],
            [1298, 7505],
            [1294, 7481],
            [1278, 7446],
            [1270, 7379],
            [1262, 7371],
            [1268, 7353],
            [1259, 7345],
            [1245, 7356],
            [1227, 7354],
            [1205, 7364],
            [1201, 7359],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'MW',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.27,
        'hc-middle-y': 0.35,
        'hc-key': 'mw',
        'hc-a2': 'MW',
        name: 'Malawi',
        labelrank: '6',
        'country-abbrev': 'Mal.',
        subregion: 'Eastern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'MWI',
        'iso-a2': 'MW',
        'woe-id': '23424889',
        continent: 'Africa',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [5147, 6521],
              [5146, 6522],
              [5146, 6522],
              [5147, 6521],
            ],
          ],
          [
            [
              [5141, 6527],
              [5141, 6527],
              [5140, 6528],
              [5141, 6527],
              [5141, 6527],
            ],
          ],
          [
            [
              [5128, 6585],
              [5125, 6589],
              [5125, 6589],
              [5128, 6585],
            ],
          ],
          [
            [
              [5122, 6592],
              [5121, 6592],
              [5121, 6592],
              [5122, 6592],
            ],
          ],
          [
            [
              [5116, 6585],
              [5127, 6558],
              [5124, 6552],
              [5127, 6512],
              [5118, 6487],
              [5125, 6467],
              [5125, 6449],
              [5154, 6410],
              [5142, 6443],
              [5173, 6401],
              [5169, 6349],
              [5155, 6345],
              [5146, 6331],
              [5151, 6309],
              [5123, 6344],
              [5118, 6355],
              [5130, 6377],
              [5124, 6411],
              [5101, 6403],
              [5088, 6425],
              [5075, 6436],
              [5084, 6477],
              [5094, 6480],
              [5093, 6542],
              [5107, 6553],
              [5097, 6578],
              [5083, 6596],
              [5099, 6589],
              [5116, 6585],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'TM',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.4,
        'hc-middle-y': 0.41,
        'hc-key': 'tm',
        'hc-a2': 'TM',
        name: 'Turkmenistan',
        labelrank: '4',
        'country-abbrev': 'Turkm.',
        subregion: 'Central Asia',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'TKM',
        'iso-a2': 'TM',
        'woe-id': '23424972',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5717, 8506],
            [5730, 8492],
            [5743, 8497],
            [5732, 8514],
            [5740, 8526],
            [5756, 8519],
            [5746, 8533],
            [5754, 8537],
            [5785, 8519],
            [5798, 8519],
            [5813, 8486],
            [5852, 8478],
            [5855, 8483],
            [5874, 8472],
            [5898, 8436],
            [5965, 8400],
            [6011, 8372],
            [6042, 8364],
            [6047, 8339],
            [6022, 8347],
            [6017, 8335],
            [6003, 8334],
            [5994, 8298],
            [5962, 8282],
            [5957, 8266],
            [5935, 8255],
            [5924, 8266],
            [5900, 8273],
            [5890, 8309],
            [5863, 8312],
            [5850, 8326],
            [5807, 8352],
            [5761, 8362],
            [5754, 8373],
            [5730, 8373],
            [5728, 8367],
            [5702, 8367],
            [5686, 8354],
            [5686, 8345],
            [5660, 8338],
            [5652, 8365],
            [5650, 8398],
            [5622, 8421],
            [5637, 8421],
            [5629, 8437],
            [5608, 8438],
            [5600, 8445],
            [5601, 8471],
            [5628, 8458],
            [5645, 8462],
            [5654, 8476],
            [5631, 8490],
            [5621, 8511],
            [5599, 8512],
            [5591, 8500],
            [5594, 8486],
            [5580, 8499],
            [5593, 8513],
            [5628, 8520],
            [5652, 8506],
            [5677, 8481],
            [5690, 8484],
            [5722, 8481],
            [5717, 8506],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'ZM',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.31,
        'hc-middle-y': 0.68,
        'hc-key': 'zm',
        'hc-a2': 'ZM',
        name: 'Zambia',
        labelrank: '3',
        'country-abbrev': 'Zambia',
        subregion: 'Eastern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'ZMB',
        'iso-a2': 'ZM',
        'woe-id': '23425003',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4939, 6597],
            [4960, 6623],
            [4952, 6631],
            [5007, 6640],
            [5003, 6632],
            [5022, 6619],
            [5027, 6627],
            [5053, 6609],
            [5083, 6596],
            [5097, 6578],
            [5107, 6553],
            [5093, 6542],
            [5094, 6480],
            [5084, 6477],
            [5075, 6436],
            [5088, 6425],
            [4989, 6388],
            [4994, 6364],
            [4976, 6365],
            [4943, 6349],
            [4939, 6331],
            [4929, 6330],
            [4899, 6308],
            [4881, 6278],
            [4870, 6274],
            [4824, 6284],
            [4815, 6293],
            [4791, 6295],
            [4763, 6289],
            [4723, 6331],
            [4720, 6344],
            [4722, 6462],
            [4788, 6462],
            [4789, 6542],
            [4802, 6533],
            [4799, 6523],
            [4833, 6530],
            [4834, 6513],
            [4854, 6503],
            [4877, 6499],
            [4894, 6516],
            [4908, 6489],
            [4930, 6483],
            [4957, 6446],
            [4969, 6454],
            [4977, 6446],
            [4979, 6494],
            [4969, 6483],
            [4953, 6485],
            [4937, 6504],
            [4932, 6520],
            [4942, 6555],
            [4945, 6582],
            [4939, 6597],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NC',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.55,
        'hc-middle-y': 0.64,
        'hc-key': 'nc',
        'hc-a2': 'NC',
        name: 'Northern Cyprus',
        labelrank: '6',
        'country-abbrev': 'N. Cy.',
        subregion: 'Western Asia',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': '-99',
        'iso-a2': 'NC',
        'woe-id': '-90',
        continent: 'Asia',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [5056, 8252],
              [5052, 8251],
              [5049, 8251],
              [5040, 8257],
              [5019, 8257],
              [5019, 8257],
              [5019, 8257],
              [5019, 8257],
              [5019, 8257],
              [5019, 8257],
              [5024, 8265],
              [5040, 8262],
              [5075, 8276],
              [5056, 8261],
              [5059, 8252],
              [5057, 8252],
              [5056, 8252],
            ],
          ],
          [
            [
              [5015, 8256],
              [5016, 8257],
              [5016, 8256],
              [5015, 8256],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'ZA',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.38,
        'hc-middle-y': 0.64,
        'hc-key': 'za',
        'hc-a2': 'ZA',
        name: 'South Africa',
        labelrank: '2',
        'country-abbrev': 'S.Af.',
        subregion: 'Southern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'ZAF',
        'iso-a2': 'ZA',
        'woe-id': '23424942',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5028, 5947],
            [5036, 5946],
            [5053, 5947],
            [5032, 5883],
            [5011, 5868],
            [4991, 5846],
            [4962, 5798],
            [4949, 5781],
            [4928, 5767],
            [4910, 5744],
            [4850, 5698],
            [4831, 5690],
            [4811, 5691],
            [4805, 5680],
            [4784, 5682],
            [4778, 5674],
            [4741, 5681],
            [4733, 5676],
            [4708, 5681],
            [4686, 5668],
            [4643, 5664],
            [4626, 5650],
            [4615, 5652],
            [4592, 5675],
            [4575, 5675],
            [4581, 5686],
            [4563, 5724],
            [4577, 5731],
            [4576, 5766],
            [4550, 5816],
            [4538, 5863],
            [4528, 5882],
            [4541, 5901],
            [4556, 5895],
            [4557, 5877],
            [4581, 5870],
            [4611, 5868],
            [4626, 5884],
            [4639, 5888],
            [4645, 6025],
            [4657, 6014],
            [4670, 5973],
            [4663, 5962],
            [4664, 5945],
            [4695, 5946],
            [4730, 5979],
            [4742, 6004],
            [4755, 6005],
            [4770, 5992],
            [4798, 5985],
            [4823, 5992],
            [4833, 6025],
            [4851, 6029],
            [4865, 6043],
            [4872, 6066],
            [4896, 6082],
            [4912, 6102],
            [4950, 6120],
            [4963, 6122],
            [4980, 6115],
            [5012, 6112],
            [5017, 6073],
            [5030, 6037],
            [5025, 5980],
            [5009, 5988],
            [4988, 5963],
            [4986, 5949],
            [4996, 5934],
            [5022, 5929],
            [5028, 5947],
          ],
          [
            [4859, 5843],
            [4868, 5818],
            [4890, 5805],
            [4901, 5824],
            [4925, 5832],
            [4936, 5854],
            [4913, 5882],
            [4884, 5870],
            [4867, 5846],
            [4859, 5843],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'LT',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.19,
        'hc-middle-y': 0.47,
        'hc-key': 'lt',
        'hc-a2': 'LT',
        name: 'Lithuania',
        labelrank: '5',
        'country-abbrev': 'Lith.',
        subregion: 'Northern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'LTU',
        'iso-a2': 'LT',
        'woe-id': '23424875',
        continent: 'Europe',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [4588, 8988],
              [4582, 9003],
              [4578, 9017],
              [4604, 9029],
              [4672, 9024],
              [4703, 9019],
              [4731, 9003],
              [4725, 8984],
              [4716, 8977],
              [4708, 8954],
              [4681, 8940],
              [4656, 8942],
              [4653, 8949],
              [4634, 8957],
              [4632, 8975],
              [4588, 8988],
            ],
          ],
          [
            [
              [4578, 8989],
              [4582, 8997],
              [4580, 8989],
              [4578, 8989],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'ET',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.43,
        'hc-middle-y': 0.56,
        'hc-key': 'et',
        'hc-a2': 'ET',
        name: 'Ethiopia',
        labelrank: '2',
        'country-abbrev': 'Eth.',
        subregion: 'Eastern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'ETH',
        'iso-a2': 'ET',
        'woe-id': '23424808',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5372, 7367],
            [5368, 7363],
            [5372, 7359],
            [5377, 7354],
            [5409, 7356],
            [5401, 7342],
            [5427, 7297],
            [5448, 7281],
            [5545, 7244],
            [5578, 7244],
            [5529, 7188],
            [5481, 7129],
            [5449, 7131],
            [5422, 7119],
            [5411, 7106],
            [5388, 7102],
            [5381, 7094],
            [5358, 7093],
            [5344, 7106],
            [5315, 7090],
            [5305, 7073],
            [5257, 7081],
            [5215, 7111],
            [5189, 7112],
            [5185, 7118],
            [5181, 7144],
            [5166, 7146],
            [5153, 7165],
            [5145, 7194],
            [5130, 7206],
            [5111, 7232],
            [5089, 7237],
            [5092, 7259],
            [5118, 7260],
            [5123, 7268],
            [5121, 7298],
            [5129, 7327],
            [5127, 7340],
            [5136, 7352],
            [5145, 7346],
            [5156, 7389],
            [5168, 7415],
            [5184, 7419],
            [5196, 7478],
            [5220, 7485],
            [5229, 7472],
            [5239, 7500],
            [5257, 7483],
            [5276, 7492],
            [5311, 7485],
            [5336, 7472],
            [5349, 7453],
            [5369, 7437],
            [5389, 7411],
            [5370, 7376],
            [5372, 7367],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'GH',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.19,
        'hc-middle-y': 0.9,
        'hc-key': 'gh',
        'hc-a2': 'GH',
        name: 'Ghana',
        labelrank: '3',
        'country-abbrev': 'Ghana',
        subregion: 'Western Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'GHA',
        'iso-a2': 'GH',
        'woe-id': '23424824',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4044, 7174],
            [4038, 7164],
            [4013, 7161],
            [3979, 7141],
            [3953, 7133],
            [3936, 7123],
            [3902, 7136],
            [3903, 7137],
            [3907, 7136],
            [3911, 7138],
            [3900, 7180],
            [3899, 7201],
            [3908, 7229],
            [3923, 7252],
            [3917, 7300],
            [3909, 7342],
            [3915, 7355],
            [3986, 7355],
            [3999, 7361],
            [4002, 7342],
            [4017, 7327],
            [4012, 7303],
            [4022, 7296],
            [4017, 7273],
            [4024, 7252],
            [4026, 7219],
            [4022, 7201],
            [4044, 7174],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SI',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.52,
        'hc-middle-y': 0.57,
        'hc-key': 'si',
        'hc-a2': 'SI',
        name: 'Slovenia',
        labelrank: '6',
        'country-abbrev': 'Slo.',
        subregion: 'Southern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'SVN',
        'iso-a2': 'SI',
        'woe-id': '23424945',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4404, 8637],
            [4404, 8639],
            [4408, 8641],
            [4396, 8666],
            [4405, 8675],
            [4430, 8669],
            [4438, 8677],
            [4472, 8681],
            [4474, 8687],
            [4479, 8687],
            [4487, 8674],
            [4463, 8663],
            [4455, 8636],
            [4404, 8637],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'BA',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.82,
        'hc-middle-y': 0.66,
        'hc-key': 'ba',
        'hc-a2': 'BA',
        name: 'Bosnia and Herzegovina',
        labelrank: '5',
        'country-abbrev': 'B.H.',
        subregion: 'Southern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'BIH',
        'iso-a2': 'BA',
        'woe-id': '23424761',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4532, 8540],
            [4529, 8542],
            [4529, 8542],
            [4529, 8547],
            [4485, 8588],
            [4469, 8609],
            [4470, 8626],
            [4487, 8620],
            [4503, 8630],
            [4530, 8622],
            [4555, 8622],
            [4566, 8612],
            [4577, 8611],
            [4572, 8591],
            [4587, 8582],
            [4575, 8579],
            [4584, 8565],
            [4576, 8564],
            [4555, 8544],
            [4556, 8529],
            [4538, 8538],
            [4532, 8540],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'JO',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.13,
        'hc-middle-y': 0.48,
        'hc-key': 'jo',
        'hc-a2': 'JO',
        name: 'Jordan',
        labelrank: '4',
        'country-abbrev': 'Jord.',
        subregion: 'Western Asia',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'JOR',
        'iso-a2': 'JO',
        'woe-id': '23424860',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5120, 8104],
            [5122, 8108],
            [5118, 8109],
            [5118, 8110],
            [5119, 8113],
            [5123, 8113],
            [5121, 8129],
            [5118, 8162],
            [5123, 8165],
            [5158, 8149],
            [5215, 8189],
            [5228, 8156],
            [5232, 8142],
            [5227, 8137],
            [5166, 8119],
            [5202, 8082],
            [5188, 8063],
            [5165, 8058],
            [5146, 8033],
            [5111, 8039],
            [5112, 8046],
            [5110, 8047],
            [5113, 8079],
            [5120, 8104],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SY',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.29,
        'hc-middle-y': 0.53,
        'hc-key': 'sy',
        'hc-a2': 'SY',
        name: 'Syria',
        labelrank: '3',
        'country-abbrev': 'Syria',
        subregion: 'Western Asia',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'SYR',
        'iso-a2': 'SY',
        'woe-id': '23424956',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5215, 8189],
            [5158, 8149],
            [5123, 8165],
            [5127, 8173],
            [5123, 8190],
            [5128, 8205],
            [5144, 8220],
            [5135, 8235],
            [5122, 8237],
            [5117, 8265],
            [5114, 8284],
            [5122, 8281],
            [5132, 8319],
            [5158, 8312],
            [5181, 8322],
            [5195, 8315],
            [5229, 8316],
            [5262, 8330],
            [5280, 8328],
            [5301, 8338],
            [5307, 8330],
            [5294, 8311],
            [5280, 8307],
            [5278, 8290],
            [5284, 8274],
            [5284, 8242],
            [5270, 8225],
            [5215, 8189],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'MC',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.5,
        'hc-middle-y': 0.67,
        'hc-key': 'mc',
        'hc-a2': 'MC',
        name: 'Monaco',
        labelrank: '6',
        'country-abbrev': 'Mco.',
        subregion: 'Western Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'MCO',
        'iso-a2': 'MC',
        'woe-id': '23424892',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4226, 8571],
            [4225, 8570],
            [4224, 8570],
            [4225, 8572],
            [4226, 8571],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'AL',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.69,
        'hc-middle-y': 0.9,
        'hc-key': 'al',
        'hc-a2': 'AL',
        name: 'Albania',
        labelrank: '6',
        'country-abbrev': 'Alb.',
        subregion: 'Southern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'ALB',
        'iso-a2': 'AL',
        'woe-id': '23424742',
        continent: 'Europe',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [4637, 8468],
              [4637, 8468],
              [4637, 8469],
              [4637, 8468],
            ],
          ],
          [
            [
              [4586, 8512],
              [4585, 8517],
              [4586, 8520],
              [4594, 8532],
              [4605, 8528],
              [4619, 8516],
              [4622, 8504],
              [4621, 8484],
              [4627, 8475],
              [4628, 8469],
              [4630, 8469],
              [4634, 8469],
              [4637, 8469],
              [4636, 8468],
              [4638, 8467],
              [4638, 8467],
              [4636, 8464],
              [4638, 8465],
              [4637, 8463],
              [4640, 8461],
              [4639, 8460],
              [4640, 8461],
              [4631, 8439],
              [4612, 8427],
              [4595, 8443],
              [4588, 8459],
              [4593, 8502],
              [4586, 8503],
              [4585, 8507],
              [4586, 8512],
            ],
          ],
          [
            [
              [4585, 8519],
              [4585, 8518],
              [4585, 8518],
              [4585, 8519],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'UY',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.89,
        'hc-middle-y': 0.86,
        'hc-key': 'uy',
        'hc-a2': 'UY',
        name: 'Uruguay',
        labelrank: '4',
        'country-abbrev': 'Ury.',
        subregion: 'South America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'URY',
        'iso-a2': 'UY',
        'woe-id': '23424979',
        continent: 'South America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [2341, 5731],
            [2329, 5714],
            [2335, 5697],
            [2336, 5694],
            [2341, 5690],
            [2334, 5666],
            [2302, 5645],
            [2286, 5651],
            [2263, 5645],
            [2229, 5664],
            [2207, 5663],
            [2187, 5683],
            [2182, 5712],
            [2190, 5716],
            [2182, 5738],
            [2179, 5759],
            [2187, 5822],
            [2211, 5825],
            [2233, 5808],
            [2242, 5789],
            [2254, 5798],
            [2267, 5783],
            [2289, 5775],
            [2324, 5742],
            [2341, 5731],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'CNM',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.34,
        'hc-middle-y': 0.05,
        'hc-key': 'cnm',
        'hc-a2': 'CN',
        name: 'Cyprus No Mans Area',
        labelrank: '9',
        'country-abbrev': null,
        subregion: 'Western Asia',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': '-99',
        'iso-a2': null,
        'woe-id': '-99',
        continent: 'Asia',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [5059, 8252],
              [5060, 8252],
              [5059, 8251],
              [5056, 8252],
              [5056, 8252],
              [5057, 8252],
              [5059, 8252],
            ],
          ],
          [
            [
              [5015, 8256],
              [5015, 8256],
              [5016, 8256],
              [5016, 8257],
              [5017, 8257],
              [5016, 8256],
              [5015, 8256],
            ],
          ],
          [
            [
              [5019, 8257],
              [5018, 8257],
              [5019, 8257],
              [5019, 8257],
              [5019, 8257],
              [5019, 8257],
            ],
          ],
          [
            [
              [5049, 8251],
              [5050, 8250],
              [5050, 8249],
              [5040, 8256],
              [5019, 8257],
              [5019, 8257],
              [5040, 8257],
              [5049, 8251],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'MN',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.49,
        'hc-middle-y': 0.51,
        'hc-key': 'mn',
        'hc-a2': 'MN',
        name: 'Mongolia',
        labelrank: '3',
        'country-abbrev': 'Mong.',
        subregion: 'Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'MNG',
        'iso-a2': 'MN',
        'woe-id': '23424887',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [7410, 8720],
            [7419, 8724],
            [7412, 8728],
            [7436, 8727],
            [7484, 8700],
            [7499, 8688],
            [7499, 8677],
            [7455, 8682],
            [7436, 8669],
            [7415, 8667],
            [7415, 8645],
            [7405, 8636],
            [7374, 8633],
            [7369, 8615],
            [7359, 8607],
            [7327, 8613],
            [7318, 8622],
            [7300, 8620],
            [7301, 8596],
            [7330, 8569],
            [7308, 8555],
            [7302, 8536],
            [7281, 8525],
            [7242, 8525],
            [7202, 8519],
            [7165, 8499],
            [7145, 8496],
            [7142, 8504],
            [7120, 8500],
            [7097, 8509],
            [7062, 8515],
            [7045, 8527],
            [6994, 8533],
            [6979, 8529],
            [6907, 8537],
            [6884, 8534],
            [6861, 8553],
            [6829, 8591],
            [6819, 8590],
            [6779, 8605],
            [6751, 8620],
            [6702, 8622],
            [6681, 8626],
            [6669, 8637],
            [6671, 8656],
            [6664, 8676],
            [6625, 8716],
            [6596, 8729],
            [6582, 8728],
            [6542, 8749],
            [6526, 8771],
            [6532, 8781],
            [6552, 8781],
            [6571, 8791],
            [6565, 8798],
            [6606, 8818],
            [6625, 8832],
            [6637, 8825],
            [6685, 8821],
            [6705, 8802],
            [6734, 8797],
            [6742, 8802],
            [6789, 8791],
            [6804, 8803],
            [6801, 8820],
            [6777, 8837],
            [6774, 8854],
            [6784, 8878],
            [6824, 8863],
            [6839, 8863],
            [6895, 8848],
            [6912, 8823],
            [6962, 8806],
            [7002, 8818],
            [7043, 8813],
            [7066, 8801],
            [7088, 8799],
            [7093, 8789],
            [7118, 8777],
            [7135, 8777],
            [7185, 8770],
            [7198, 8778],
            [7242, 8786],
            [7241, 8794],
            [7261, 8811],
            [7302, 8797],
            [7322, 8802],
            [7340, 8795],
            [7345, 8733],
            [7364, 8718],
            [7389, 8724],
            [7410, 8720],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'RW',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.48,
        'hc-middle-y': 0.54,
        'hc-key': 'rw',
        'hc-a2': 'RW',
        name: 'Rwanda',
        labelrank: '3',
        'country-abbrev': 'Rwa.',
        subregion: 'Eastern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'RWA',
        'iso-a2': 'RW',
        'woe-id': '23424937',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5007, 6907],
            [5019, 6887],
            [5019, 6859],
            [5010, 6857],
            [4989, 6860],
            [4988, 6847],
            [4970, 6841],
            [4959, 6845],
            [4955, 6848],
            [4954, 6854],
            [4970, 6870],
            [4966, 6884],
            [4970, 6890],
            [4978, 6895],
            [4990, 6892],
            [5007, 6907],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'BO',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.49,
        'hc-middle-y': 0.57,
        'hc-key': 'bo',
        'hc-a2': 'BO',
        name: 'Bolivia',
        labelrank: '3',
        'country-abbrev': 'Bolivia',
        subregion: 'South America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'BOL',
        'iso-a2': 'BO',
        'woe-id': '23424762',
        continent: 'South America',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [1758, 6342],
              [1757, 6349],
              [1763, 6342],
              [1760, 6343],
              [1758, 6342],
            ],
          ],
          [
            [
              [1750, 6294],
              [1744, 6303],
              [1762, 6330],
              [1776, 6338],
              [1768, 6352],
              [1747, 6368],
              [1754, 6379],
              [1745, 6388],
              [1760, 6418],
              [1751, 6437],
              [1752, 6466],
              [1761, 6481],
              [1729, 6539],
              [1771, 6538],
              [1789, 6548],
              [1823, 6577],
              [1861, 6586],
              [1868, 6566],
              [1863, 6557],
              [1866, 6531],
              [1881, 6500],
              [1901, 6482],
              [1925, 6482],
              [1945, 6475],
              [1956, 6462],
              [1975, 6458],
              [1987, 6442],
              [2013, 6445],
              [2032, 6433],
              [2042, 6384],
              [2032, 6384],
              [2044, 6370],
              [2049, 6341],
              [2105, 6338],
              [2110, 6303],
              [2130, 6293],
              [2140, 6269],
              [2135, 6237],
              [2126, 6212],
              [2135, 6202],
              [2126, 6195],
              [2125, 6208],
              [2093, 6228],
              [2064, 6228],
              [2008, 6215],
              [1995, 6181],
              [1996, 6162],
              [1989, 6118],
              [1982, 6127],
              [1946, 6127],
              [1937, 6095],
              [1926, 6119],
              [1889, 6123],
              [1871, 6135],
              [1845, 6097],
              [1822, 6097],
              [1806, 6154],
              [1785, 6186],
              [1784, 6211],
              [1791, 6223],
              [1772, 6241],
              [1764, 6271],
              [1750, 6294],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'CM',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.49,
        'hc-middle-y': 0.74,
        'hc-key': 'cm',
        'hc-a2': 'CM',
        name: 'Cameroon',
        labelrank: '3',
        'country-abbrev': 'Cam.',
        subregion: 'Middle Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'CMR',
        'iso-a2': 'CM',
        'woe-id': '23424785',
        continent: 'Africa',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [4442, 7027],
              [4440, 7031],
              [4378, 7032],
              [4377, 7027],
              [4333, 7027],
              [4327, 7034],
              [4332, 7061],
              [4321, 7091],
              [4300, 7099],
              [4297, 7117],
              [4287, 7126],
              [4294, 7139],
              [4295, 7164],
              [4338, 7207],
              [4352, 7212],
              [4376, 7186],
              [4394, 7212],
              [4405, 7257],
              [4424, 7274],
              [4426, 7296],
              [4437, 7302],
              [4439, 7322],
              [4462, 7366],
              [4482, 7374],
              [4484, 7400],
              [4468, 7407],
              [4464, 7433],
              [4472, 7433],
              [4471, 7426],
              [4478, 7430],
              [4489, 7417],
              [4500, 7376],
              [4498, 7348],
              [4518, 7318],
              [4469, 7318],
              [4462, 7305],
              [4475, 7288],
              [4503, 7262],
              [4513, 7227],
              [4504, 7216],
              [4488, 7179],
              [4477, 7171],
              [4485, 7160],
              [4482, 7142],
              [4488, 7118],
              [4498, 7111],
              [4504, 7086],
              [4534, 7052],
              [4538, 7030],
              [4536, 7011],
              [4485, 7028],
              [4442, 7027],
            ],
          ],
          [
            [
              [4474, 7433],
              [4474, 7433],
              [4473, 7433],
              [4474, 7433],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'CG',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.15,
        'hc-middle-y': 0.85,
        'hc-key': 'cg',
        'hc-a2': 'CG',
        name: 'Republic of Congo',
        labelrank: '4',
        'country-abbrev': 'Rep. Congo',
        subregion: 'Middle Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'COG',
        'iso-a2': 'CG',
        'woe-id': '23424779',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4434, 6774],
            [4424, 6783],
            [4399, 6759],
            [4393, 6776],
            [4370, 6800],
            [4382, 6816],
            [4394, 6808],
            [4398, 6823],
            [4389, 6828],
            [4385, 6860],
            [4415, 6860],
            [4414, 6876],
            [4426, 6875],
            [4433, 6859],
            [4447, 6855],
            [4457, 6868],
            [4468, 6853],
            [4479, 6876],
            [4482, 6924],
            [4460, 6939],
            [4461, 6954],
            [4481, 6980],
            [4474, 6996],
            [4459, 7000],
            [4441, 6992],
            [4437, 7006],
            [4442, 7027],
            [4485, 7028],
            [4536, 7011],
            [4538, 7030],
            [4547, 7052],
            [4549, 7075],
            [4579, 7084],
            [4591, 7078],
            [4612, 7082],
            [4617, 7076],
            [4617, 7063],
            [4599, 7027],
            [4599, 7004],
            [4593, 6984],
            [4595, 6960],
            [4589, 6927],
            [4574, 6909],
            [4559, 6899],
            [4539, 6867],
            [4538, 6823],
            [4528, 6801],
            [4515, 6795],
            [4492, 6767],
            [4478, 6764],
            [4478, 6787],
            [4445, 6764],
            [4434, 6774],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'EH',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.33,
        'hc-middle-y': 0.82,
        'hc-key': 'eh',
        'hc-a2': 'EH',
        name: 'Western Sahara',
        labelrank: '7',
        'country-abbrev': 'W. Sah.',
        subregion: 'Northern Africa',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'ESH',
        'iso-a2': 'EH',
        'woe-id': '23424990',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3455, 7720],
            [3453, 7723],
            [3457, 7744],
            [3497, 7747],
            [3527, 7745],
            [3547, 7777],
            [3555, 7818],
            [3563, 7832],
            [3578, 7839],
            [3586, 7855],
            [3607, 7871],
            [3621, 7916],
            [3631, 7918],
            [3643, 7938],
            [3642, 7948],
            [3657, 7952],
            [3695, 7947],
            [3705, 7955],
            [3725, 7956],
            [3729, 7977],
            [3729, 7963],
            [3727, 7915],
            [3621, 7914],
            [3619, 7820],
            [3587, 7804],
            [3584, 7784],
            [3585, 7741],
            [3458, 7741],
            [3455, 7720],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'RS',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.44,
        'hc-middle-y': 0.52,
        'hc-key': 'rs',
        'hc-a2': 'RS',
        name: 'Republic of Serbia',
        labelrank: '5',
        'country-abbrev': 'Serb.',
        subregion: 'Southern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'SRB',
        'iso-a2': 'RS',
        'woe-id': '-90',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4566, 8612],
            [4566, 8624],
            [4559, 8653],
            [4577, 8662],
            [4598, 8660],
            [4615, 8647],
            [4615, 8637],
            [4638, 8625],
            [4635, 8612],
            [4659, 8598],
            [4667, 8607],
            [4677, 8589],
            [4668, 8573],
            [4690, 8552],
            [4675, 8538],
            [4674, 8520],
            [4661, 8520],
            [4651, 8517],
            [4655, 8533],
            [4643, 8535],
            [4623, 8554],
            [4612, 8538],
            [4589, 8551],
            [4576, 8564],
            [4584, 8565],
            [4575, 8579],
            [4587, 8582],
            [4572, 8591],
            [4577, 8611],
            [4566, 8612],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'ME',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.42,
        'hc-middle-y': 0.47,
        'hc-key': 'me',
        'hc-a2': 'ME',
        name: 'Montenegro',
        labelrank: '6',
        'country-abbrev': 'Mont.',
        subregion: 'Southern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'MNE',
        'iso-a2': 'ME',
        'woe-id': '20069817',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4576, 8564],
            [4589, 8551],
            [4612, 8538],
            [4603, 8534],
            [4605, 8528],
            [4594, 8532],
            [4586, 8520],
            [4585, 8519],
            [4585, 8518],
            [4578, 8518],
            [4586, 8512],
            [4585, 8507],
            [4586, 8503],
            [4567, 8518],
            [4558, 8523],
            [4556, 8526],
            [4556, 8529],
            [4555, 8544],
            [4576, 8564],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'BJ',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.28,
        'hc-middle-y': 0.93,
        'hc-key': 'bj',
        'hc-a2': 'BJ',
        name: 'Benin',
        labelrank: '5',
        'country-abbrev': 'Benin',
        subregion: 'Western Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'BEN',
        'iso-a2': 'BJ',
        'woe-id': '23424764',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4094, 7184],
            [4067, 7180],
            [4058, 7178],
            [4057, 7283],
            [4048, 7301],
            [4048, 7319],
            [4030, 7332],
            [4034, 7356],
            [4052, 7374],
            [4071, 7372],
            [4083, 7389],
            [4082, 7402],
            [4098, 7408],
            [4122, 7382],
            [4118, 7372],
            [4130, 7341],
            [4120, 7313],
            [4108, 7299],
            [4106, 7285],
            [4096, 7284],
            [4092, 7240],
            [4096, 7209],
            [4094, 7184],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.38,
        'hc-middle-y': 0.37,
        'hc-key': 'ng',
        'hc-a2': 'NG',
        name: 'Nigeria',
        labelrank: '2',
        'country-abbrev': 'Nigeria',
        subregion: 'Western Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'NGA',
        'iso-a2': 'NG',
        'woe-id': '23424908',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4094, 7184],
            [4096, 7209],
            [4092, 7240],
            [4096, 7284],
            [4106, 7285],
            [4108, 7299],
            [4120, 7313],
            [4130, 7341],
            [4118, 7372],
            [4122, 7382],
            [4124, 7413],
            [4138, 7430],
            [4140, 7448],
            [4162, 7459],
            [4185, 7463],
            [4213, 7454],
            [4231, 7430],
            [4260, 7443],
            [4288, 7428],
            [4320, 7424],
            [4335, 7440],
            [4378, 7444],
            [4412, 7433],
            [4440, 7457],
            [4449, 7457],
            [4464, 7433],
            [4468, 7407],
            [4484, 7400],
            [4482, 7374],
            [4462, 7366],
            [4439, 7322],
            [4437, 7302],
            [4426, 7296],
            [4424, 7274],
            [4405, 7257],
            [4394, 7212],
            [4376, 7186],
            [4352, 7212],
            [4338, 7207],
            [4295, 7164],
            [4294, 7139],
            [4287, 7126],
            [4275, 7131],
            [4278, 7116],
            [4244, 7118],
            [4241, 7110],
            [4208, 7106],
            [4189, 7119],
            [4178, 7149],
            [4165, 7170],
            [4150, 7183],
            [4132, 7186],
            [4094, 7184],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'TG',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.84,
        'hc-middle-y': 0.98,
        'hc-key': 'tg',
        'hc-a2': 'TG',
        name: 'Togo',
        labelrank: '6',
        'country-abbrev': 'Togo',
        subregion: 'Western Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'TGO',
        'iso-a2': 'TG',
        'woe-id': '23424965',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4058, 7178],
            [4052, 7177],
            [4044, 7174],
            [4022, 7201],
            [4026, 7219],
            [4024, 7252],
            [4017, 7273],
            [4022, 7296],
            [4012, 7303],
            [4017, 7327],
            [4002, 7342],
            [3999, 7361],
            [4021, 7356],
            [4034, 7356],
            [4030, 7332],
            [4048, 7319],
            [4048, 7301],
            [4057, 7283],
            [4058, 7178],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'LA',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.59,
        'hc-middle-y': 0.45,
        'hc-key': 'la',
        'hc-a2': 'LA',
        name: 'Laos',
        labelrank: '4',
        'country-abbrev': 'Laos',
        subregion: 'South-Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'LAO',
        'iso-a2': 'LA',
        'woe-id': '23424872',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [7237, 7703],
            [7239, 7718],
            [7249, 7721],
            [7252, 7740],
            [7264, 7749],
            [7270, 7735],
            [7284, 7733],
            [7282, 7759],
            [7272, 7775],
            [7290, 7780],
            [7323, 7750],
            [7321, 7740],
            [7332, 7723],
            [7351, 7716],
            [7361, 7727],
            [7381, 7715],
            [7374, 7708],
            [7396, 7694],
            [7387, 7677],
            [7367, 7679],
            [7364, 7665],
            [7395, 7646],
            [7434, 7605],
            [7464, 7579],
            [7497, 7539],
            [7490, 7534],
            [7510, 7515],
            [7508, 7494],
            [7486, 7479],
            [7475, 7490],
            [7459, 7481],
            [7458, 7465],
            [7433, 7481],
            [7440, 7484],
            [7444, 7505],
            [7441, 7532],
            [7409, 7562],
            [7406, 7593],
            [7375, 7629],
            [7354, 7633],
            [7342, 7617],
            [7330, 7616],
            [7313, 7625],
            [7286, 7597],
            [7278, 7602],
            [7284, 7619],
            [7278, 7633],
            [7284, 7656],
            [7279, 7674],
            [7254, 7673],
            [7253, 7694],
            [7237, 7703],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'AF',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.43,
        'hc-middle-y': 0.52,
        'hc-key': 'af',
        'hc-a2': 'AF',
        name: 'Afghanistan',
        labelrank: '3',
        'country-abbrev': 'Afg.',
        subregion: 'Southern Asia',
        'region-wb': 'South Asia',
        'iso-a3': 'AFG',
        'iso-a2': 'AF',
        'woe-id': '23424739',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [6305, 8334],
            [6291, 8330],
            [6297, 8326],
            [6276, 8321],
            [6238, 8319],
            [6202, 8289],
            [6220, 8271],
            [6225, 8257],
            [6210, 8230],
            [6217, 8214],
            [6201, 8210],
            [6184, 8214],
            [6199, 8187],
            [6178, 8178],
            [6173, 8153],
            [6179, 8135],
            [6166, 8123],
            [6144, 8131],
            [6123, 8108],
            [6110, 8112],
            [6094, 8098],
            [6096, 8057],
            [6062, 8046],
            [6044, 8048],
            [6033, 8041],
            [6015, 8045],
            [5982, 8042],
            [5927, 8058],
            [5951, 8095],
            [5944, 8114],
            [5916, 8119],
            [5911, 8147],
            [5897, 8177],
            [5902, 8196],
            [5891, 8199],
            [5887, 8216],
            [5898, 8224],
            [5900, 8273],
            [5924, 8266],
            [5935, 8255],
            [5957, 8266],
            [5962, 8282],
            [5994, 8298],
            [6003, 8334],
            [6017, 8335],
            [6022, 8347],
            [6047, 8339],
            [6071, 8333],
            [6087, 8333],
            [6097, 8323],
            [6114, 8336],
            [6133, 8329],
            [6137, 8348],
            [6156, 8346],
            [6153, 8361],
            [6163, 8376],
            [6186, 8374],
            [6187, 8361],
            [6198, 8360],
            [6201, 8328],
            [6217, 8314],
            [6239, 8327],
            [6254, 8343],
            [6269, 8334],
            [6287, 8341],
            [6305, 8334],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'UA',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.33,
        'hc-middle-y': 0.29,
        'hc-key': 'ua',
        'hc-a2': 'UA',
        name: 'Ukraine',
        labelrank: '3',
        'country-abbrev': 'Ukr.',
        subregion: 'Eastern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'UKR',
        'iso-a2': 'UA',
        'woe-id': '23424976',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4644, 8743],
            [4648, 8753],
            [4653, 8767],
            [4662, 8765],
            [4653, 8784],
            [4665, 8800],
            [4691, 8821],
            [4690, 8832],
            [4671, 8856],
            [4692, 8869],
            [4730, 8870],
            [4774, 8858],
            [4802, 8860],
            [4834, 8850],
            [4866, 8857],
            [4874, 8875],
            [4898, 8877],
            [4913, 8884],
            [4953, 8886],
            [4975, 8864],
            [4972, 8846],
            [4998, 8845],
            [5022, 8814],
            [5049, 8809],
            [5070, 8816],
            [5091, 8797],
            [5094, 8803],
            [5125, 8796],
            [5152, 8783],
            [5145, 8766],
            [5160, 8737],
            [5157, 8722],
            [5130, 8723],
            [5118, 8714],
            [5117, 8696],
            [5053, 8679],
            [5024, 8662],
            [5049, 8630],
            [5081, 8635],
            [5079, 8623],
            [5055, 8624],
            [5038, 8610],
            [5023, 8607],
            [5010, 8594],
            [4995, 8603],
            [4994, 8621],
            [4973, 8632],
            [4970, 8642],
            [4995, 8653],
            [4934, 8664],
            [4949, 8673],
            [4936, 8679],
            [4914, 8679],
            [4880, 8642],
            [4878, 8627],
            [4867, 8635],
            [4853, 8628],
            [4834, 8636],
            [4853, 8656],
            [4851, 8672],
            [4884, 8669],
            [4877, 8685],
            [4866, 8690],
            [4864, 8704],
            [4850, 8711],
            [4852, 8724],
            [4806, 8745],
            [4774, 8738],
            [4762, 8728],
            [4736, 8725],
            [4667, 8727],
            [4659, 8732],
            [4644, 8743],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SK',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.78,
        'hc-middle-y': 0.28,
        'hc-key': 'sk',
        'hc-a2': 'SK',
        name: 'Slovakia',
        labelrank: '6',
        'country-abbrev': 'Svk.',
        subregion: 'Eastern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'SVK',
        'iso-a2': 'SK',
        'woe-id': '23424877',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4653, 8767],
            [4648, 8753],
            [4644, 8743],
            [4623, 8749],
            [4596, 8748],
            [4581, 8733],
            [4550, 8730],
            [4550, 8722],
            [4522, 8719],
            [4501, 8729],
            [4491, 8742],
            [4493, 8750],
            [4525, 8768],
            [4544, 8783],
            [4561, 8787],
            [4581, 8771],
            [4587, 8779],
            [4605, 8775],
            [4631, 8779],
            [4653, 8767],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'JK',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.22,
        'hc-middle-y': 0.49,
        'hc-key': 'jk',
        'hc-a2': 'JK',
        name: 'Siachen Glacier',
        labelrank: '5',
        'country-abbrev': 'Siachen',
        subregion: 'Southern Asia',
        'region-wb': 'South Asia',
        'iso-a3': '-99',
        'iso-a2': 'JK',
        'woe-id': '23424928',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [6413, 8268],
            [6393, 8254],
            [6379, 8274],
            [6400, 8268],
            [6413, 8268],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'PK',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.53,
        'hc-middle-y': 0.57,
        'hc-key': 'pk',
        'hc-a2': 'PK',
        name: 'Pakistan',
        labelrank: '2',
        'country-abbrev': 'Pak.',
        subregion: 'Southern Asia',
        'region-wb': 'South Asia',
        'iso-a3': 'PAK',
        'iso-a2': 'PK',
        'woe-id': '23424922',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [6379, 8274],
            [6393, 8254],
            [6384, 8240],
            [6359, 8231],
            [6313, 8241],
            [6298, 8226],
            [6307, 8213],
            [6316, 8181],
            [6330, 8166],
            [6340, 8169],
            [6345, 8155],
            [6365, 8143],
            [6344, 8127],
            [6350, 8105],
            [6334, 8077],
            [6339, 8071],
            [6322, 8061],
            [6314, 8027],
            [6298, 8018],
            [6288, 7988],
            [6257, 7978],
            [6243, 7991],
            [6220, 7959],
            [6219, 7945],
            [6242, 7934],
            [6242, 7914],
            [6263, 7902],
            [6281, 7866],
            [6273, 7849],
            [6266, 7856],
            [6248, 7846],
            [6212, 7849],
            [6209, 7839],
            [6193, 7834],
            [6178, 7832],
            [6165, 7843],
            [6156, 7866],
            [6140, 7871],
            [6139, 7886],
            [6123, 7895],
            [6069, 7888],
            [6043, 7892],
            [6036, 7885],
            [6003, 7887],
            [5980, 7879],
            [5975, 7885],
            [5979, 7924],
            [5992, 7933],
            [6017, 7938],
            [6021, 7956],
            [6002, 7962],
            [5997, 7998],
            [5968, 8009],
            [5927, 8058],
            [5982, 8042],
            [6015, 8045],
            [6033, 8041],
            [6044, 8048],
            [6062, 8046],
            [6096, 8057],
            [6094, 8098],
            [6110, 8112],
            [6123, 8108],
            [6144, 8131],
            [6166, 8123],
            [6179, 8135],
            [6173, 8153],
            [6178, 8178],
            [6199, 8187],
            [6184, 8214],
            [6201, 8210],
            [6217, 8214],
            [6210, 8230],
            [6225, 8257],
            [6220, 8271],
            [6202, 8289],
            [6238, 8319],
            [6276, 8321],
            [6297, 8326],
            [6315, 8325],
            [6347, 8305],
            [6359, 8280],
            [6379, 8274],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'BG',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.75,
        'hc-middle-y': 0.51,
        'hc-key': 'bg',
        'hc-a2': 'BG',
        name: 'Bulgaria',
        labelrank: '4',
        'country-abbrev': 'Bulg.',
        subregion: 'Eastern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'BGR',
        'iso-a2': 'BG',
        'woe-id': '23424771',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4854, 8571],
            [4843, 8559],
            [4832, 8525],
            [4845, 8507],
            [4816, 8511],
            [4796, 8498],
            [4791, 8485],
            [4765, 8481],
            [4742, 8492],
            [4695, 8484],
            [4696, 8499],
            [4674, 8520],
            [4675, 8538],
            [4690, 8552],
            [4668, 8573],
            [4677, 8589],
            [4697, 8576],
            [4758, 8568],
            [4780, 8581],
            [4806, 8587],
            [4854, 8571],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'LI',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.58,
        'hc-middle-y': 0.51,
        'hc-key': 'li',
        'hc-a2': 'LI',
        name: 'Liechtenstein',
        labelrank: '6',
        'country-abbrev': 'Liech.',
        subregion: 'Western Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'LIE',
        'iso-a2': 'LI',
        'woe-id': '23424879',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4282, 8702],
            [4285, 8696],
            [4284, 8694],
            [4281, 8694],
            [4282, 8702],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'AT',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.51,
        'hc-middle-y': 0.6,
        'hc-key': 'at',
        'hc-a2': 'AT',
        name: 'Austria',
        labelrank: '4',
        'country-abbrev': 'Aust.',
        subregion: 'Western Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'AUT',
        'iso-a2': 'AT',
        'woe-id': '23424750',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4284, 8694],
            [4285, 8696],
            [4282, 8702],
            [4285, 8707],
            [4282, 8711],
            [4286, 8710],
            [4287, 8712],
            [4300, 8702],
            [4307, 8713],
            [4324, 8706],
            [4342, 8713],
            [4375, 8716],
            [4373, 8733],
            [4400, 8747],
            [4403, 8756],
            [4428, 8749],
            [4435, 8764],
            [4493, 8750],
            [4491, 8742],
            [4501, 8729],
            [4500, 8718],
            [4485, 8719],
            [4483, 8693],
            [4474, 8687],
            [4472, 8681],
            [4438, 8677],
            [4430, 8669],
            [4405, 8675],
            [4367, 8681],
            [4358, 8695],
            [4310, 8687],
            [4300, 8686],
            [4284, 8694],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SZ',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.53,
        'hc-middle-y': 0.48,
        'hc-key': 'sz',
        'hc-a2': 'SZ',
        name: 'Swaziland',
        labelrank: '4',
        'country-abbrev': 'Swz.',
        subregion: 'Southern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'SWZ',
        'iso-a2': 'SZ',
        'woe-id': '23424993',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5025, 5980],
            [5027, 5968],
            [5028, 5947],
            [5022, 5929],
            [4996, 5934],
            [4986, 5949],
            [4988, 5963],
            [5009, 5988],
            [5025, 5980],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'HU',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.27,
        'hc-middle-y': 0.59,
        'hc-key': 'hu',
        'hc-a2': 'HU',
        name: 'Hungary',
        labelrank: '5',
        'country-abbrev': 'Hun.',
        subregion: 'Eastern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'HUN',
        'iso-a2': 'HU',
        'woe-id': '23424844',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4559, 8653],
            [4545, 8646],
            [4513, 8654],
            [4487, 8674],
            [4479, 8687],
            [4474, 8687],
            [4483, 8693],
            [4485, 8719],
            [4500, 8718],
            [4501, 8729],
            [4522, 8719],
            [4550, 8722],
            [4550, 8730],
            [4581, 8733],
            [4596, 8748],
            [4623, 8749],
            [4644, 8743],
            [4659, 8732],
            [4667, 8727],
            [4643, 8710],
            [4623, 8666],
            [4598, 8660],
            [4577, 8662],
            [4559, 8653],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NE',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.59,
        'hc-middle-y': 0.45,
        'hc-key': 'ne',
        'hc-a2': 'NE',
        name: 'Niger',
        labelrank: '3',
        'country-abbrev': 'Niger',
        subregion: 'Western Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'NER',
        'iso-a2': 'NE',
        'woe-id': '23424906',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4122, 7382],
            [4098, 7408],
            [4082, 7402],
            [4083, 7389],
            [4072, 7406],
            [4077, 7415],
            [4056, 7417],
            [4037, 7432],
            [4034, 7453],
            [4025, 7456],
            [4010, 7488],
            [4012, 7502],
            [4036, 7504],
            [4048, 7516],
            [4119, 7518],
            [4130, 7530],
            [4141, 7558],
            [4142, 7579],
            [4142, 7659],
            [4192, 7671],
            [4246, 7724],
            [4389, 7822],
            [4438, 7810],
            [4462, 7789],
            [4486, 7803],
            [4494, 7747],
            [4521, 7704],
            [4513, 7688],
            [4507, 7576],
            [4472, 7533],
            [4443, 7482],
            [4449, 7457],
            [4440, 7457],
            [4412, 7433],
            [4378, 7444],
            [4335, 7440],
            [4320, 7424],
            [4288, 7428],
            [4260, 7443],
            [4231, 7430],
            [4213, 7454],
            [4185, 7463],
            [4162, 7459],
            [4140, 7448],
            [4138, 7430],
            [4124, 7413],
            [4122, 7382],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'LU',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.48,
        'hc-middle-y': 0.6,
        'hc-key': 'lu',
        'hc-a2': 'LU',
        name: 'Luxembourg',
        labelrank: '6',
        'country-abbrev': 'Lux.',
        subregion: 'Western Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'LUX',
        'iso-a2': 'LU',
        'woe-id': '23424881',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4187, 8781],
            [4176, 8781],
            [4171, 8784],
            [4168, 8797],
            [4179, 8805],
            [4191, 8794],
            [4187, 8781],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'AD',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.58,
        'hc-middle-y': 0.28,
        'hc-key': 'ad',
        'hc-a2': 'AD',
        name: 'Andorra',
        labelrank: '6',
        'country-abbrev': 'And.',
        subregion: 'Southern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'AND',
        'iso-a2': 'AD',
        'woe-id': '23424744',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4048, 8530],
            [4056, 8530],
            [4056, 8526],
            [4050, 8524],
            [4048, 8530],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'CI',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.53,
        'hc-middle-y': 0.32,
        'hc-key': 'ci',
        'hc-a2': 'CI',
        name: 'Ivory Coast',
        labelrank: '3',
        'country-abbrev': 'I.C.',
        subregion: 'Western Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'CIV',
        'iso-a2': 'CI',
        'woe-id': '23424854',
        continent: 'Africa',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [3902, 7136],
              [3897, 7137],
              [3903, 7137],
              [3902, 7136],
            ],
          ],
          [
            [
              [3757, 7108],
              [3756, 7135],
              [3760, 7164],
              [3747, 7177],
              [3722, 7188],
              [3732, 7212],
              [3727, 7228],
              [3735, 7227],
              [3740, 7250],
              [3736, 7263],
              [3754, 7258],
              [3744, 7273],
              [3747, 7297],
              [3740, 7297],
              [3737, 7317],
              [3743, 7325],
              [3754, 7335],
              [3777, 7325],
              [3800, 7346],
              [3801, 7328],
              [3824, 7335],
              [3837, 7330],
              [3852, 7307],
              [3885, 7317],
              [3900, 7316],
              [3917, 7300],
              [3923, 7252],
              [3908, 7229],
              [3899, 7201],
              [3900, 7180],
              [3911, 7138],
              [3874, 7141],
              [3813, 7134],
              [3757, 7108],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'LR',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.9,
        'hc-middle-y': 0.71,
        'hc-key': 'lr',
        'hc-a2': 'LR',
        name: 'Liberia',
        labelrank: '4',
        'country-abbrev': 'Liberia',
        subregion: 'Western Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'LBR',
        'iso-a2': 'LR',
        'woe-id': '23424876',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3727, 7228],
            [3732, 7212],
            [3722, 7188],
            [3747, 7177],
            [3760, 7164],
            [3756, 7135],
            [3757, 7108],
            [3734, 7117],
            [3700, 7138],
            [3666, 7175],
            [3632, 7196],
            [3628, 7204],
            [3657, 7236],
            [3668, 7262],
            [3693, 7257],
            [3705, 7214],
            [3720, 7233],
            [3727, 7228],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SL',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.49,
        'hc-middle-y': 0.47,
        'hc-key': 'sl',
        'hc-a2': 'SL',
        name: 'Sierra Leone',
        labelrank: '4',
        'country-abbrev': 'S.L.',
        subregion: 'Western Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'SLE',
        'iso-a2': 'SL',
        'woe-id': '23424946',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3668, 7262],
            [3657, 7236],
            [3628, 7204],
            [3580, 7228],
            [3593, 7231],
            [3573, 7251],
            [3569, 7283],
            [3589, 7297],
            [3595, 7313],
            [3637, 7319],
            [3655, 7293],
            [3661, 7269],
            [3653, 7255],
            [3668, 7262],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'BN',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.48,
        'hc-middle-y': 0.36,
        'hc-key': 'bn',
        'hc-a2': 'BN',
        name: 'Brunei',
        labelrank: '6',
        'country-abbrev': 'Brunei',
        subregion: 'South-Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'BRN',
        'iso-a2': 'BN',
        'woe-id': '23424773',
        continent: 'Asia',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [7784, 7126],
              [7787, 7127],
              [7787, 7129],
              [7795, 7107],
              [7784, 7126],
            ],
          ],
          [
            [
              [7750, 7118],
              [7768, 7121],
              [7782, 7128],
              [7771, 7096],
              [7750, 7118],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'BE',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.51,
        'hc-middle-y': 0.36,
        'hc-key': 'be',
        'hc-a2': 'BE',
        name: 'Belgium',
        labelrank: '2',
        'country-abbrev': 'Belg.',
        subregion: 'Western Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'BEL',
        'iso-a2': 'BE',
        'woe-id': '23424757',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4179, 8805],
            [4168, 8797],
            [4171, 8784],
            [4161, 8783],
            [4142, 8800],
            [4123, 8800],
            [4125, 8810],
            [4109, 8813],
            [4076, 8840],
            [4093, 8849],
            [4100, 8851],
            [4113, 8844],
            [4124, 8850],
            [4126, 8848],
            [4125, 8850],
            [4146, 8854],
            [4170, 8843],
            [4175, 8828],
            [4186, 8812],
            [4179, 8805],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'IQ',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.39,
        'hc-middle-y': 0.57,
        'hc-key': 'iq',
        'hc-a2': 'IQ',
        name: 'Iraq',
        labelrank: '3',
        'country-abbrev': 'Iraq',
        subregion: 'Western Asia',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'IRQ',
        'iso-a2': 'IQ',
        'woe-id': '23424855',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5538, 8062],
            [5524, 8065],
            [5519, 8063],
            [5493, 8062],
            [5478, 8030],
            [5420, 8034],
            [5329, 8104],
            [5273, 8135],
            [5232, 8142],
            [5228, 8156],
            [5215, 8189],
            [5270, 8225],
            [5284, 8242],
            [5284, 8274],
            [5278, 8290],
            [5280, 8307],
            [5294, 8311],
            [5307, 8330],
            [5316, 8339],
            [5364, 8334],
            [5365, 8325],
            [5381, 8331],
            [5404, 8287],
            [5437, 8280],
            [5427, 8268],
            [5428, 8253],
            [5416, 8229],
            [5418, 8211],
            [5436, 8198],
            [5451, 8173],
            [5490, 8152],
            [5506, 8129],
            [5505, 8100],
            [5516, 8100],
            [5519, 8081],
            [5538, 8062],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'GE',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.28,
        'hc-middle-y': 0.45,
        'hc-key': 'ge',
        'hc-a2': 'GE',
        name: 'Georgia',
        labelrank: '5',
        'country-abbrev': 'Geo.',
        subregion: 'Western Asia',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'GEO',
        'iso-a2': 'GE',
        'woe-id': '23424823',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5360, 8483],
            [5336, 8480],
            [5314, 8476],
            [5292, 8493],
            [5283, 8488],
            [5254, 8491],
            [5259, 8502],
            [5245, 8531],
            [5229, 8544],
            [5195, 8558],
            [5214, 8564],
            [5244, 8552],
            [5281, 8550],
            [5319, 8528],
            [5344, 8535],
            [5373, 8525],
            [5372, 8516],
            [5398, 8504],
            [5393, 8496],
            [5411, 8482],
            [5407, 8474],
            [5366, 8488],
            [5360, 8483],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'GM',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.02,
        'hc-middle-y': 0.61,
        'hc-key': 'gm',
        'hc-a2': 'GM',
        name: 'Gambia',
        labelrank: '6',
        'country-abbrev': 'Gambia',
        subregion: 'Western Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'GMB',
        'iso-a2': 'GM',
        'woe-id': '23424821',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3458, 7433],
            [3456, 7443],
            [3465, 7452],
            [3499, 7452],
            [3520, 7460],
            [3536, 7447],
            [3549, 7452],
            [3553, 7443],
            [3536, 7439],
            [3511, 7452],
            [3489, 7443],
            [3488, 7436],
            [3458, 7433],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'CH',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.49,
        'hc-middle-y': 0.55,
        'hc-key': 'ch',
        'hc-a2': 'CH',
        name: 'Switzerland',
        labelrank: '4',
        'country-abbrev': 'Switz.',
        subregion: 'Western Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'CHE',
        'iso-a2': 'CH',
        'woe-id': '23424957',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4271, 8716],
            [4271, 8716],
            [4272, 8716],
            [4272, 8716],
            [4281, 8710],
            [4282, 8711],
            [4285, 8707],
            [4282, 8702],
            [4281, 8694],
            [4284, 8694],
            [4300, 8686],
            [4310, 8687],
            [4310, 8675],
            [4296, 8669],
            [4276, 8673],
            [4266, 8649],
            [4264, 8658],
            [4241, 8665],
            [4235, 8653],
            [4211, 8653],
            [4203, 8661],
            [4203, 8671],
            [4198, 8675],
            [4191, 8669],
            [4187, 8666],
            [4184, 8677],
            [4210, 8704],
            [4225, 8713],
            [4250, 8713],
            [4254, 8721],
            [4271, 8716],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'TD',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.46,
        'hc-middle-y': 0.68,
        'hc-key': 'td',
        'hc-a2': 'TD',
        name: 'Chad',
        labelrank: '3',
        'country-abbrev': 'Chad',
        subregion: 'Middle Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'TCD',
        'iso-a2': 'TD',
        'woe-id': '23424777',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4478, 7430],
            [4487, 7433],
            [4474, 7433],
            [4473, 7433],
            [4471, 7436],
            [4472, 7433],
            [4464, 7433],
            [4449, 7457],
            [4443, 7482],
            [4472, 7533],
            [4507, 7576],
            [4513, 7688],
            [4521, 7704],
            [4494, 7747],
            [4486, 7803],
            [4518, 7819],
            [4780, 7672],
            [4785, 7532],
            [4756, 7531],
            [4744, 7493],
            [4734, 7488],
            [4740, 7473],
            [4725, 7460],
            [4732, 7443],
            [4717, 7423],
            [4730, 7421],
            [4744, 7396],
            [4742, 7381],
            [4754, 7371],
            [4753, 7353],
            [4739, 7356],
            [4716, 7342],
            [4717, 7334],
            [4674, 7287],
            [4631, 7282],
            [4632, 7269],
            [4614, 7246],
            [4583, 7244],
            [4555, 7228],
            [4548, 7239],
            [4522, 7224],
            [4513, 7227],
            [4503, 7262],
            [4475, 7288],
            [4462, 7305],
            [4469, 7318],
            [4518, 7318],
            [4498, 7348],
            [4500, 7376],
            [4489, 7417],
            [4478, 7430],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'KV',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.5,
        'hc-middle-y': 0.51,
        'hc-key': 'kv',
        'hc-a2': 'KV',
        name: 'Kosovo',
        labelrank: '6',
        'country-abbrev': 'Kos.',
        subregion: 'Southern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': '-99',
        'iso-a2': 'KV',
        'woe-id': '-90',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4622, 8504],
            [4619, 8516],
            [4605, 8528],
            [4603, 8534],
            [4612, 8538],
            [4623, 8554],
            [4643, 8535],
            [4655, 8533],
            [4651, 8517],
            [4637, 8515],
            [4622, 8504],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'LB',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.54,
        'hc-middle-y': 0.55,
        'hc-key': 'lb',
        'hc-a2': 'LB',
        name: 'Lebanon',
        labelrank: '5',
        'country-abbrev': 'Leb.',
        subregion: 'Western Asia',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'LBN',
        'iso-a2': 'LB',
        'woe-id': '23424873',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5102, 8178],
            [5113, 8209],
            [5122, 8237],
            [5135, 8235],
            [5144, 8220],
            [5128, 8205],
            [5123, 8190],
            [5113, 8178],
            [5102, 8178],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SX',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.96,
        'hc-middle-y': 0.19,
        'hc-key': 'sx',
        'hc-a2': 'SX',
        name: 'Somaliland',
        labelrank: '5',
        'country-abbrev': 'Solnd.',
        subregion: 'Eastern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': '-99',
        'iso-a2': 'SX',
        'woe-id': '-99',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5578, 7244],
            [5545, 7244],
            [5448, 7281],
            [5427, 7297],
            [5401, 7342],
            [5409, 7356],
            [5419, 7374],
            [5454, 7336],
            [5477, 7334],
            [5502, 7351],
            [5525, 7345],
            [5555, 7363],
            [5580, 7361],
            [5606, 7365],
            [5608, 7298],
            [5578, 7244],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'DJ',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.57,
        'hc-middle-y': 0.54,
        'hc-key': 'dj',
        'hc-a2': 'DJ',
        name: 'Djibouti',
        labelrank: '5',
        'country-abbrev': 'Dji.',
        subregion: 'Eastern Africa',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'DJI',
        'iso-a2': 'DJ',
        'woe-id': '23424797',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5409, 7356],
            [5377, 7354],
            [5372, 7359],
            [5375, 7364],
            [5372, 7367],
            [5370, 7376],
            [5389, 7411],
            [5399, 7407],
            [5413, 7420],
            [5422, 7393],
            [5396, 7375],
            [5419, 7374],
            [5409, 7356],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'ER',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.31,
        'hc-middle-y': 0.18,
        'hc-key': 'er',
        'hc-a2': 'ER',
        name: 'Eritrea',
        labelrank: '4',
        'country-abbrev': 'Erit.',
        subregion: 'Eastern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'ERI',
        'iso-a2': 'ER',
        'woe-id': '23424806',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5413, 7420],
            [5399, 7407],
            [5389, 7411],
            [5369, 7437],
            [5349, 7453],
            [5336, 7472],
            [5311, 7485],
            [5276, 7492],
            [5257, 7483],
            [5239, 7500],
            [5229, 7472],
            [5220, 7485],
            [5196, 7478],
            [5191, 7510],
            [5206, 7553],
            [5206, 7582],
            [5245, 7599],
            [5256, 7617],
            [5268, 7594],
            [5284, 7538],
            [5297, 7510],
            [5303, 7524],
            [5313, 7504],
            [5328, 7503],
            [5346, 7491],
            [5364, 7465],
            [5385, 7452],
            [5402, 7425],
            [5413, 7420],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'BI',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.56,
        'hc-middle-y': 0.47,
        'hc-key': 'bi',
        'hc-a2': 'BI',
        name: 'Burundi',
        labelrank: '6',
        'country-abbrev': 'Bur.',
        subregion: 'Eastern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'BDI',
        'iso-a2': 'BI',
        'woe-id': '23424774',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4979, 6781],
            [4970, 6802],
            [4965, 6822],
            [4966, 6833],
            [4959, 6845],
            [4970, 6841],
            [4988, 6847],
            [4989, 6860],
            [5010, 6857],
            [5005, 6841],
            [5018, 6825],
            [5005, 6814],
            [4991, 6787],
            [4979, 6781],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SR',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.85,
        'hc-middle-y': 0.21,
        'hc-key': 'sr',
        'hc-a2': 'SR',
        name: 'Suriname',
        labelrank: '4',
        'country-abbrev': 'Sur.',
        subregion: 'South America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'SUR',
        'iso-a2': 'SR',
        'woe-id': '23424913',
        continent: 'South America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [2125, 7151],
            [2135, 7170],
            [2168, 7163],
            [2171, 7169],
            [2216, 7168],
            [2231, 7163],
            [2226, 7146],
            [2215, 7129],
            [2219, 7097],
            [2230, 7075],
            [2224, 7053],
            [2209, 7033],
            [2197, 7041],
            [2173, 7036],
            [2164, 7041],
            [2163, 7015],
            [2147, 7019],
            [2140, 7022],
            [2125, 7051],
            [2121, 7073],
            [2110, 7073],
            [2097, 7102],
            [2109, 7132],
            [2123, 7134],
            [2125, 7151],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'IL',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.55,
        'hc-middle-y': 0.17,
        'hc-key': 'il',
        'hc-a2': 'IL',
        name: 'Israel',
        labelrank: '4',
        'country-abbrev': 'Isr.',
        subregion: 'Western Asia',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'ISR',
        'iso-a2': 'IL',
        'woe-id': '23424852',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5080, 8112],
            [5097, 8148],
            [5102, 8178],
            [5113, 8178],
            [5123, 8190],
            [5127, 8173],
            [5123, 8165],
            [5118, 8162],
            [5121, 8129],
            [5117, 8120],
            [5119, 8113],
            [5118, 8110],
            [5118, 8109],
            [5117, 8107],
            [5120, 8104],
            [5113, 8079],
            [5110, 8047],
            [5109, 8045],
            [5108, 8045],
            [5106, 8054],
            [5080, 8112],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'GW',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.56,
        'hc-middle-y': 0.49,
        'hc-key': 'gw',
        'hc-a2': 'GW',
        name: 'Guinea Bissau',
        labelrank: '6',
        'country-abbrev': 'GnB.',
        subregion: 'Western Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'GNB',
        'iso-a2': 'GW',
        'woe-id': '23424929',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3458, 7406],
            [3493, 7410],
            [3509, 7419],
            [3557, 7418],
            [3557, 7404],
            [3548, 7399],
            [3556, 7382],
            [3524, 7375],
            [3513, 7355],
            [3501, 7369],
            [3480, 7358],
            [3469, 7376],
            [3483, 7379],
            [3472, 7400],
            [3458, 7406],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SN',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.25,
        'hc-middle-y': 0.5,
        'hc-key': 'sn',
        'hc-a2': 'SN',
        name: 'Senegal',
        labelrank: '3',
        'country-abbrev': 'Sen.',
        subregion: 'Western Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'SEN',
        'iso-a2': 'SN',
        'woe-id': '23424943',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3557, 7418],
            [3509, 7419],
            [3493, 7410],
            [3458, 7406],
            [3456, 7424],
            [3458, 7433],
            [3488, 7436],
            [3489, 7443],
            [3511, 7452],
            [3536, 7439],
            [3553, 7443],
            [3549, 7452],
            [3536, 7447],
            [3520, 7460],
            [3499, 7452],
            [3465, 7452],
            [3444, 7493],
            [3467, 7535],
            [3474, 7559],
            [3520, 7566],
            [3539, 7566],
            [3555, 7547],
            [3566, 7548],
            [3574, 7528],
            [3605, 7497],
            [3614, 7474],
            [3610, 7457],
            [3633, 7428],
            [3633, 7408],
            [3601, 7405],
            [3557, 7418],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'GN',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.57,
        'hc-middle-y': 0.38,
        'hc-key': 'gn',
        'hc-a2': 'GN',
        name: 'Guinea',
        labelrank: '3',
        'country-abbrev': 'Gin.',
        subregion: 'Western Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'GIN',
        'iso-a2': 'GN',
        'woe-id': '23424835',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3557, 7418],
            [3601, 7405],
            [3633, 7408],
            [3636, 7393],
            [3644, 7401],
            [3655, 7389],
            [3669, 7401],
            [3687, 7394],
            [3705, 7411],
            [3717, 7390],
            [3716, 7381],
            [3731, 7370],
            [3720, 7356],
            [3733, 7355],
            [3736, 7335],
            [3743, 7325],
            [3737, 7317],
            [3740, 7297],
            [3747, 7297],
            [3744, 7273],
            [3754, 7258],
            [3736, 7263],
            [3740, 7250],
            [3735, 7227],
            [3727, 7228],
            [3720, 7233],
            [3705, 7214],
            [3693, 7257],
            [3668, 7262],
            [3653, 7255],
            [3661, 7269],
            [3655, 7293],
            [3637, 7319],
            [3595, 7313],
            [3589, 7297],
            [3569, 7283],
            [3561, 7310],
            [3525, 7337],
            [3513, 7355],
            [3524, 7375],
            [3556, 7382],
            [3548, 7399],
            [3557, 7404],
            [3557, 7418],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'PL',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.52,
        'hc-middle-y': 0.26,
        'hc-key': 'pl',
        'hc-a2': 'PL',
        name: 'Poland',
        labelrank: '3',
        'country-abbrev': 'Pol.',
        subregion: 'Eastern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'POL',
        'iso-a2': 'PL',
        'woe-id': '23424923',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4546, 8960],
            [4541, 8954],
            [4550, 8959],
            [4632, 8956],
            [4634, 8957],
            [4653, 8949],
            [4656, 8942],
            [4671, 8914],
            [4673, 8897],
            [4655, 8883],
            [4669, 8876],
            [4671, 8856],
            [4690, 8832],
            [4691, 8821],
            [4665, 8800],
            [4653, 8784],
            [4662, 8765],
            [4653, 8767],
            [4631, 8779],
            [4605, 8775],
            [4587, 8779],
            [4581, 8771],
            [4561, 8787],
            [4544, 8783],
            [4535, 8798],
            [4514, 8800],
            [4494, 8815],
            [4481, 8805],
            [4466, 8816],
            [4472, 8822],
            [4425, 8832],
            [4430, 8847],
            [4416, 8866],
            [4415, 8893],
            [4400, 8903],
            [4406, 8918],
            [4401, 8933],
            [4411, 8939],
            [4399, 8940],
            [4398, 8941],
            [4399, 8942],
            [4451, 8954],
            [4462, 8964],
            [4509, 8973],
            [4518, 8959],
            [4546, 8960],
            [4546, 8960],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'MK',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.49,
        'hc-middle-y': 0.47,
        'hc-key': 'mk',
        'hc-a2': 'MK',
        name: 'Macedonia',
        labelrank: '6',
        'country-abbrev': 'Mkd.',
        subregion: 'Southern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'MKD',
        'iso-a2': 'MK',
        'woe-id': '23424890',
        continent: 'Europe',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [4638, 8467],
              [4638, 8467],
              [4638, 8467],
              [4638, 8467],
            ],
          ],
          [
            [
              [4674, 8520],
              [4696, 8499],
              [4695, 8484],
              [4690, 8478],
              [4665, 8476],
              [4642, 8467],
              [4637, 8473],
              [4637, 8468],
              [4637, 8469],
              [4637, 8469],
              [4634, 8469],
              [4630, 8469],
              [4632, 8476],
              [4627, 8475],
              [4621, 8484],
              [4622, 8504],
              [4637, 8515],
              [4651, 8517],
              [4661, 8520],
              [4674, 8520],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'PY',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.41,
        'hc-middle-y': 0.37,
        'hc-key': 'py',
        'hc-a2': 'PY',
        name: 'Paraguay',
        labelrank: '4',
        'country-abbrev': 'Para.',
        subregion: 'South America',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'PRY',
        'iso-a2': 'PY',
        'woe-id': '23424917',
        continent: 'South America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [2265, 6050],
            [2265, 6040],
            [2259, 5999],
            [2260, 5996],
            [2260, 5994],
            [2258, 5954],
            [2240, 5942],
            [2231, 5924],
            [2219, 5930],
            [2186, 5923],
            [2158, 5931],
            [2140, 5929],
            [2151, 5973],
            [2164, 5999],
            [2157, 6009],
            [2122, 6024],
            [2079, 6052],
            [2047, 6060],
            [2014, 6089],
            [2001, 6109],
            [1989, 6118],
            [1996, 6162],
            [1995, 6181],
            [2008, 6215],
            [2064, 6228],
            [2093, 6228],
            [2125, 6208],
            [2126, 6195],
            [2140, 6166],
            [2138, 6124],
            [2182, 6118],
            [2189, 6124],
            [2216, 6103],
            [2227, 6054],
            [2252, 6060],
            [2265, 6050],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'BY',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.5,
        'hc-middle-y': 0.5,
        'hc-key': 'by',
        'hc-a2': 'BY',
        name: 'Belarus',
        labelrank: '4',
        'country-abbrev': 'Bela.',
        subregion: 'Eastern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'BLR',
        'iso-a2': 'BY',
        'woe-id': '23424765',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4671, 8856],
            [4669, 8876],
            [4655, 8883],
            [4673, 8897],
            [4671, 8914],
            [4656, 8942],
            [4681, 8940],
            [4708, 8954],
            [4716, 8977],
            [4725, 8984],
            [4731, 9003],
            [4758, 9007],
            [4771, 9019],
            [4849, 9000],
            [4864, 8966],
            [4886, 8937],
            [4915, 8924],
            [4901, 8911],
            [4877, 8909],
            [4898, 8877],
            [4874, 8875],
            [4866, 8857],
            [4834, 8850],
            [4802, 8860],
            [4774, 8858],
            [4730, 8870],
            [4692, 8869],
            [4671, 8856],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'LV',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.27,
        'hc-middle-y': 0.42,
        'hc-key': 'lv',
        'hc-a2': 'LV',
        name: 'Latvia',
        labelrank: '5',
        'country-abbrev': 'Lat.',
        subregion: 'Northern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'LVA',
        'iso-a2': 'LV',
        'woe-id': '23424874',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4771, 9019],
            [4758, 9007],
            [4731, 9003],
            [4703, 9019],
            [4672, 9024],
            [4604, 9029],
            [4578, 9017],
            [4574, 9044],
            [4589, 9069],
            [4611, 9075],
            [4632, 9053],
            [4645, 9048],
            [4662, 9057],
            [4656, 9079],
            [4681, 9086],
            [4717, 9067],
            [4740, 9067],
            [4755, 9059],
            [4752, 9044],
            [4767, 9033],
            [4771, 9019],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'BF',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.45,
        'hc-middle-y': 0.54,
        'hc-key': 'bf',
        'hc-a2': 'BF',
        name: 'Burkina Faso',
        labelrank: '3',
        'country-abbrev': 'B.F.',
        subregion: 'Western Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'BFA',
        'iso-a2': 'BF',
        'woe-id': '23424978',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4034, 7356],
            [4021, 7356],
            [3999, 7361],
            [3986, 7355],
            [3915, 7355],
            [3909, 7342],
            [3917, 7300],
            [3900, 7316],
            [3885, 7317],
            [3852, 7307],
            [3837, 7330],
            [3824, 7335],
            [3836, 7391],
            [3856, 7399],
            [3867, 7421],
            [3863, 7435],
            [3872, 7445],
            [3887, 7438],
            [3899, 7441],
            [3898, 7457],
            [3910, 7455],
            [3912, 7469],
            [3925, 7478],
            [3936, 7473],
            [3981, 7508],
            [4012, 7502],
            [4010, 7488],
            [4025, 7456],
            [4034, 7453],
            [4037, 7432],
            [4056, 7417],
            [4077, 7415],
            [4072, 7406],
            [4083, 7389],
            [4071, 7372],
            [4052, 7374],
            [4034, 7356],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SS',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.48,
        'hc-middle-y': 0.58,
        'hc-key': 'ss',
        'hc-a2': 'SS',
        name: 'South Sudan',
        labelrank: '3',
        'country-abbrev': 'S. Sud.',
        subregion: 'Eastern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'SSD',
        'iso-a2': 'SS',
        'woe-id': '-99',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5121, 7104],
            [5106, 7086],
            [5089, 7091],
            [5062, 7077],
            [5049, 7088],
            [5029, 7088],
            [5019, 7076],
            [4997, 7094],
            [4984, 7116],
            [4973, 7120],
            [4964, 7108],
            [4950, 7116],
            [4937, 7106],
            [4917, 7118],
            [4906, 7135],
            [4896, 7161],
            [4872, 7173],
            [4871, 7194],
            [4859, 7207],
            [4836, 7220],
            [4819, 7250],
            [4799, 7255],
            [4797, 7270],
            [4810, 7277],
            [4817, 7312],
            [4826, 7329],
            [4851, 7334],
            [4853, 7326],
            [4875, 7301],
            [4919, 7304],
            [4924, 7294],
            [4950, 7294],
            [4987, 7329],
            [5012, 7308],
            [5028, 7311],
            [5050, 7343],
            [5065, 7358],
            [5062, 7382],
            [5053, 7393],
            [5075, 7393],
            [5090, 7401],
            [5087, 7378],
            [5091, 7350],
            [5115, 7325],
            [5115, 7298],
            [5121, 7298],
            [5123, 7268],
            [5118, 7260],
            [5092, 7259],
            [5089, 7237],
            [5111, 7232],
            [5130, 7206],
            [5145, 7194],
            [5153, 7165],
            [5166, 7146],
            [5181, 7144],
            [5185, 7118],
            [5175, 7118],
            [5168, 7134],
            [5134, 7118],
            [5121, 7104],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NA',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.33,
        'hc-middle-y': 0.4,
        'hc-key': 'na',
        'hc-a2': 'NA',
        name: 'Namibia',
        labelrank: '3',
        'country-abbrev': 'Nam.',
        subregion: 'Southern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'NAM',
        'iso-a2': 'NA',
        'woe-id': '23424987',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4763, 6289],
            [4791, 6295],
            [4815, 6293],
            [4824, 6284],
            [4801, 6274],
            [4790, 6276],
            [4769, 6259],
            [4760, 6276],
            [4701, 6265],
            [4684, 6264],
            [4681, 6129],
            [4648, 6127],
            [4645, 6025],
            [4639, 5888],
            [4626, 5884],
            [4611, 5868],
            [4581, 5870],
            [4557, 5877],
            [4556, 5895],
            [4541, 5901],
            [4528, 5882],
            [4503, 5906],
            [4492, 5929],
            [4479, 5987],
            [4478, 6023],
            [4473, 6032],
            [4468, 6117],
            [4454, 6135],
            [4437, 6170],
            [4430, 6196],
            [4403, 6250],
            [4389, 6271],
            [4387, 6304],
            [4413, 6305],
            [4432, 6315],
            [4457, 6298],
            [4604, 6299],
            [4613, 6285],
            [4679, 6275],
            [4698, 6276],
            [4763, 6289],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'RO',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.52,
        'hc-middle-y': 0.6,
        'hc-key': 'ro',
        'hc-a2': 'RO',
        name: 'Romania',
        labelrank: '3',
        'country-abbrev': 'Rom.',
        subregion: 'Eastern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'ROU',
        'iso-a2': 'RO',
        'woe-id': '23424933',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4834, 8636],
            [4853, 8628],
            [4867, 8635],
            [4878, 8627],
            [4879, 8611],
            [4855, 8606],
            [4854, 8571],
            [4806, 8587],
            [4780, 8581],
            [4758, 8568],
            [4697, 8576],
            [4677, 8589],
            [4667, 8607],
            [4659, 8598],
            [4635, 8612],
            [4638, 8625],
            [4615, 8637],
            [4615, 8647],
            [4598, 8660],
            [4623, 8666],
            [4643, 8710],
            [4667, 8727],
            [4736, 8725],
            [4762, 8728],
            [4774, 8738],
            [4785, 8735],
            [4797, 8716],
            [4821, 8693],
            [4829, 8678],
            [4828, 8656],
            [4834, 8636],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'ZW',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.63,
        'hc-middle-y': 0.52,
        'hc-key': 'zw',
        'hc-a2': 'ZW',
        name: 'Zimbabwe',
        labelrank: '3',
        'country-abbrev': 'Zimb.',
        subregion: 'Eastern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'ZWE',
        'iso-a2': 'ZW',
        'woe-id': '23425004',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4824, 6284],
            [4870, 6274],
            [4881, 6278],
            [4918, 6319],
            [4942, 6322],
            [4939, 6331],
            [4943, 6349],
            [4976, 6365],
            [4994, 6364],
            [4994, 6351],
            [5021, 6350],
            [5042, 6335],
            [5076, 6325],
            [5075, 6263],
            [5064, 6222],
            [5071, 6200],
            [5054, 6181],
            [5050, 6154],
            [5012, 6112],
            [4980, 6115],
            [4963, 6122],
            [4950, 6120],
            [4941, 6134],
            [4908, 6143],
            [4897, 6162],
            [4899, 6183],
            [4885, 6183],
            [4884, 6198],
            [4868, 6204],
            [4850, 6220],
            [4845, 6242],
            [4831, 6261],
            [4824, 6284],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'KH',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.25,
        'hc-middle-y': 0.55,
        'hc-key': 'kh',
        'hc-a2': 'KH',
        name: 'Cambodia',
        labelrank: '3',
        'country-abbrev': 'Camb.',
        subregion: 'South-Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'KHM',
        'iso-a2': 'KH',
        'woe-id': '23424776',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [7424, 7334],
            [7392, 7342],
            [7398, 7352],
            [7378, 7354],
            [7370, 7380],
            [7353, 7417],
            [7344, 7452],
            [7352, 7453],
            [7365, 7479],
            [7419, 7484],
            [7433, 7481],
            [7458, 7465],
            [7459, 7481],
            [7475, 7490],
            [7486, 7479],
            [7508, 7494],
            [7504, 7472],
            [7516, 7449],
            [7513, 7431],
            [7517, 7406],
            [7492, 7392],
            [7485, 7381],
            [7471, 7385],
            [7467, 7367],
            [7479, 7347],
            [7464, 7357],
            [7441, 7353],
            [7437, 7339],
            [7424, 7334],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SD',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.5,
        'hc-middle-y': 0.5,
        'hc-key': 'sd',
        'hc-a2': 'SD',
        name: 'Sudan',
        labelrank: '3',
        'country-abbrev': 'Sudan',
        subregion: 'Northern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'SDN',
        'iso-a2': 'SD',
        'woe-id': '-90',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5192, 7765],
            [5193, 7753],
            [5208, 7722],
            [5206, 7692],
            [5213, 7660],
            [5220, 7643],
            [5256, 7617],
            [5245, 7599],
            [5206, 7582],
            [5206, 7553],
            [5191, 7510],
            [5196, 7478],
            [5184, 7419],
            [5168, 7415],
            [5156, 7389],
            [5145, 7346],
            [5136, 7352],
            [5127, 7340],
            [5129, 7327],
            [5121, 7298],
            [5115, 7298],
            [5115, 7325],
            [5091, 7350],
            [5087, 7378],
            [5090, 7401],
            [5075, 7393],
            [5053, 7393],
            [5062, 7382],
            [5065, 7358],
            [5050, 7343],
            [5028, 7311],
            [5012, 7308],
            [4987, 7329],
            [4950, 7294],
            [4924, 7294],
            [4919, 7304],
            [4875, 7301],
            [4853, 7326],
            [4851, 7334],
            [4826, 7329],
            [4817, 7312],
            [4810, 7277],
            [4797, 7270],
            [4775, 7273],
            [4779, 7314],
            [4753, 7353],
            [4754, 7371],
            [4742, 7381],
            [4744, 7396],
            [4730, 7421],
            [4717, 7423],
            [4732, 7443],
            [4725, 7460],
            [4740, 7473],
            [4734, 7488],
            [4744, 7493],
            [4756, 7531],
            [4785, 7532],
            [4780, 7672],
            [4780, 7691],
            [4812, 7691],
            [4809, 7765],
            [5011, 7765],
            [5192, 7765],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'CZ',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.49,
        'hc-middle-y': 0.56,
        'hc-key': 'cz',
        'hc-a2': 'CZ',
        name: 'Czech Republic',
        labelrank: '5',
        'country-abbrev': 'Cz. Rep.',
        subregion: 'Eastern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'CZE',
        'iso-a2': 'CZ',
        'woe-id': '23424810',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4544, 8783],
            [4525, 8768],
            [4493, 8750],
            [4435, 8764],
            [4428, 8749],
            [4403, 8756],
            [4359, 8792],
            [4361, 8815],
            [4412, 8833],
            [4425, 8832],
            [4472, 8822],
            [4466, 8816],
            [4481, 8805],
            [4494, 8815],
            [4514, 8800],
            [4535, 8798],
            [4544, 8783],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'ML',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.61,
        'hc-middle-y': 0.47,
        'hc-key': 'ml',
        'hc-a2': 'ML',
        name: 'Mali',
        labelrank: '3',
        'country-abbrev': 'Mali',
        subregion: 'Western Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'MLI',
        'iso-a2': 'ML',
        'woe-id': '23424891',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3824, 7335],
            [3801, 7328],
            [3800, 7346],
            [3777, 7325],
            [3754, 7335],
            [3743, 7325],
            [3736, 7335],
            [3733, 7355],
            [3720, 7356],
            [3731, 7370],
            [3716, 7381],
            [3717, 7390],
            [3705, 7411],
            [3687, 7394],
            [3669, 7401],
            [3655, 7389],
            [3644, 7401],
            [3636, 7393],
            [3633, 7408],
            [3633, 7428],
            [3610, 7457],
            [3614, 7474],
            [3605, 7497],
            [3620, 7501],
            [3623, 7525],
            [3634, 7527],
            [3649, 7509],
            [3656, 7521],
            [3676, 7519],
            [3701, 7523],
            [3826, 7523],
            [3831, 7554],
            [3822, 7562],
            [3794, 7877],
            [3851, 7877],
            [4042, 7732],
            [4042, 7719],
            [4066, 7700],
            [4109, 7683],
            [4105, 7659],
            [4114, 7653],
            [4142, 7659],
            [4142, 7579],
            [4141, 7558],
            [4130, 7530],
            [4119, 7518],
            [4048, 7516],
            [4036, 7504],
            [4012, 7502],
            [3981, 7508],
            [3936, 7473],
            [3925, 7478],
            [3912, 7469],
            [3910, 7455],
            [3898, 7457],
            [3899, 7441],
            [3887, 7438],
            [3872, 7445],
            [3863, 7435],
            [3867, 7421],
            [3856, 7399],
            [3836, 7391],
            [3824, 7335],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'BT',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.53,
        'hc-middle-y': 0.69,
        'hc-key': 'bt',
        'hc-a2': 'BT',
        name: 'Bhutan',
        labelrank: '5',
        'country-abbrev': 'Bhutan',
        subregion: 'Southern Asia',
        'region-wb': 'South Asia',
        'iso-a3': 'BTN',
        'iso-a2': 'BT',
        'woe-id': '23424770',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [6834, 7964],
            [6849, 7995],
            [6868, 8003],
            [6918, 7980],
            [6931, 7970],
            [6939, 7950],
            [6927, 7945],
            [6868, 7941],
            [6844, 7945],
            [6830, 7958],
            [6834, 7964],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'BW',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.32,
        'hc-middle-y': 0.62,
        'hc-key': 'bw',
        'hc-a2': 'BW',
        name: 'Botswana',
        labelrank: '4',
        'country-abbrev': 'Bwa.',
        subregion: 'Southern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'BWA',
        'iso-a2': 'BW',
        'woe-id': '23424755',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4824, 6284],
            [4831, 6261],
            [4845, 6242],
            [4850, 6220],
            [4868, 6204],
            [4884, 6198],
            [4885, 6183],
            [4899, 6183],
            [4897, 6162],
            [4908, 6143],
            [4941, 6134],
            [4950, 6120],
            [4912, 6102],
            [4896, 6082],
            [4872, 6066],
            [4865, 6043],
            [4851, 6029],
            [4833, 6025],
            [4823, 5992],
            [4798, 5985],
            [4770, 5992],
            [4755, 6005],
            [4742, 6004],
            [4730, 5979],
            [4695, 5946],
            [4664, 5945],
            [4663, 5962],
            [4670, 5973],
            [4657, 6014],
            [4645, 6025],
            [4648, 6127],
            [4681, 6129],
            [4684, 6264],
            [4701, 6265],
            [4760, 6276],
            [4769, 6259],
            [4790, 6276],
            [4801, 6274],
            [4824, 6284],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'MD',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.51,
        'hc-middle-y': 0.39,
        'hc-key': 'md',
        'hc-a2': 'MD',
        name: 'Moldova',
        labelrank: '6',
        'country-abbrev': 'Mda.',
        subregion: 'Eastern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'MDA',
        'iso-a2': 'MD',
        'woe-id': '23424885',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4834, 8636],
            [4828, 8656],
            [4829, 8678],
            [4821, 8693],
            [4797, 8716],
            [4785, 8735],
            [4774, 8738],
            [4806, 8745],
            [4852, 8724],
            [4850, 8711],
            [4864, 8704],
            [4866, 8690],
            [4877, 8685],
            [4884, 8669],
            [4851, 8672],
            [4853, 8656],
            [4834, 8636],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'CF',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.56,
        'hc-middle-y': 0.52,
        'hc-key': 'cf',
        'hc-a2': 'CF',
        name: 'Central African Republic',
        labelrank: '4',
        'country-abbrev': 'C.A.R.',
        subregion: 'Middle Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'CAF',
        'iso-a2': 'CF',
        'woe-id': '23424792',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4617, 7076],
            [4612, 7082],
            [4591, 7078],
            [4579, 7084],
            [4549, 7075],
            [4547, 7052],
            [4538, 7030],
            [4534, 7052],
            [4504, 7086],
            [4498, 7111],
            [4488, 7118],
            [4482, 7142],
            [4485, 7160],
            [4477, 7171],
            [4488, 7179],
            [4504, 7216],
            [4513, 7227],
            [4522, 7224],
            [4548, 7239],
            [4555, 7228],
            [4583, 7244],
            [4614, 7246],
            [4632, 7269],
            [4631, 7282],
            [4674, 7287],
            [4717, 7334],
            [4716, 7342],
            [4739, 7356],
            [4753, 7353],
            [4779, 7314],
            [4775, 7273],
            [4797, 7270],
            [4799, 7255],
            [4819, 7250],
            [4836, 7220],
            [4859, 7207],
            [4871, 7194],
            [4872, 7173],
            [4896, 7161],
            [4906, 7135],
            [4896, 7140],
            [4874, 7135],
            [4845, 7147],
            [4836, 7134],
            [4815, 7130],
            [4810, 7136],
            [4775, 7120],
            [4757, 7126],
            [4745, 7102],
            [4681, 7111],
            [4673, 7124],
            [4653, 7138],
            [4632, 7129],
            [4614, 7108],
            [4617, 7076],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NZ',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.18,
        'hc-middle-y': 0.84,
        'hc-key': 'nz',
        'hc-a2': 'NZ',
        name: 'New Zealand',
        labelrank: '2',
        'country-abbrev': 'N.Z.',
        subregion: 'Australia and New Zealand',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'NZL',
        'iso-a2': 'NZ',
        'woe-id': '23424916',
        continent: 'Oceania',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [9046, 5271],
              [9014, 5248],
              [8958, 5216],
              [8935, 5217],
              [8886, 5196],
              [8906, 5212],
              [8913, 5230],
              [8885, 5229],
              [8889, 5244],
              [8933, 5277],
              [8997, 5311],
              [9011, 5313],
              [9051, 5328],
              [9098, 5350],
              [9128, 5368],
              [9154, 5391],
              [9169, 5397],
              [9199, 5425],
              [9228, 5438],
              [9217, 5410],
              [9249, 5424],
              [9262, 5421],
              [9242, 5405],
              [9235, 5390],
              [9197, 5367],
              [9175, 5350],
              [9150, 5339],
              [9142, 5318],
              [9126, 5322],
              [9078, 5302],
              [9046, 5271],
            ],
          ],
          [
            [
              [9383, 5467],
              [9311, 5416],
              [9272, 5398],
              [9263, 5410],
              [9296, 5433],
              [9313, 5454],
              [9289, 5477],
              [9294, 5484],
              [9329, 5499],
              [9363, 5538],
              [9375, 5581],
              [9388, 5599],
              [9373, 5595],
              [9368, 5635],
              [9376, 5645],
              [9371, 5663],
              [9385, 5666],
              [9378, 5649],
              [9397, 5643],
              [9405, 5621],
              [9394, 5606],
              [9397, 5595],
              [9385, 5574],
              [9399, 5560],
              [9410, 5581],
              [9409, 5597],
              [9418, 5578],
              [9407, 5544],
              [9417, 5534],
              [9437, 5530],
              [9465, 5547],
              [9478, 5540],
              [9449, 5509],
              [9434, 5503],
              [9421, 5488],
              [9408, 5490],
              [9383, 5476],
              [9383, 5467],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'CU',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.66,
        'hc-middle-y': 0.61,
        'hc-key': 'cu',
        'hc-a2': 'CU',
        name: 'Cuba',
        labelrank: '3',
        'country-abbrev': 'Cuba',
        subregion: 'Caribbean',
        'region-wb': 'Latin America & Caribbean',
        'iso-a3': 'CUB',
        'iso-a2': 'CU',
        'woe-id': '23424793',
        continent: 'North America',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1562, 7687],
            [1543, 7691],
            [1494, 7685],
            [1516, 7708],
            [1509, 7718],
            [1473, 7714],
            [1468, 7752],
            [1453, 7749],
            [1431, 7754],
            [1415, 7768],
            [1380, 7768],
            [1363, 7782],
            [1372, 7791],
            [1344, 7792],
            [1329, 7778],
            [1345, 7751],
            [1335, 7745],
            [1320, 7773],
            [1304, 7772],
            [1283, 7758],
            [1289, 7779],
            [1304, 7791],
            [1330, 7803],
            [1370, 7810],
            [1420, 7808],
            [1457, 7789],
            [1455, 7780],
            [1475, 7786],
            [1492, 7780],
            [1506, 7761],
            [1525, 7745],
            [1550, 7732],
            [1567, 7729],
            [1570, 7718],
            [1592, 7714],
            [1606, 7694],
            [1562, 7687],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'VN',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.9,
        'hc-middle-y': 0.82,
        'hc-key': 'vn',
        'hc-a2': 'VN',
        name: 'Vietnam',
        labelrank: '2',
        'country-abbrev': 'Viet.',
        subregion: 'South-Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'VNM',
        'iso-a2': 'VN',
        'woe-id': '23424984',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [7485, 7746],
            [7472, 7729],
            [7451, 7728],
            [7460, 7718],
            [7443, 7711],
            [7447, 7700],
            [7430, 7691],
            [7423, 7654],
            [7443, 7627],
            [7455, 7621],
            [7465, 7597],
            [7512, 7553],
            [7522, 7550],
            [7545, 7519],
            [7558, 7495],
            [7570, 7463],
            [7569, 7445],
            [7579, 7427],
            [7572, 7417],
            [7577, 7392],
            [7570, 7369],
            [7542, 7353],
            [7516, 7333],
            [7502, 7342],
            [7501, 7325],
            [7493, 7302],
            [7463, 7286],
            [7450, 7268],
            [7440, 7279],
            [7440, 7313],
            [7436, 7326],
            [7404, 7333],
            [7424, 7334],
            [7437, 7339],
            [7441, 7353],
            [7464, 7357],
            [7479, 7347],
            [7467, 7367],
            [7471, 7385],
            [7485, 7381],
            [7492, 7392],
            [7517, 7406],
            [7513, 7431],
            [7516, 7449],
            [7504, 7472],
            [7508, 7494],
            [7510, 7515],
            [7490, 7534],
            [7497, 7539],
            [7464, 7579],
            [7434, 7605],
            [7395, 7646],
            [7364, 7665],
            [7367, 7679],
            [7387, 7677],
            [7396, 7694],
            [7374, 7708],
            [7381, 7715],
            [7361, 7727],
            [7351, 7716],
            [7332, 7723],
            [7321, 7740],
            [7323, 7750],
            [7290, 7780],
            [7299, 7794],
            [7319, 7782],
            [7326, 7795],
            [7349, 7784],
            [7387, 7816],
            [7407, 7799],
            [7428, 7800],
            [7441, 7766],
            [7464, 7751],
            [7485, 7746],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'TN',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.39,
        'hc-middle-y': 0.16,
        'hc-key': 'tn',
        'hc-a2': 'TN',
        name: 'Tunisia',
        labelrank: '3',
        'country-abbrev': 'Tun.',
        subregion: 'Northern Africa',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'TUN',
        'iso-a2': 'TN',
        'woe-id': '23424967',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4269, 8323],
            [4304, 8339],
            [4318, 8332],
            [4323, 8316],
            [4345, 8329],
            [4347, 8320],
            [4329, 8300],
            [4333, 8282],
            [4351, 8259],
            [4334, 8233],
            [4320, 8224],
            [4319, 8210],
            [4332, 8199],
            [4350, 8205],
            [4354, 8183],
            [4364, 8182],
            [4367, 8155],
            [4346, 8143],
            [4323, 8117],
            [4328, 8097],
            [4316, 8077],
            [4305, 8072],
            [4289, 8140],
            [4266, 8157],
            [4258, 8178],
            [4247, 8183],
            [4238, 8208],
            [4248, 8228],
            [4261, 8236],
            [4262, 8305],
            [4269, 8323],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'TW',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.5,
        'hc-middle-y': 0.5,
        'hc-key': 'tw',
        'hc-a2': 'TW',
        name: 'Taiwan',
        labelrank: '3',
        'country-abbrev': 'Taiwan',
        subregion: 'Eastern Asia',
        'region-wb': 'East Asia & Pacific',
        'iso-a3': 'TWN',
        'iso-a2': 'TW',
        'woe-id': '23424971',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [7861, 7821],
            [7846, 7825],
            [7862, 7832],
            [7879, 7879],
            [7894, 7887],
            [7906, 7881],
            [7905, 7808],
            [7897, 7790],
            [7896, 7763],
            [7876, 7785],
            [7863, 7806],
            [7861, 7821],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'MG',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.46,
        'hc-middle-y': 0.49,
        'hc-key': 'mg',
        'hc-a2': 'MG',
        name: 'Madagascar',
        labelrank: '3',
        'country-abbrev': 'Mad.',
        subregion: 'Eastern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'MDG',
        'iso-a2': 'MG',
        'woe-id': '23424883',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5620, 6368],
            [5625, 6330],
            [5609, 6303],
            [5611, 6286],
            [5564, 6151],
            [5546, 6109],
            [5531, 6058],
            [5512, 6017],
            [5484, 6008],
            [5459, 5994],
            [5448, 5994],
            [5414, 6015],
            [5406, 6038],
            [5410, 6073],
            [5399, 6096],
            [5396, 6118],
            [5407, 6153],
            [5442, 6202],
            [5443, 6219],
            [5432, 6260],
            [5431, 6296],
            [5448, 6324],
            [5450, 6343],
            [5463, 6342],
            [5477, 6353],
            [5509, 6361],
            [5537, 6381],
            [5551, 6400],
            [5551, 6385],
            [5571, 6427],
            [5568, 6440],
            [5579, 6447],
            [5594, 6446],
            [5604, 6482],
            [5614, 6501],
            [5624, 6476],
            [5635, 6461],
            [5641, 6409],
            [5648, 6371],
            [5638, 6352],
            [5629, 6372],
            [5620, 6368],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'IS',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.5,
        'hc-middle-y': 0.5,
        'hc-key': 'is',
        'hc-a2': 'IS',
        name: 'Iceland',
        labelrank: '3',
        'country-abbrev': 'Iceland',
        subregion: 'Northern Europe',
        'region-wb': 'Europe & Central Asia',
        'iso-a3': 'ISL',
        'iso-a2': 'IS',
        'woe-id': '23424845',
        continent: 'Europe',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3426, 9359],
            [3444, 9354],
            [3436, 9366],
            [3450, 9367],
            [3478, 9352],
            [3469, 9341],
            [3484, 9331],
            [3509, 9357],
            [3518, 9345],
            [3527, 9355],
            [3553, 9358],
            [3570, 9351],
            [3582, 9360],
            [3598, 9358],
            [3607, 9370],
            [3625, 9357],
            [3642, 9354],
            [3638, 9343],
            [3667, 9337],
            [3668, 9325],
            [3639, 9300],
            [3617, 9296],
            [3585, 9282],
            [3555, 9277],
            [3528, 9267],
            [3493, 9272],
            [3485, 9278],
            [3470, 9282],
            [3430, 9281],
            [3432, 9289],
            [3451, 9289],
            [3459, 9300],
            [3443, 9313],
            [3414, 9316],
            [3446, 9322],
            [3458, 9333],
            [3445, 9338],
            [3395, 9336],
            [3426, 9359],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'LK',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.59,
        'hc-middle-y': 0.8,
        'hc-key': 'lk',
        'hc-a2': 'LK',
        name: 'Sri Lanka',
        labelrank: '3',
        'country-abbrev': 'Sri L.',
        subregion: 'Southern Asia',
        'region-wb': 'South Asia',
        'iso-a3': 'LKA',
        'iso-a2': 'LK',
        'woe-id': '23424778',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [6621, 7247],
            [6627, 7296],
            [6637, 7301],
            [6630, 7311],
            [6650, 7295],
            [6672, 7262],
            [6688, 7229],
            [6689, 7193],
            [6676, 7178],
            [6651, 7167],
            [6634, 7175],
            [6626, 7200],
            [6618, 7248],
            [6621, 7247],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'SO',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.43,
        'hc-middle-y': 0.69,
        'hc-key': 'so',
        'hc-a2': 'SO',
        name: 'Somalia',
        labelrank: '6',
        'country-abbrev': 'Som.',
        subregion: 'Eastern Africa',
        'region-wb': 'Sub-Saharan Africa',
        'iso-a3': 'SOM',
        'iso-a2': 'SO',
        'woe-id': '-90',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5606, 7365],
            [5648, 7378],
            [5665, 7393],
            [5682, 7387],
            [5676, 7363],
            [5680, 7340],
            [5672, 7331],
            [5670, 7299],
            [5625, 7208],
            [5615, 7175],
            [5580, 7112],
            [5518, 7037],
            [5470, 7004],
            [5445, 6981],
            [5406, 6935],
            [5371, 6883],
            [5353, 6914],
            [5352, 7051],
            [5381, 7094],
            [5388, 7102],
            [5411, 7106],
            [5422, 7119],
            [5449, 7131],
            [5481, 7129],
            [5529, 7188],
            [5578, 7244],
            [5608, 7298],
            [5606, 7365],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'EG',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.27,
        'hc-middle-y': 0.5,
        'hc-key': 'eg',
        'hc-a2': 'EG',
        name: 'Egypt',
        labelrank: '2',
        'country-abbrev': 'Egypt',
        subregion: 'Northern Africa',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'EGY',
        'iso-a2': 'EG',
        'woe-id': '23424802',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5108, 8045],
            [5094, 7979],
            [5059, 8010],
            [5055, 8028],
            [5040, 8043],
            [5032, 8062],
            [5027, 8049],
            [5038, 8025],
            [5073, 7981],
            [5070, 7976],
            [5088, 7948],
            [5089, 7937],
            [5144, 7839],
            [5144, 7821],
            [5152, 7800],
            [5170, 7789],
            [5192, 7765],
            [5011, 7765],
            [4809, 7765],
            [4803, 7907],
            [4796, 8033],
            [4784, 8070],
            [4792, 8093],
            [4786, 8115],
            [4795, 8125],
            [4864, 8114],
            [4868, 8109],
            [4899, 8104],
            [4919, 8094],
            [4934, 8099],
            [4959, 8119],
            [4997, 8117],
            [5015, 8103],
            [5046, 8110],
            [5064, 8105],
            [5080, 8112],
            [5106, 8054],
            [5108, 8045],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'LY',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.53,
        'hc-middle-y': 0.49,
        'hc-key': 'ly',
        'hc-a2': 'LY',
        name: 'Libya',
        labelrank: '3',
        'country-abbrev': 'Libya',
        subregion: 'Northern Africa',
        'region-wb': 'Middle East & North Africa',
        'iso-a3': 'LBY',
        'iso-a2': 'LY',
        'woe-id': '23424882',
        continent: 'Africa',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4364, 8182],
            [4391, 8169],
            [4422, 8171],
            [4480, 8152],
            [4491, 8125],
            [4509, 8111],
            [4551, 8104],
            [4578, 8092],
            [4606, 8073],
            [4628, 8082],
            [4639, 8109],
            [4630, 8129],
            [4634, 8144],
            [4649, 8158],
            [4681, 8173],
            [4697, 8173],
            [4728, 8161],
            [4728, 8150],
            [4761, 8138],
            [4789, 8137],
            [4795, 8125],
            [4786, 8115],
            [4792, 8093],
            [4784, 8070],
            [4796, 8033],
            [4803, 7907],
            [4809, 7765],
            [4812, 7691],
            [4780, 7691],
            [4780, 7672],
            [4518, 7819],
            [4486, 7803],
            [4462, 7789],
            [4438, 7810],
            [4389, 7822],
            [4375, 7851],
            [4348, 7861],
            [4338, 7858],
            [4326, 7872],
            [4324, 7892],
            [4305, 7919],
            [4319, 7933],
            [4314, 7963],
            [4321, 7984],
            [4315, 7999],
            [4316, 8031],
            [4298, 8068],
            [4305, 8072],
            [4316, 8077],
            [4328, 8097],
            [4323, 8117],
            [4346, 8143],
            [4367, 8155],
            [4364, 8182],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NP',
      properties: {
        'hc-group': 'admin0',
        'hc-middle-x': 0.35,
        'hc-middle-y': 0.42,
        'hc-key': 'np',
        'hc-a2': 'NP',
        name: 'Nepal',
        labelrank: '3',
        'country-abbrev': 'Nepal',
        subregion: 'Southern Asia',
        'region-wb': 'South Asia',
        'iso-a3': 'NPL',
        'iso-a2': 'NP',
        'woe-id': '23424911',
        continent: 'Asia',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [6561, 8071],
            [6572, 8077],
            [6594, 8076],
            [6599, 8066],
            [6635, 8049],
            [6649, 8033],
            [6666, 8036],
            [6690, 8012],
            [6706, 8011],
            [6706, 8000],
            [6725, 8002],
            [6737, 7985],
            [6754, 7993],
            [6775, 7983],
            [6805, 7984],
            [6806, 7956],
            [6815, 7942],
            [6791, 7928],
            [6780, 7936],
            [6771, 7930],
            [6742, 7936],
            [6733, 7946],
            [6723, 7942],
            [6701, 7953],
            [6697, 7964],
            [6679, 7971],
            [6674, 7965],
            [6637, 7970],
            [6607, 7984],
            [6559, 8014],
            [6541, 8020],
            [6545, 8055],
            [6561, 8071],
          ],
        ],
      },
    },
  ],
};
